export default {
  locale: 'nl',
  messages: {
    accountMy: 'Mijn account',
    actions: 'Acties',
    add: 'Toevoegen',
    addressAddNew: 'Nieuw adres toevoegen',
    addressCity: 'Plaats',
    addressCountries: 'Landen',
    addressCountry: 'Land',
    addressDeleteConfirmTitle: 'Een adres verwijderen',
    addressDeleteConfirmMessage: 'Weet u zeker dat u dit adres wilt verwijderen?',
    addressDeleteSuccess: 'Adres succesvol verwijderd!',
    addressEdit: 'Adres bewerken',
    addressFlags: 'Vlaggen',
    addressInvoice: 'Factuuradres',
    addressInvoiceDifferentAsShippingLabel: 'Zijn de factuurgegevens anders dan het bezorgadres?',
    addressInvoiceSelectionTitle: 'Selecteer uw factuuradres',
    addressInvoiceUsedFor: 'Gebruikt voor de factuur',
    addressInvoiceUse: 'Gebruiken voor de factuur',
    addressLabel: 'Naam van het adres (bijv. Thuis, Kantoor)',
    addressLegalInformation: 'Juridische informatie',
    addressMy: 'Mijn adressen',
    addressName: 'Voor- en achternaam ontvanger',
    addressNoItems: 'U heeft nog geen adres opgeslagen!',
    addressPhone: 'Telefoonnummer (nodig voor de bezorging)',
    addressPostalCode: 'Postcode',
    addressRegion: 'Staat / provincie',
    addressShipping: 'Bezorgadres',
    addressShippingSelectionTitle: 'Selecteer uw bezorgadres',
    addressStreet1: 'Straat en huisnummer',
    addressStreetNumberHint: 'Vergeet het huisnummer niet: zonder nummer vindt de vervoerder het adres vaak niet.',
    addressPostalCodeInvalid: 'Deze postcode past niet bij het gekozen land.',
    addressPhoneInvalid: 'Dit nummer lijkt onjuist. De vervoerder gebruikt het om u te bereiken.',
    addressPhoneMobileHint: 'Een mobiel nummer is aan te raden: de vervoerder stuurt het bericht per sms.',
    addressIssueTitle: 'Dit adres moet worden aangevuld voor verzending',
    addressIssueIncomplete: 'Er ontbreken verplichte velden.',
    addressIssuePostalCode: 'Controleer de postcode voor het gekozen land.',
    addressIssuePhone: 'Een bereikbaar telefoonnummer is nodig: de vervoerder belt u of stuurt een bericht.',
    addressIssueRegion: 'Kies de staat of provincie die de vervoerder vraagt.',
    addressIssueTaxId: 'De douane vraagt een fiscaal nummer voor deze bestemming.',
    addressIssueComplete: 'Dit adres aanvullen',
    addressStreet2: 'Toevoeging (appartement, etage, etc.)',
    administrationTitle: 'Administratie',
    affiliationComment: 'Opmerking',
    affiliationCommission: 'Commissie',
    affiliationCommissionMultiplePendingAlert: 'Deze lijst is een schatting: Bestellingen & commissies zijn nog niet definitief verwerkt!',
    affiliationCommissionPendingAlert: 'Deze bestelling wacht op goedkeuring',
    affiliationDeleteConfirmMessage: 'Weet u zeker dat u deze affiliatie wilt verwijderen?',
    affiliationInvoiceTotalTitle: 'Totaal te ontvangen (incl. btw)',
    affiliationKey: 'Affiliate-sleutel',
    affiliationLegalApplyVAT: 'Btw toepassen?',
    affiliationLegalInformations: 'Juridische informatie (facturatie, KvK-nummer...)',
    affiliationMy: 'Mijn partnerschappen',
    affiliationOptionValidityDays: 'Geldigheid affiliate-link (dagen)',
    affiliationSince: 'Lid sinds',
    affiliationViewResultsMy: 'Bekijk affiliate-inkomsten',
    affiliations: 'Partnerschappen',
    alertContactError: 'Uw bericht kon niet worden verzonden! Probeer het opnieuw...',
    alertContactSuccess: 'Goed ontvangen!',
    alertConversationNoExists: 'Deze chat bestaat niet!',
    alertFetchApiError: 'De server is momenteel niet bereikbaar...',
    alertFormRequiredFieldsError: 'Vul alstublieft alle verplichte velden in!',
    alertGenericError: 'Er is een fout opgetreden! Probeer het later nog eens...',
    alertInstitutionAlreadyExists: 'Deze instelling bestaat al!',
    alertJsonParseError: 'De server gaf een ongeldig antwoord...',
    alertOrderValid: 'Uw bestelling is klaar om voorbereid te worden!',
    alertUnauthorized: 'Uw sessie is verlopen! Log alstublieft opnieuw in.',
    alertUserAlreadyExists: 'Er bestaat al een account met dit e-mailadres!',
    alertUserRegisterSuccess: 'Welkom aan boord!',
    app404ErrorText: 'We kunnen niet vinden wat u zoekt! Ga terug naar de startpagina of naar uw account.',
    app404ErrorTitle: 'Verkeerde afslag...',
    appAccessButton: 'Ga naar {app}',
    appAgreementAcceptButton: 'Lees de algemene voorwaarden',
    appAgreementAcceptHelp: 'U kunt de voorwaarden lezen door op deze link te klikken',
    appAgreementAcceptClickHint: 'Klik hier om aan te vinken en te accepteren',
    appAgreementAcceptLabel: 'Ik heb de algemene voorwaarden gelezen en ga akkoord',
    appApplication: 'Applicatie',
    appBackHomeButton: 'Terug naar de startpagina',
    appBackHomeTitle: 'U bent verdwaald...',
    appBugErrorText: 'Er is een probleem opgetreden... ONZE EXCUSES! Klik op de onderstaande link om deze pagina opnieuw te laden...',
    appConditionsAcceptTitle: 'Algemene Gebruiksvoorwaarden',
    appConditionsCheckError: 'Vink het vakje aan om te bevestigen dat u de algemene voorwaarden hebt gelezen!',
    appConditionsCheckLabel: 'Ik heb de algemene gebruiksvoorwaarden gelezen en ga hiermee akkoord',
    appConditionsCheckSuccess: 'Begrepen!',
    appConditionsUpdateDate: 'Bijgewerkt op {date}',
    appConfig: 'Config',
    appConfiguration: 'Configuratie',
    appCookieConsentPrivacyLink: 'Bekijk ons privacybeleid',
    appCookieConsentText: 'Door verder te gaan op deze site, gaat u akkoord met het gebruik van cookies voor de goede werking van de dienst en voor statistische doeleinden. Er worden geen persoonlijke gegevens gedeeld zonder uw voorafgaande toestemming.',
    appCreateIndexButton: 'Database-index aanmaken',
    appDataPrivacyCheckButton: 'Lees ons gegevensbeschermingsbeleid',
    appDatabase: 'Database',
    appErrorAlertText: 'Er is iets onverwachts gebeurd... Geen paniek! Neem contact met ons op en we lossen het zo snel mogelijk voor u op.',
    appErrorAlertTitle: 'Er is een fout opgetreden!',
    appForceUpdateApp: 'App-update forceren',
    appForceUpdateAppWeb: 'Web App-update forceren',
    appHome: 'Home',
    appMaintenanceModeText: 'Even geduld, probeer het zo meteen nog eens...',
    appMaintenanceModeTitle: 'We voeren momenteel onderhoud uit',
    appProcessLaunch: 'Startproces',
    appQuestionLink: 'Heeft u vragen?',
    appRewiewsHeaderText: 'Gemaakt in Frankrijk 🇫🇷 met Liefde ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 Trustpilot reviews',
    appShopOrderHistory: 'Bestelling volgen',
    appStart: 'Maak uw boek',
    appVersion: 'Versie',
    appVersionCurrent: 'Huidige app-versie: {version}',
    appWebsiteAboutUs: 'Ons verhaal',
    appWebsiteBlog: 'Blog',
    appWebsiteBook: 'Het boek',
    appWebsiteConversationAndroid: 'Android SMS afdrukken',
    appWebsiteConversationInstagram: 'Instagram-berichten afdrukken',
    appWebsiteConversationIos: 'iPhone iMessages/SMS afdrukken',
    appWebsiteConversationMessenger: 'Messenger-berichten afdrukken',
    appWebsiteConversationWhatsapp: 'WhatsApp-berichten afdrukken',
    appWebsiteConversations: 'Kies uw platform',
    appWebsiteFaq: 'Veelgestelde Vragen',
    appFooterQuestion: 'Een vraag?',
    appFooterTerms: 'Gebruiksvoorwaarden',
    appWebsitePrices: 'Tarieven',
    appWelcomeTitle: 'Welkom bij {name}',
    apply: 'Toepassen',
    back: 'Terug',
    by: 'door',
    cancel: 'Annuleren',
    cartAddTo: 'In winkelwagen',
    cartAuthInfo: 'Vul uw e-mailadres in om verder te gaan...',
    cartContinuePurchase: 'Verder winkelen',
    cartEmptyError: 'Uw winkelwagen is leeg...',
    cartItemsRemoveAll: 'Alles verwijderen',
    cartMy: 'Mijn winkelwagen',
    cartMyEdit: 'Winkelwagen bewerken',
    cartNextStepButton: 'Naar de volgende stap',
    cartNoItems: 'Er zitten geen artikelen in uw winkelwagen.',
    cartNote: 'Opmerking',
    cartProgression: 'Voortgang winkelwagen',
    cartSalesConditionsAccept: 'Door uw bestelling te bevestigen, gaat u akkoord met onze verkoopvoorwaarden.',
    cartSee: 'Mijn winkelwagen bekijken',
    cartShipping: 'Verzending',
    cartShippingFeeError: 'We kunnen niet naar dit adres bezorgen! Voer een ander adres in.',
    cartStepConfirmationTitle: 'Bevestiging',
    cartStepInvoiceTitle: 'Facturatie',
    cartStepPaymentTitle: 'Betaling',
    cartStepPreviewTitle: 'Winkelwagen',
    cartStepShippingTitle: 'Verzending',
    cartTotalShipping: 'Verzendkosten',
    cartTotalSubTotal: 'Subtotaal',
    cartTotalTax: 'Btw',
    cartTotalTotal: 'Totaal',
    cartValidButton: 'Mijn bestelling bevestigen',
    checkoutEyebrow: 'Uw bestelling',
    checkoutStepUpsellTitle: 'Eén exemplaar, of twee?',
    checkoutStepUpsellTitleGroup: 'Eén exemplaar, twee? Of meer?',
    checkoutStepUpsellHint: 'Houd er een voor uzelf, geef er een cadeau, of allebei.',
    checkoutStepUpsellHintGroup: 'Voor iedereen een: korting vanaf het tweede exemplaar.',
    checkoutStepShippingTitle: 'Waar moeten we uw boek bezorgen?',
    checkoutStepShippingHint: 'We drukken het met zorg en verzenden het wereldwijd.',
    checkoutStepInvoiceTitle: 'Uw gegevens',
    checkoutStepInvoiceHint: 'Voor uw factuur en het volgen van uw bestelling.',
    checkoutStepPaymentTitle: 'Veilig betalen',
    checkoutStepPaymentHint: 'Bankkaart, Apple Pay, Google Pay: versleutelde betaling.',
    checkoutPdfReadyTitle: 'Uw eBook is klaar',
    checkoutPdfReadyHint: 'Geen verzending nodig, rond uw bestelling af.',
    checkoutSummaryEyebrow: 'Overzicht',
    cartReassuranceSecure: 'Veilig betalen',
    cartReassuranceReturn: 'Geld-terug-garantie',
    cartReassuranceSupport: 'Klantenservice',
    checkoutPromoEyebrow: 'Promocode',
    checkoutGiftEyebrow: 'Cadeaukaart',
    checkoutGiftCodeLabel: 'Cadeaucode',
    checkoutGiftCodePlaceholder: 'Voer uw cadeaucode in',
    checkoutGiftCodeHint: 'Cadeaukaart ontvangen? Voer uw code hier in.',
    checkoutGiftToggle: 'Heeft u een cadeaukaart?',
    checkoutAddCopy: 'Nog een exemplaar',
    checkoutSecondCopyKicker: 'Voor uzelf, of om cadeau te doen',
    checkoutSecondCopyKickerGroup: 'Voor ieder een',
    checkoutSecondCopyTitle: 'Het extra exemplaar, voor de halve prijs',
    checkoutSecondCopyTitlePercent: 'Het extra exemplaar',
    checkoutSecondCopyFor: 'dit exemplaar',
    checkoutSecondCopyForGroup: 'de 2e',
    checkoutSecondCopyChip: '2e voor de halve prijs',
    checkoutSecondCopyChipPercent: '2e met −{percent}%',
    checkoutSecondCopySet: 'Alle {count} delen, samen',
    checkoutSecondCopyPerBook: 'elk boek',
    checkoutSecondCopySetPrice: '{price} voor alle {count} delen',
    checkoutExtraBooksChip: 'extra boeken voor de halve prijs',
    checkoutExtraBooksChipPercent: 'extra boeken voor −{percent} %',
    checkoutGroupQtyHint: 'De derde ook: elk extra boek voor −{percent} %.',
    productExtraCopyRate: 'Extra boeken, in % van de prijs van één boek',
    productExtraCopyRateHelp: 'Elk boek na het eerste exemplaar kost dit percentage van de prijs van één boek. Leeg: 50 %. 0: staffelprijzen.',
    checkoutGroupPicksLabel: 'Exemplaren',
    checkoutGroupAddSecond: '2e',
    checkoutGroupAddThird: '3',
    checkoutGroupAddSecondAria: 'Tweede exemplaar voor de halve prijs toevoegen',
    checkoutGroupAddThirdAria: 'Naar drie exemplaren',
    checkoutQtyGroupHint: 'Voor ieder een exemplaar: de korting geldt vanaf het tweede.',
    checkoutQtyPdfSingle: '1 eBook',
    checkoutQtyMoreAriaLabel: 'Ander aantal',
    checkoutQtyVolumeBreakdown: '{copies} exemplaren × {volumes} delen = {total} boeken',
    checkoutOfferBookCount: '{count, plural, one {# boek} other {# boeken}}',
    checkoutUpsellTwoHint: 'Ideaal om cadeau te geven: voeg een tweede exemplaar toe, de korting wordt automatisch toegepast.',
    checkoutEmptyTitle: 'Geen bestelling in behandeling',
    checkoutEmptyHint: 'Ga terug naar uw boek om uw editie te kiezen.',
    checkoutEmptyCta: 'Mijn gesprekken bekijken',
    checkoutBookAsideEyebrow: 'Uw boek',
    checkoutBookAsideEyebrowPlural: 'Uw boeken',
    checkoutBookAsideVolume: 'deel',
    checkoutBookAsideVolumes: 'delen',
    checkoutBookAsideShelfLabel: 'De {count} delen van uw bestelling',
    checkoutBookAsideEbook: 'eBook',
    checkoutBookAsidePaper: 'Gedrukt boek',
    checkToggler: 'Alles selecteren/deselecteren',
    choose: 'Kiezen',
    close: 'Sluiten',
    cmsDeleteConfirmTitle: 'Inhoud verwijderen',
    cmsDeleteConfirmMessage: 'Weet u zeker dat u deze inhoud wilt verwijderen?',
    companyShippingEdit: 'Transport bewerken',
    conditions: 'Voorwaarden',
    configMissingKeyAlert: 'De configuratiesleutel ontbreekt!',
    configuration: 'Configuratie',
    confirm: 'Bevestigen',
    confirmMessage: 'Bevestig uw actie.',
    confirmTitle: 'Weet u het zeker?',
    contactButton: 'Neem contact op',
    contactMessage: 'Bericht',
    contactPageButton: 'Verzenden',
    contactPageText1: 'Hulp nodig? Informatie? Wij staan voor u klaar!',
    contactPageTitle: 'Contact',
    contactSend: 'Verzenden',
    continue: 'Doorgaan',
    conversationActionContinue: 'Verdergaan',
    conversationActionRestart: 'Opnieuw beginnen',
    conversationAddTitle: 'Een chat toevoegen',
    conversationAdminDeleteConfirmTitle: 'Chat verwijderen',
    conversationAdminDeleteConfirmMessage: 'Deze chat en alle media worden definitief verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
    conversationArchiveError: 'We kunnen uw archiefbestand niet lezen! Neem contact met ons op om het probleem op te lossen...',
    conversationBookOrderTypeBook: 'Papieren boek + Gratis eBook(s)',
    conversationBookOrderTypePdf: 'Alleen eBook(s)',
    conversationBookPreview: 'Voorbeeldweergave',
    conversationBookPreviewSelected: 'Voorbeeldweergave van boek nr. {number}',
    conversationBookSelector: 'Selecteer het boek om te bewerken',
    conversationBookTypeLabelBook: 'Papier + Ebook',
    conversationBookTypeLabelPdf: 'Alleen Ebook',
    conversationBooks: 'Boeken',
    conversationCollectorArchiveSelectButton: 'Een archief uploaden',
    conversationCollectorInitWaiting: 'We bereiden uw gegevens voor... Een moment geduld alstublieft',
    conversationCollectorUseArchive: 'Een back-up uploaden (.zip-bestand)',
        conversationCoverBookEdit: 'Omslag aanpassen',
    conversationCoverBookReset: 'De omslag van dit boek resetten',
    conversationCoverApplyToAllBooks: 'Deze omslag op alle delen toepassen',
    conversationCoverAutoAppliedToAllBooks: 'Omslag toegepast op de andere delen.',
    conversationCoverApplyToAllBooksTitle: 'Deze omslag op alle delen toepassen?',
    conversationCoverApplyToAllBooksMessage: 'Kies de elementen die op alle andere delen worden toegepast.',
    conversationCoverApplyOptionColor: 'Kleur',
    conversationCoverApplyOptionPhoto: 'Foto',
    conversationCoverApplyOptionTitle: 'Titel',
    conversationCoverApplyOptionSubtitle: 'Ondertitel',
    conversationCoverBookSwitchAlertMessage: 'Alleen de omslaginformatie voor dit specifieke boek wordt opgeslagen.',
    conversationCoverBookSwitchAlertTitle: 'Wilt u de omslag voor dit boek opslaan?',
    conversationCoverColorEditTitle: 'Kies uw omslag',
    conversationCoverLuxEyebrow: 'Uw omslag',
    conversationCoverLuxHint: 'Kies het model en de kleur, en personaliseer daarna de omslag.',
    conversationParticipantsLuxEyebrow: 'Uw gesprek',
    conversationParticipantsLuxHint: 'Bewerk namen, bubbelkleuren en links/rechts positie voor elke deelnemer.',
    conversationParticipantsLuxSavePreview: 'Opslaan · terug naar voorbeeld',
    conversationParticipantsLuxSaved: 'Opgeslagen',
    conversationParticipantsSameSideHint: 'Meerdere deelnemers staan aan dezelfde kant. Controleer de links/rechts positie.',
    conversationParticipantColorBlushClair: 'Licht blush',
    conversationParticipantColorCielClair: 'Lichte lucht',
    conversationParticipantColorLavandeClaire: 'Lichte lavendel',
    conversationParticipantColorPruneClaire: 'Lichte pruim',
    conversationParticipantColorPecheClaire: 'Lichte perzik',
    conversationParticipantColorSaugeClair: 'Lichte salie',
    conversationParticipantColorMiel: 'Honing',
    conversationParticipantColorPerle: 'Parel',
    conversationParticipantNameError: 'De naam is te lang (max. {max} tekens)',
    conversationParticipantPositionLeft: 'Links',
    conversationParticipantPositionRight: 'Rechts',
    conversationDatesLuxEyebrow: 'Uw verhaal',
    conversationDatesLuxHint: 'Kies de begin- en einddatum van uw boek. Klik op een bericht om de selectie te verfijnen.',
    conversationDatesLuxNextEnd: 'Einddatum',
    conversationDatesLuxBackStart: 'Begindatum',
    conversationDatesLuxSavePreview: 'Opslaan · terug naar voorbeeld',
    conversationDatesPresetsLabel: 'Snelle periodeselectie',
    conversationDatesPreset_all: 'Volledig gesprek',
    conversationDatesPreset_year: 'Afgelopen jaar',
    conversationDatesPreset_sixMonths: 'Laatste 6 maanden',
    conversationDatesSelectionCount: '{count, number} {count, plural, one {bericht} other {berichten}}',
    conversationDatesSelectionPeriod: 'van {start} tot {end}',
    conversationDatesStoryDuration: 'Deze selectie beslaat {duration}',
    conversationDatesStartCaption: 'Uw allereerste bericht',
    conversationDatesEndCaption: 'Uw allerlaatste bericht',
    conversationDatesBookMessages: '{messages, number} {messages, plural, one {bericht} other {berichten}}, {photos, number} {photos, plural, one {foto} other {foto\'s}} en {medias, number} {medias, plural, one {media} other {media}} in uw selectie',
    conversationDateSelectionEmpty: 'Geen berichten in deze periode. Verruim de selectie.',
    conversationMessagesLuxEyebrow: 'Uw boek',
    conversationMessagesLuxHint: 'Zoek, verberg of bewerk berichten. Uw wijzigingen gelden voor uw selectie.',
    conversationMessagesLuxSavePreview: 'Opslaan · terug naar voorbeeld',
    conversationMessagesLuxBackPreview: 'Voorbeeld bekijken',
    conversationMessagesLuxCount: '{messages, number} {messages, plural, one {bericht} other {berichten}}, {photos, number} {photos, plural, one {foto} other {foto\'s}} en {medias, number} {medias, plural, one {media} other {media}} in uw selectie',
    conversationMessagesFilterResults: '{count, number} {count, plural, one {resultaat} other {resultaten}}',
    conversationMessagesOnlyHidden: 'Alleen verborgen',
    conversationMessagesResetFilters: 'Filters wissen',
    conversationMessagesShowHidden: 'Verborgen berichten tonen',
    conversationMessagesResetChanges: 'Alle wijzigingen ongedaan maken',
    conversationMessagesResetChangesButton: 'Alles ongedaan maken',
    conversationMessagesResetChangesConfirm: 'Het gesprek wordt hersteld naar de oorspronkelijk geïmporteerde staat. Al uw wijzigingen (verborgen, bewerkte of toegevoegde berichten) gaan definitief verloren. Doorgaan?',
    conversationMediaTypePhotos: 'Foto’s',
    conversationMediaTypeVideos: 'Video’s',
    conversationMediaTypeAudios: 'Audio',
    conversationMediaTypeLinks: 'Links',
    conversationMediaTypeOther: 'Overige',
    conversationMessagesToolSearch: 'Zoeken',
    conversationMessagesToolMedias: 'Media',
    conversationMessagesToolDates: 'Datums',
    conversationMessagesToolHidePeriod: 'Een periode verbergen',
    conversationMessagesToolHidden: 'Weergave',
    conversationMessagesToolReset: 'Wijzigingen',
    conversationMessagesToolResetNone: 'Geen',
    conversationMessagesToolResetCount: '{count, number} {count, plural, one {wijziging} other {wijzigingen}}',
    conversationMessagesHiddenViewHint: 'Kies welke berichten in de lijst hieronder verschijnen.',
    conversationMessagesHiddenViewAll: 'Alle',
    conversationMessagesHiddenViewVisible: 'Alleen zichtbare',
    conversationMessagesHiddenViewHidden: 'Alleen verborgen',
    conversationMessagesResetChangesHint: 'Herstelt het gesprek naar de oorspronkelijk geïmporteerde staat. Al uw wijzigingen (verborgen, bewerkte of toegevoegde berichten) gaan verloren.',
    conversationMessagesToolSearchNone: 'Geen',
    conversationMessagesToolMediasAll: 'Alle berichten',
    conversationMessagesToolDatesAll: 'Hele periode',
    conversationMessagesToolHidePeriodNone: 'Geen periode',
    conversationMessagesToolHiddenShown: 'Getoond',
    conversationMessagesToolHiddenMasked: 'Verborgen',
    conversationMessagesBestofCuratedHint: 'Uw Best Of is samengesteld: het boek is al gevuld tot het maximale aantal pagina\'s. U kunt berichten verbergen en andere weer tonen, zolang het boek niet langer wordt.',
    conversationMessagesBestofFullError: 'Uw Best Of is al vol. Verberg eerst ongeveer {pages, number} {pages, plural, one {pagina} other {pagina\'s}} elders om deze berichten te tonen.',
    conversationMessagesHidePeriodHint: 'Verberg (of toon opnieuw) alle berichten tussen twee datums in één keer.',
    conversationMessagesHidePeriodFrom: 'Van',
    conversationMessagesHidePeriodTo: 'Tot',
    conversationMessagesHidePeriodCount: '{count, number} {count, plural, one {bericht} other {berichten}} in deze periode ({visible} zichtbaar, {hidden} verborgen)',
    conversationMessagesHidePeriodConfirmHide: '{count, number} {count, plural, one {bericht} other {berichten}} van deze periode verbergen?',
    conversationMessagesHidePeriodConfirmShow: '{count, number} {count, plural, one {bericht} other {berichten}} van deze periode opnieuw tonen?',
    conversationMessagesHidePeriodHide: 'Deze periode verbergen',
    conversationMessagesHidePeriodShow: 'Deze periode opnieuw tonen',
    conversationMessagesHidePeriodItem: 'Periode {index}',
    conversationMessagesHidePeriodAdd: 'Een periode toevoegen',
    conversationMessagesHidePeriodInvalid: 'De einddatum moet na de begindatum liggen.',
    conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {periode} other {periodes}}',
    conversationMessagesSearchPlaceholder: 'Zoek een woord, een naam…',
    conversationCoverResumeLuxEyebrow: 'Voorwoord',
    conversationCoverResumeLuxHint: 'Optioneel: deze tekst wordt op de binnenflap afgedrukt.',
    conversationCoverBookNumber: 'Deel {number}',
    conversationCoverFooterPrefaceGuide: 'Ga terug naar het voorbeeld om het voorwoord over te slaan, of ga verder om het optioneel te schrijven (binnenflap).',
    conversationCoverFooterNextPreface: 'Voorwoord (optioneel)',
    conversationCoverFooterSkipPreface: 'Voorwoord overslaan · terug naar voorbeeld',
    conversationCoverFooterBackToCover: 'Terug naar omslag',
    conversationCoverFooterFinishPreview: 'Klaar · terug naar voorbeeld',
    conversationCoverFooterGoPreview: 'Terug naar voorbeeld',
    conversationCoverEditionTypeTitle: 'Type boekeditie',
    conversationCoverEditionTypeBookHelp: 'Bij de volledige collectie kunt u de omslag van elk deel apart aanpassen.',
    conversationCoverColorSelectorHelp: 'Selecteer de kleur van de omslag',
    conversationCoverStyleSelectorHelp: 'Kies het omslagmodel',
    conversationCoverStylePhoto: 'Polaroid',
    conversationCoverStyleIncipit: 'Eerste bericht',
    conversationCoverPickMessageTitle: 'Een bericht kiezen',
    conversationCoverEditQuote: 'De zin wijzigen',
    conversationCoverPickMessageHint: 'Deze zin staat groot op de omslag.',
    conversationCoverPickMessageSearch: 'Een bericht zoeken',
    conversationCoverPickMessageEmpty: 'Geen bericht komt overeen.',
    conversationCoverAddQuote: 'Een zin toevoegen',
    conversationCoverHourLabel: 'Uur',
    conversationCoverDateLabel: 'Datum',
    conversationCoverGroupNameLabel: 'Groepsnaam',
    conversationCoverSpanLabel: 'Datums van het eerste en laatste bericht',
    conversationCoverApplyOptionStyle: 'Model',
    conversationCoverApplyOptionQuote: 'Zin',
    conversationCoverDragNDropFiles: 'Sleep een afbeelding hierheen',
    conversationCoverTapToSelectPhoto: 'Tik om een foto te kiezen',
    conversationCoverOpenFinder: 'Selecteer een afbeelding',
    conversationCoverPhotoSelectorTitle: 'Kies een foto',
    conversationCoverPhotoEditHint: 'Klik om de foto te wijzigen',
    conversationCoverPhotoChoose: 'Klik om een foto te kiezen',
    conversationPreviewSwipeHint: 'Veeg om te bladeren',
    conversationPreviewOpenBookHint: 'Veeg over de omslag om het boek te openen',
    conversationPreviewDiscoverBook: 'Ontdek mijn boek',
    conversationPreviewVolumesLabel: 'Uw collectie: {count} boeken',
    conversationPreviewVolumesHint: 'Tik op een omslag om dat deel te openen.',
    conversationCoverResumeEditTitle: 'Schrijf een voorwoord of opdracht (optioneel)',
    conversationCoverResumeError: 'Voorwoord te lang voor één pagina: verkort de tekst of verminder regelovergangen.',
    conversationCoverResumeNearLimit: 'Limiet van één pagina bijna bereikt ({lines}/{max} regels).',
    conversationCoverResumeHelp: 'Dit voorwoord wordt gedrukt op de binnenkant van de omslag van uw boek.',
    conversationCoverResumePlaceholder: 'Schrijf een voorwoord voor uw boek',
    conversationCoverResumeReset: 'De tekst van dit boek resetten',
    conversationCoverTitleError: 'Titel te lang (max: {max} tekens)',
    conversationCoverTitleHelp: 'Klik om de titel van het boek te bewerken',
    conversationCoverTitlePlaceholder: 'Voer een titel in...',
    conversationCoverDefaultTitleTwoNames: '{name1} & {name2}',
    conversationCoverDefaultTitleGroup: 'Onze groep',
    conversationCoverDefaultTitleSingle: 'Mijn berichten',
	conversationCoverWaitingForCustomization: 'U kunt de omslag van uw boek in de volgende stap personaliseren...',
    conversationCreateInfoText: 'Maak een nieuw berichtenboek door hier op de iconen te klikken',
    conversationCreateMyBookTitle: 'Ik maak mijn boek',
    conversationCreateTitle: 'Een boek maken',
    conversationDateCreation: 'Aanmaakdatum',
    conversationDateDownloadedInfo: 'Het boek is gedownload op {downloaded}',
    conversationDateEnd: 'Einde van de chat',
    conversationDateEndInfo: 'Het boek eindigt op {end}',
    conversationDateEndLabel: 'Einddatum selecteren',
    conversationDateEndMessageSelection: 'Het boek hier beëindigen',
    conversationDateGeneratedInfo: 'Het boek is gegenereerd op {generated}',
    conversationDateRange: 'Van {start} tot {end}',
    conversationDeleteConfirmation: 'De chat is verwijderd!',
    conversationDateSelectionAlert: 'Het lijkt erop dat uw chat beschadigd is geraakt tijdens de overdracht. Probeer het opnieuw, blijf op de pagina tijdens het proces en zorg voor een stabiele internetverbinding.',
    conversationDateSimulatedInfo: 'Het boek is als voorbeeld bekeken op {simulated}',
    conversationDateStart: 'Begin van de chat',
    conversationDateStartInfo: 'Het boek begint op {start}',
    conversationDateStartLabel: 'Startdatum selecteren',
    conversationDateStartMessageSelection: 'Het boek hier beginnen',
    conversationDatesEditTitle: 'Datumselectie',
    conversationPreviewPrefaceOptionalBadge: 'Optioneel',
    conversationPreviewPrefaceEmptyTitle: 'Een voorwoord, als u wilt',
    conversationPreviewPrefaceEmptyText: 'Een paar woorden om uw boek te openen. U kunt deze stap overslaan en later terugkomen.',
    conversationPreviewPrefaceEmptyButton: 'Voorwoord toevoegen',
    conversationPreviewEndCta: 'Nu bestellen',
    conversationPreviewEndBodyPaused: 'Bevestig uw wijzigingen. De digitale versie ontvangt u meteen daarna per e-mail, om na te kijken.',
    conversationPreviewEndCtaPaused: 'Mijn wijzigingen bevestigen',
    conversationDemoAlert: 'U kunt nu de eerste pagina\'s van uw boek ontdekken.<br></br>Na uw bestelling ontvang u de volledige versie om na te kijken voordat we het drukken.',
    conversationDemoEndAlert: 'U kunt de rest van uw berichten ontdekken zodra uw aankoop is bevestigd.',
    conversationPreviewEndTitle: 'De rest wacht op u',
    conversationPreviewEndBody: 'De rest van uw berichten wacht. Bestel om uw boek volledig te zien.',
    conversationPreviewDemoBadge: 'MonLivreSMS',
    conversationPreviewPrefaceEmptyTitle: 'Uw voorwoord (optioneel)',
    conversationPreviewPrefaceOptionalBadge: 'Optioneel',
    conversationPreviewPrefaceEmptyText: 'Een paar woorden om uw boek te openen. U kunt deze stap overslaan en later terugkomen.',
    conversationPreviewPrefaceEmptyButton: 'Mijn voorwoord schrijven',
    conversationPreviewPrefaceEditButton: 'Voorwoord bewerken',

    conversationDisclaimerSubtitle: 'Kies uw formaat en open uw personalisatie-atelier.',
    conversationDisclaimerTitle: `{count} {count, plural,
      =0 {bericht}
      =1 {bericht}
      other {berichten}
    }: een verhaal dat het verdient om gelezen te worden`,
    conversationDisclaimerSavings: 'U bespaart {value}',
    conversationDisclaimerEBookIncluded: 'Ebook editie inbegrepen',
    conversationDisclaimerGenerating: 'Uw boek wordt gegenereerd...',

    conversationDisclaimerPlanSingleTitle: 'Deel 1',
    conversationDisclaimerPlanSingleDescription: 'De Essentie',
    conversationDisclaimerPlanSingleButtonText: 'Mijn boek maken',
    conversationDisclaimerPlanSingleFeaturePages: 'Het boek van uw keuze (400 pagina\'s) thuisbezorgd',
    conversationDisclaimerPlanSingleFeatureQuality: '',
    conversationDisclaimerPlanSingleFeatureEvolutive: 'Uitbreidbaar: maak de collectie later compleet',
    conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Premium Papier',
    conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Gedrukt op Premium Papier',
    conversationDisclaimerPlanSingleFeaturePdfIncluded: 'PDF-versie inbegrepen (Waarde: {price})',
    conversationDisclaimerPlanSingleFeatureWorkshop: 'Volledige personalisatie inbegrepen',
    conversationDisclaimerPlanSingleFeatureMedia: 'Foto\'s, Video\'s & Audio inbegrepen',

    conversationDisclaimerPlanCollectionTitle: 'De Complete Collectie',
    conversationDisclaimerPlanCollectionDescription: 'Het Volledige Werk',
    conversationDisclaimerPlanCollectionButtonText: 'Ons hele verhaal bewaren',
    conversationDisclaimerPlanCollectionBadge: 'PAKKETAANBIEDING -{percentage}%',
    conversationDisclaimerPlanCollectionFeatureBox: 'Uw {count} boeken gedrukt en bezorgd',
    conversationDisclaimerPlanCollectionFeatureDiscount: 'Collectietarief -{percentage}% (-{amount} inbegrepen)',
    conversationDisclaimerPlanCollectionFeatureDigital: 'Digitale editie cadeau',
    conversationDisclaimerPlanCollectionFeatureWorkshop: 'Volledige personalisatie inbegrepen',
    conversationDisclaimerPlanCollectionFeatureMedia: 'Foto\'s, Video\'s & Audio inbegrepen',

    conversationDisclaimerPlanEbookTitle: 'De Ebook Editie',
    conversationDisclaimerPlanEbookDescription: 'Het Digitale Formaat',
    conversationDisclaimerPlanEbookButtonText: 'Opslaan als PDF',
    conversationDisclaimerPlanEbookFeaturePdf: 'Direct High Definition PDF',
    conversationDisclaimerPlanEbookFeatureShare: 'Gemakkelijk te delen',
    conversationDisclaimerPlanEbookFeatureMessages: 'Al uw {count} berichten',
    conversationDisclaimerPlanEbookFeatureMedia: 'Foto\'s, Video\'s & Audio inbegrepen',

    conversationDisclaimerReassuranceGuaranteeTitle: 'Tevredenheidsgarantie',
    conversationDisclaimerReassuranceGuaranteeDescription: 'Terugbetaling op verzoek gegarandeerd tot aan de definitieve validatie.',
    conversationDisclaimerReassuranceCustomTitle: 'Vrije Personalisatie',
    conversationDisclaimerReassuranceCustomDescription: 'Bewerk uw omslag en berichten ná uw betaling',
    conversationDisclaimerReassuranceSecureTitle: '100% Veilige Betaling',
    conversationDisclaimerReassuranceSecureDescription: 'Bankkaart, Apple Pay, Google Pay',
    conversationDisclaimerReassuranceDeliveryTitle: 'Snelle Levering',
    conversationDisclaimerReassuranceDeliveryDescription: 'Binnen 5 werkdagen bij u thuis bezorgd',

    conversationDisclaimerReviewSuffix: 'uit +{count} gedrukte boeken',

    conversationDowloadUnableAlert: 'U kunt de boeken van deze chat niet meer downloaden... Neem contact met ons op om het probleem op te lossen.',
    conversationDownloadDeadlineInfo: 'U kunt uw bestanden downloaden tot {date}',
    conversationDownloadLink: 'Download mijn boek Nr. {index}',
    conversationDownloadFileCoverLink: 'Download omslag {name}',
    conversationDownloadFileSourceLink: 'Download het bronbestand {name}',
    conversationDownloadPdfButton: 'Download het E-book',
    conversationDownloadPdfWaitingMessage: 'Wacht 5 minuten om opnieuw te downloaden',
    conversationEditStart: 'Het boek bewerken',
    conversationEditSuccess: 'De chat is bijgewerkt!',
    'conversationFormatLabelA4-1': 'Kronieken van jullie herinneringen',
    'conversationFormatLabelA4-2': '(A4 album)',
    'conversationFormatLabelA5-1': 'De kleine schat',
    'conversationFormatLabelA5-2': '(A5 formaat)',
    conversationGeneratedSuccess: 'Gefeliciteerd! <br></br> Uw chat is succesvol gegenereerd!',
        conversationGenerationAlert: 'We maken uw boek…',
        conversationGenerationAlert2: 'Blijf even bij ons: het duurt maar een moment.',
        conversationGenerationFailed: 'Het maken van uw boek is onderbroken.',
        conversationGenerationFailedHint: 'Uw berichten zijn veilig bewaard. Probeer het opnieuw. Gebeurt het nog een keer? Stuur ons dan een bericht, dan kijken we met u mee.',
        conversationGenerationRetry: 'Opnieuw proberen',
    conversationHelpBooksText: 'Wissel tussen uw boeken om de specifieke informatie van elk boek te bewerken',
    conversationHelpBooksTitle: 'Boekselectie',
    conversationHelpCoverColorText: 'U kunt de achtergrondkleur van de omslag wijzigen door op de cirkel te klikken.',
    conversationHelpCoverColorTitle: 'Kleur van de omslag',
    conversationHelpCoverImageText: 'U kunt elke afbeelding in deze ruimte slepen om deze aan uw omslag toe te voegen.',
    conversationHelpCoverImageTitle: 'Omslagafbeelding',
    conversationHelpCoverTitleText: 'Klik op de titel om deze te bewerken! U heeft 2 regels beschikbaar: Titel en Ondertitel.',
    conversationHelpCoverTitleTitle: 'Titel van de omslag',
    conversationHelpDatePreviewText: 'Selecteer de startdatum van uw verhaal.',
    conversationHelpDatePreviewTitle: 'Datum',
    conversationHelpDateSelectorText: 'Door de datum te wijzigen, verschijnen uw eerste en laatste berichten hier!',
    conversationHelpDateSelectorTitle: 'Voorbeeld van het bericht',
    conversationHelpParticipantColorText: 'U kunt de kleur van de tekstballonnen voor elke deelnemer wijzigen om een unieke touch te geven.',
    conversationHelpParticipantColorTitle: 'Kleur van de deelnemers',
    conversationHelpParticipantNameText: 'Bewerk de naam van de deelnemer zoals u dat wilt!',
    conversationHelpParticipantNameTitle: 'Naam van de deelnemer',
    conversationHelpParticipantPositionText: 'Kies of u de berichten van deze deelnemer links of rechts wilt weergeven.',
    conversationHelpParticipantPositionTitle: 'Positie van de deelnemer',
	conversationHelpMessagesToolsTitle: 'Tools',
	conversationHelpMessagesToolsText: 'Tik op een tegel om te zoeken, te filteren op media of datums, of berichten te verbergen.',
	conversationHelpMessagesSearchTitle: 'Zoeken',
	conversationHelpMessagesSearchText: 'Typ een woord of een naam om snel een bericht te vinden.',
	conversationHelpMessagesMediasTitle: 'Media',
	conversationHelpMessagesMediasText: 'Filter berichten met foto\'s, video\'s, audio of links.',
	conversationHelpMessagesDatesTitle: 'Datums',
	conversationHelpMessagesDatesText: 'Toon alleen berichten tussen twee datums om u op een deel van het gesprek te richten.',
	conversationHelpMessagesHidePeriodTitle: 'Periode verbergen',
	conversationHelpMessagesHidePeriodText: 'Kies twee datums om in één keer een hele periode te verbergen (of opnieuw te tonen).',
	conversationHelpMessagesHiddenTitle: 'Weergave',
	conversationHelpMessagesHiddenText: 'Toon alle berichten, alleen zichtbare, of alleen verborgen.',
	conversationHelpMessagesListTitle: 'Bericht bewerken',
	conversationHelpMessagesListText: 'Op elke bubbel: selecteren, verbergen, tekst bewerken of een nieuw bericht invoegen.',
	conversationHelpMessagesFooterTitle: 'Terug naar voorbeeld',
	conversationHelpMessagesFooterText: 'Als u klaar bent, ga terug naar het voorbeeld om uw bijgewerkte boek te zien.',
    conversationHelpPreviewBookCoverText: 'Geef het een unieke omslag. Klik om te personaliseren.',
    conversationHelpPreviewBookCoverTitle: 'Boekomslag',
    conversationHelpPreviewBookPreviewText: 'Bekijk een specifiek deel door hier te klikken!',
    conversationHelpPreviewBookPreviewTitle: 'Boekvoorbeeld',
    conversationHelpPreviewBookSelectorText: 'Kies de delen die u wilt afdrukken.',
    conversationHelpPreviewBookSelectorTitle: 'Boekenselectie',
    conversationHelpPreviewBookSplitText: 'Door dit vakje aan te vinken, krijgen al uw boeken hetzelfde aantal pagina\'s voor een uniforme collectie.',
    conversationHelpPreviewBookSplitTitle: 'Boekpagina\'s',
        conversationHelpPreviewCopyText: 'Bestel meerdere exemplaren: voor uzelf of als cadeau. Korting vanaf het 2e exemplaar.',
    conversationHelpPreviewCopyTitle: 'Kopieën',
        conversationHelpPreviewFormatText: 'Papieren boek of digitaal eBook: kies wat bij u past.',
        conversationHelpPreviewFormatTitle: 'Formaat',
        conversationHelpPreviewRenderText: 'Hier is uw boek. Pas de omslag direct aan, blader daarna door de pagina\'s.',
        conversationHelpPreviewRenderTitle: 'Uw boek',
	conversationHelpPreviewMessagesText: 'Tik op deze kaart om de inhoud van uw berichten te bewerken.',
	conversationHelpPreviewMessagesTitle: 'Berichten',
	conversationHelpPreviewDatesText: 'Tik op deze kaart om de begin- en einddatum van uw boek te kiezen.',
	conversationHelpPreviewDatesTitle: 'Datums',
	conversationHelpPreviewParticipantsText: 'Tik op deze kaart om namen en weergave van deelnemers te wijzigen.',
	conversationHelpPreviewParticipantsTitle: 'Deelnemers',
	conversationHelpPreviewCoverTitleText: 'Klik op de titel of ondertitel om ze te bewerken.',
	conversationHelpPreviewCoverTitleTitle: 'Titel en ondertitel',
	conversationHelpPreviewVolumesTitle: 'Meerdere delen',
	conversationHelpPreviewVolumesText: 'Uw gesprek beslaat meerdere boeken. Tik op een nummer om van deel te wisselen en elke omslag aan te passen.',
	conversationHelpPreviewCoverImageText: 'Tik op het fotogebied om de omslagafbeelding toe te voegen of te wijzigen.',
	conversationHelpPreviewCoverImageTitle: 'Foto',
	conversationHelpPreviewCoverColorText: 'Tik op een kleurstalen om de achtergrondkleur van de omslag te wijzigen.',
	conversationHelpPreviewCoverColorTitle: 'Kleur',
        conversationHelpPreviewValidText: 'Als alles klopt, bevestig. Uw eBook komt per e-mail, uw boek thuis.',
        conversationHelpPreviewValidTitle: 'Aan de slag!',

    conversationHighlightStartDateTitle: 'Het eerste bericht',
    conversationHighlightStartDateDescription: 'Die dag ging het eerste bericht de deur uit. De rest is daaruit ontstaan.',
    conversationHighlightDurationTitle: 'Samen sinds',
    conversationHighlightDurationDescription: 'Al deze dagen samen, sinds dat eerste bericht.',
    conversationHighlightMessagesCountTitle: 'Berichten',
    conversationHighlightMessagesCountDescription: 'Al deze berichten, uitgewisseld sinds {date}.',
    conversationHighlightImagesCountTitle: 'Foto\'s',
    conversationHighlightImagesCountDescription: 'Deze foto\'s, bewaard uit onze chat.',
    conversationHighlightMediasCountTitle: 'Video\'s en spraakberichten',
    conversationHighlightMediasCountDescription: 'Om een stem terug te horen en een moment terug te zien.',
    conversationHighlightSpecialDayMessagesCountTitle: 'Op één dag',
    conversationHighlightSpecialDayMessagesCountDescription: 'Ons record: zoveel berichten op één dag.',
    conversationHighlightSpecialDayTitle: 'Die dag',
    conversationHighlightSpecialDayDescription: 'De dag waarop we elkaar het meest hebben geschreven.',
    conversationHighlightCharsCountReferenceDiffTitle: 'Romeo en Julia',
    conversationHighlightCharsCountReferenceDiffDescription: 'De tekst van Romeo en Julia, zoveel keer.',
    conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} keer',
    conversationHighlightTypingDurationTitle: 'Schrijven',
    conversationHighlightTypingDurationDescription: 'Zoveel uur dat we elkaar hebben geschreven.',
    conversationHighlightUnitDays: '{count, plural, one {dag} other {dagen}}',
    conversationHighlightUnitMessages: '{count, plural, one {bericht} other {berichten}}',
    conversationHighlightUnitHours: 'uur',
    conversationHighlightUnitTimes: 'keer',

    conversationHighlightBadge: 'In een paar cijfers',
    conversationHighlightStoryKicker: 'Uw verhaal',
    conversationHighlightsMomentsCount: '{count, plural, one {# afbeelding om te downloaden} other {# afbeeldingen om te downloaden}}',
    conversationHighlightShareFormat: 'Story-formaat',
    conversationHighlightsCardFooter: 'Sommige verhalen verdienen een boek',
    conversationHighlightShareButton: 'Downloaden',
    conversationHighlightShareButtonAlt: 'Bekijk de gespreksstatistieken',
    conversationHighlightSubtitle: 'De cijfers van wat u elkaar hebt gezegd.',
    conversationHighlightTitle1: 'Uw berichten',
    conversationHighlightTitle2: 'in een paar cijfers',
    conversationHighlightOpenStoryButton: 'Deze story openen',
    conversationHighlightsAtGlanceEyebrow: 'In één oogopslag',
    conversationHighlightsAtGlanceTitle: 'De omvang van uw verhaal',
    conversationHighlightsNoAiNote: 'Deze statistieken worden automatisch berekend, zonder AI.',
    conversationHighlightsKpiMessages: 'berichten',
    conversationHighlightsKpiWords: 'geschreven woorden',
    conversationHighlightsKpiActiveDays: 'actieve dagen',
    conversationHighlightsKpiStreak: 'dagen op rij',
    conversationHighlightsRhythmEyebrow: 'Uw ritme',
    conversationHighlightsRhythmTitle: 'Wanneer uw berichten tot leven komen',
    conversationHighlightsTopHour: 'Uw favoriete tijdstip',
    conversationHighlightsTopWeekday: 'Uw favoriete dag',
    conversationHighlightsNightMessages: 'Berichten \'s nachts',
    conversationHighlightsChartMonths: 'Elke maand, van het eerste tot het laatste bericht',
    conversationHighlightsChartYears: 'Elk jaar, van het eerste tot het laatste bericht',
    conversationHighlightsLessThanOneMinute: 'minder dan 1 min',
    conversationHighlightsSpanLessThanMonth: 'Minder dan een maand',
    conversationHighlightsSpanYears: '{count, plural, one {# jaar} other {# jaar}}',
    conversationHighlightsSpanMonths: '{count, plural, one {# maand} other {# maanden}}',
    conversationHighlightsSpanYearsMonths: '{years, plural, one {# jaar} other {# jaar}} en {months, plural, one {# maand} other {# maanden}}',
    conversationHighlightsSpanLabel: 'Van het eerste tot het laatste bericht',
    conversationHighlightsBusiestDayLabel: 'Drukste dag',
    conversationHighlightsPhotosLabel: 'Foto’s',
    conversationHighlightsMediasLabel: 'Video’s en spraakberichten',
    conversationHighlightsBookPagesLabel: 'Uw boek',
    conversationHighlightsBookPagesPrefix: 'ongeveer',
    conversationHighlightsBookPagesUnit: '{count, plural, one {pagina} other {pagina\'s}}',
    conversationHighlightsBookPagesNote: 'Schatting op basis van uw berichten en foto’s.',
    conversationHighlightsWritingHours: 'Ongeveer {count, plural, one {# uur schrijven aan elkaar} other {# uur schrijven aan elkaar}}.',
    conversationHighlightsRomeo: 'Evenveel tekst als {count} keer Romeo en Julia.',
    conversationHighlightsDayClockPeak: 'Het vaakst tussen {start} u en {end} u',
    conversationHighlightsLessThanOnePercent: '< 1 %',
    conversationHighlightsWritesLonger: '{name} schrijft de langste berichten.',
    conversationHighlightsStartsMore: '{name} begint het vaakst het gesprek.',
    conversationHighlightsWordsPerMessage: '{count} woorden / bericht',
    conversationHighlightsStartsShare: '{percent} % van de starts',
    conversationHighlightsMedianReply: 'Mediane reactietijd',
    conversationHighlightsBalanceEyebrow: 'Uw balans',
    conversationHighlightsBalanceTitle: 'Iedereen is er op zijn eigen manier',
    conversationHighlightsWordsShort: 'woorden',
    conversationHighlightsStartsShort: 'openingen',
    conversationHighlightsBalanceNote: 'Een percentage beschrijft een ritme, nooit het belang van een persoon.',
    conversationHighlightsRecordsEyebrow: 'Uw records',
    conversationHighlightsRecordsTitle: 'De momenten die eruit springen',
    conversationHighlightsLongestSession: 'Langste gesprek',
    conversationHighlightsIntenseQuarter: 'Intensiefste 15 minuten',
    conversationHighlightsQuestions: 'Lieve berichten',
    conversationHighlightsSignsOfInterest: 'hartjes, kusjes of „ik hou van je”',
    conversationHighlightsLaughs: 'Berichten met gelach',
    conversationHighlightsSharedSmiles: 'gedeelde glimlachen',
    conversationHighlightsFavoriteEmojis: 'Uw favoriete emoji\'s',
    conversationHighlightsStoriesEyebrow: 'Om te bewaren',
    conversationHighlightsStoriesTitle: 'Uw herinneringskaarten',
    conversationHighlightsStoriesText: 'Open een kaart en download deze daarna in story-formaat.',
    conversationHighlightsDeepEyebrow: 'En na de cijfers?',
    conversationHighlightsDeepTitle: 'Wilt u uw verhaal verder laten uitdiepen?',
    conversationHighlightsDeepText: 'Laat ons weten of u ooit verder zou willen gaan. Voorlopig wordt er niets anders geanalyseerd.',
    conversationHighlightsDeepThanks: 'Bedankt, uw interesse is geregistreerd',
    conversationHighlightsDeepButton: 'Ja, dat zou mij interesseren',
    conversationHighlightsDeepNotice: 'U krijgt bericht zodra het gepland is.',
    conversationHighlightsDeepNoticeClose: 'Akkoord',
    conversationHighlightsPrintBook: 'Ik wil mijn boek laten drukken',
    conversationHighlightsPrintNow: 'Ik druk het nu',

    conversationImagesCount: `{count} {count, plural,
      =0 {foto}
      =1 {foto}
      other {foto's}
    }`,

    conversationImportFileNotSupportedError: 'Uw bestand is niet geldig! Selecteer een geldig ingepakt bestand (.zip)',
    conversationImportFileSummary: 'Uw naam is {name} en u heeft {count} chats in dit archief.',
    conversationImportFileTooBigError: 'Uw bestand is te groot! (meer dan 4GB). Neem contact met ons op om dit probleem op te lossen.',
    conversationImportProviderNext: 'Mijn chat overzetten',
    conversationImportTutorialGoNext: 'Bekijk het volgende',
    conversationImportTutorialStep: 'Stap nr. {step}',
    conversationImportDetailToggle: 'Bekijk de gedetailleerde gids met screenshots',
    conversationImportDetailCardTitle: 'Eerste keer?',
    conversationImportDetailCardSubtitle: 'Geïllustreerde stap-voor-stap gids ({count} stappen met screenshots)',
    conversationImportDetailCardAction: 'Gids openen',
    conversationImportDetailTitle: 'Gedetailleerde stap-voor-stap gids',
    conversationImportDetailStepOf: 'Stap {current} van {total}',
    conversationImportDetailPrev: 'Vorige',
    conversationImportDetailNext: 'Volgende',
    conversationImportDetailClose: 'Sluiten',
    conversationImportSelectionSummary: `Geselecteerde chat: {name} (bevat {count} {count, plural,
        =0 {bericht}
        =1 {bericht}
        other {berichten}
      })`,
    conversationImportSelectionSummary2: 'Geselecteerde chat: {name}',
    conversationImportSelectionText: 'Typ de naam van uw vriend...',
    conversationImportSelectionTitle: 'Selecteer de chat',
    conversationImportStepCreation: 'Gesprek aanmaken',
    conversationImportStepExtraction: 'Gegevens ophalen',
    conversationImportStepFinal: 'De laatste details afronden...',
    conversationImportStepImages: 'Uw afbeeldingen opslaan',
    conversationImportStepMessages: 'Uw berichten opslaan',
    conversationImportSuccess: 'Gefeliciteerd! <br></br>Uw chat is succesvol geïmporteerd!',
    conversationImportValidationWaiting: 'Validatie in uitvoering...',
    conversationMediaAudioOpusWarning: 'Als u dit audiobestand niet kunt afspelen, gebruik dan een andere compatibele browser (zoals Google Chrome)',
    conversationMediasCount: `{count} {count, plural,
      =0 {mediabestand}
      =1 {mediabestand}
      other {mediabestanden}
    }`,
    conversationMerge: 'De chats samenvoegen',
    conversationMergeInfo: 'Selecteer de chats die u wilt samenvoegen en klik op de knop onder de lijst:',
    conversationMergeRequestSuccess: 'De chats worden binnenkort samengevoegd! U ontvangt een e-mail wanneer de samenvoeging voltooid is.',
    conversationMergeHintEyebrow: 'Goed om te weten',
    conversationMergeHintTitle: 'Samenvoegen tot één gesprek',
    conversationMergeHintSingle: 'Meerdere chatthreads? Importeer elk gesprek met + en voeg ze daarna samen tot één gesprek.',
    conversationMergeHintReady: 'U kunt uw gesprekken samenvoegen tot één chronologisch gesprek.',
    conversationMessages: 'Berichten',
    conversationMessagesCount: `{count} {count, plural,
      =0 {bericht}
      =1 {bericht}
      other {berichten}
    }`,
    conversationMessagesCount2: `{count, plural,
      =0 {bericht}
      =1 {bericht}
      other {berichten}
    }`,
    conversationMessagesImagesCount: `{count} {count, plural,
      =0 {afbeelding}
      =1 {afbeelding}
      other {afbeeldingen}
    }`,
    conversationMessagesImagesCount2: `{count, plural,
      =0 {afbeelding}
      =1 {afbeelding}
      other {afbeeldingen}
    }`,
    conversationMessagesLoadingAlert: 'De magie van uw berichten wordt opgehaald...',
    conversationMessagesMediasCount: `{count} {count, plural,
      =0 {mediabestand}
      =1 {mediabestand}
      other {mediabestanden}
    }`,
    conversationMessagesMediasCount2: `{count, plural,
      =0 {mediabestand}
      =1 {mediabestand}
      other {mediabestanden}
    }`,
    conversationNoData: 'U heeft nog geen gesprek geïmporteerd!',
    conversationOptionWithImagesHelp1: 'Momenteel worden uw boeken MET uw afbeeldingen of foto\'s gedrukt',
    conversationOptionWithImagesHelp2: 'Momenteel worden uw boeken ZONDER uw afbeeldingen of foto\'s gedrukt',
    conversationOptionWithImagesHelp3: 'Afhankelijk van de hoeveelheid foto\'s kan de overdracht van de chat vertragen. Blijf alstublieft op deze pagina tijdens het laden, dit kan tot 10 minuten duren. Als u nog steeds problemen ondervindt, stuur ons dan uw archief via www.fromsmash.com naar het adres hello@monlivresms.com met vermelding van de naam van het contact of de groep, en we zullen een oplossing vinden.',
    conversationOptionWithImagesLabel: 'Wilt u de afbeeldingen uit de chat opnemen?',
    conversationOptionWithMediaHelp: 'U zult uw video\'s, audio\'s en GIF\'s kunnen herontdekken dankzij de QR-codes die in uw boek worden afgedrukt. We geven uw 10 jaar veilige opslag van uw gegevens cadeau.',
    conversationOptionWithMediasLabel: 'Wilt u de video\'s, audio\'s en GIF\'s uit de chat opnemen?',
    conversationOrder: 'Bestelling',
    conversationOrderButton: 'Nu bestellen',
    conversationOrderButtonWithPrice: 'Bestellen · {price}',
    conversationOrderButtonWithPriceVolumes: 'Bestel mijn {count} boeken · {price}',
    conversationOrderDiscountLabel: '-{discount}% korting op deze chat bij bestelling van {threshold} exemplaren of meer!',
    conversationOrderQuantity: 'Aantal exemplaren',
    conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
			=1 {deel}
			other {delen}
		} · {bookTotal} {discount, plural,
			=0 {}
			other {: {discount} % korting inbegrepen}
		}`,
    conversationOrderSummary2: `Uw bestelling bevat {bookCount} {bookCount, plural,
          =0 {boek}
          =1 {boek}
          other {boeken}
        } en {pdfCount} {pdfCount, plural,
          =0 {eBook}
          =1 {eBook}
          other {eBooks}
        } {freeCount, plural,
          =0 {}
          =1 {+1 gratis eBook}
          other {+{freeCount} gratis eBooks}
        } voor {pdfTotal}`,
        conversationOrderSummaryBestof: '1 Best Of-boek · {bestofTotal}',
        conversationOrderSummaryPdf: '1 volledig eBook · {pdfTotal}',
    conversationParticipantColorHelp: 'Klik hier om de kleur van de bubbel te veranderen',
    conversationParticipantNameHelp: 'Klik hier om de naam van de deelnemer te bewerken',
    conversationParticipantPositionHelp: 'Klik om de positie van de deelnemer te wijzigen (naar links of naar rechts)',
    conversationParticipants: 'Deelnemers',
    conversationParticipantsEditTitle: 'Deelnemers bewerken',
    conversationPauseButton: 'Mijn bestelling pauzeren',
    conversationPauseConfirmText: 'Het genereren van uw boeken wordt gepauzeerd. U kunt het op elk moment hervatten.',
    conversationPreviewBookNumber: `{index}{index, plural,
          =0 {}
          =1 {e}
          other {e}
      } deel`,
    conversationPreviewBestofHelpButton: 'Hoe werkt de selectie?',
    conversationPreviewBestofHelpText: 'Onze formule analyseert elk moment van uw gesprek: de dichtheid van berichten, de kwaliteit van de uitwisseling (echt heen-en-weer of een monoloog?), de rijkheid van de inhoud (foto’s, tekst, emoji’s). De eerste en laatste berichten worden altijd bewaard. Alleen de momenten die er echt toe deden, komen in het boek. Uw berichten blijven privé: onze formule leest nooit de inhoud, alleen de structuur van uw uitwisselingen.',
    conversationPreviewBookSelection: 'Selectie van de delen',
    conversationPreviewBooksSelectAllBooks: 'Selecteer alle fysieke boeken',
    conversationPreviewBooksSelectAllEBooks: 'Selecteer alle eBooks',
    conversationPreviewBooksUnselectAll: 'Alles deselecteren',
        conversationPreviewBrowserWarning: 'Uw browser kan de weergave vertragen. Voor de beste ervaring raden we Google Chrome aan.',
    conversationPreviewFormatSelection: 'Formaatselectie',
    conversationPreviewPagesDivideEquallyLabel: 'Wilt u de pagina\'s eerlijk verdelen over de delen?',
    conversationPreviewPagesSetMaxBookPagesLabel: 'Heeft u liever dat uw boeken maximaal {max} pagina\'s hebben?',
        conversationPreviewTitle: 'Uw verhaal, als boek.',
        conversationPreviewSubtitle: 'Personaliseer omslag, namen, datums en berichten voordat u uw editie kiest.',
        conversationPreviewHeroTitle: 'Uw woorden, voor altijd gebundeld.',
        conversationPreviewBookCaption: 'Blader door de pagina\'s om uw boek te ontdekken.',
        conversationPreviewCustomizeEyebrow: 'Helemaal naar uw smaak',
        conversationPreviewEditionEyebrow: 'Uw editie',
        conversationPreviewPricePerVolume: '{price}/deel',
    conversationPreviewCollectionPriceNote: '{count} delen · {price}/deel',
    conversationPreviewCollectionUntilLabel: 'Welke delen',
    conversationPreviewCollectionUntilAll: 'Van het eerste tot het laatste deel',
    conversationPreviewCollectionUntilOpen: 'Kiezen',
    conversationPreviewCollectionUntilClose: 'Sluiten',
    conversationPreviewCollectionUntilPartial: '{count, plural, one {Het eerste deel} other {De eerste {count} delen}}',
    conversationPreviewCollectionUntilSuffix: '{count, plural, one {Het laatste deel} other {De laatste {count} delen}}',
    conversationPreviewCollectionUntilSingle: 'Deel {number}',
    conversationPreviewCollectionUntilWindow: 'Van deel {from} tot deel {to}',
    conversationPreviewCollectionUntilPeriod: 'Van {start} tot {end}',
    conversationPreviewCollectionUntilHint: 'De andere delen blijven in het gesprek, voor een volgende bestelling.',
    conversationPreviewCollectionUntilAriaStart: 'Eerste deel om af te drukken',
    conversationPreviewCollectionUntilAriaEnd: 'Laatste deel om af te drukken',
    conversationPreviewTypeBookTaglinePartial: '{count, plural, one {Het eerste deel van uw gesprek.} other {De eerste {count} delen van uw gesprek.}}',
    conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {Het laatste deel van uw gesprek.} other {De laatste {count} delen van uw gesprek.}}',
    conversationPreviewTypeBookTaglineWindowSingle: 'Deel {number} van uw gesprek.',
    conversationPreviewTypeBookTaglineWindow: 'De delen {from} tot {to} van uw gesprek.',
    conversationPreviewStickyCollectionVolumes: 'Collectie · {count} delen',
        conversationPreviewSocialProofCount: '{count}+ reviews',
        conversationPreviewSocialProofAria: 'Beoordeeld met {rating} van 5 op Trustpilot, op basis van meer dan {count} reviews',
        conversationPreviewCustomizeTitle: 'Mijn boek personaliseren',
        conversationPreviewCustomizeHint: 'Tik op een kaart om te bewerken.',
        conversationPreviewCardsHintTitle: 'Namen, periode, berichten',
        conversationPreviewCardsHintText: 'Hier wijzigt u de namen, de periode en de berichten.',
        conversationPreviewCustomizeTopics: 'Omslag · namen · data · berichten',
        conversationPreviewEditionTitle: 'Kies uw editie',
        conversationPreviewEditionHint: 'Vergelijk de opties en kies wat bij u past.',
        conversationPreviewPausedEyebrow: 'Bestelling gepauzeerd',
        conversationPreviewPausedTitle: 'Zijn uw wijzigingen klaar?',
        conversationPreviewPausedHint: 'Uw bestelling is gepauzeerd. Bewerk uw boek en bevestig daarna om de productie te hervatten.',
        conversationPreviewPausedScrollHint: 'Mijn wijzigingen bevestigen',
        conversationPreviewMissingMediasBanner: 'Sommige media (foto\'s, bestanden) uit uw gesprek ontbreken of konden niet worden opgehaald. Controleer uw berichten voordat u bevestigt.',
        conversationPreviewMissingMediasCta: 'Media aanvullen',
        bookMissingPhotoLabel: 'Foto niet beschikbaar',
        conversationMissingMediasBadge: 'Ontbrekende media',
        conversationMissingMediasCta: 'Ontbrekende media aanvullen',
        conversationResumeWithoutMediasButton: 'Doorgaan zonder deze foto’s',
        conversationResumeMissingMediasConfirmText: 'Er ontbreken nog foto’s. Uw boek gaat zonder deze foto’s naar druk. Vul de media aan als u kunt.',
        orderMissingMediasAlert: 'Er ontbreken foto’s in een gesprek van deze bestelling. Vul ze aan zodat de productie kan hervatten.',
        missingMediasRecoveryAddPhoto: 'Foto toevoegen',
        missingMediasRecoveryArchiveCta: 'Exportbestand neerzetten',
        missingMediasRecoveryArchiveError: 'Dit bestand kon niet worden gelezen. Controleer of het de export van uw berichtenapp is.',
        missingMediasRecoveryArchiveHelp: 'Upload opnieuw uw {provider}-export (zip). Alleen ontbrekende foto\'s worden toegevoegd: berichten en wijzigingen blijven hetzelfde.',
        missingMediasRecoveryArchiveTitle: 'Aanvullen via een nieuwe export',
        missingMediasRecoveryArchiveWorking: 'Ontbrekende foto\'s zoeken in uw bestand…',
        missingMediasRecoveryContact: 'Mail ons',
        missingMediasRecoveryEmpty: 'Momenteel geen ontbrekende media gedetecteerd.',
        missingMediasRecoveryError: 'Er is iets misgegaan. Probeer opnieuw of neem contact op.',
        missingMediasRecoveryFirstDate: 'Eerste ontbrekende media: {date}.',
        missingMediasRecoveryIgnore: 'Negeren',
        missingMediasRecoveryIntro: '{count, plural, one {# foto ontbreekt} other {# foto\'s ontbreken}} in uw boek. U kunt uw export opnieuw uploaden of elk item hieronder behandelen.',
        missingMediasRecoveryListTitle: 'Media één voor één behandelen',
        missingMediasRecoveryNoMatch: 'Geen bestand gevonden dat overeenkomt met de ontbrekende media.',
        missingMediasRecoveryRecommended: 'Aanbevolen',
        missingMediasRecoveryRescan: 'Opnieuw controleren',
        missingMediasRecoveryResolved: 'Alle ontbrekende media zijn verwerkt. Uw boek gaat terug naar productie.',
        missingMediasRecoverySuccessEyebrow: 'Alles in orde',
        missingMediasRecoverySuccessTitle: 'Top, uw foto\'s zijn compleet',
        missingMediasRecoverySuccessText: 'Alle ontbrekende media zijn verwerkt. Uw boek gaat terug naar productie.',
        missingMediasRecoverySuccessCta: 'Terug naar mijn voorbeeld',
        conversationMissingMediasFixedSuccess: 'Top: alle ontbrekende media zijn aangevuld. Uw boek gaat terug naar productie.',
        conversationMissingMediasFixedHint: 'U hoeft niets meer te doen: de productie hervat automatisch.',
        missingMediasRecoverySmsStepAndroid: 'Op Android: open de MonLivreSMS-app opnieuw en stuur het gesprek opnieuw.',
        missingMediasRecoverySmsStepBackup: 'Maak een nieuwe niet-versleutelde lokale back-up (Mac/PC) en start onze software opnieuw om de media van dit gesprek te sturen.',
        missingMediasRecoverySmsStepIcloud: 'Op iPhone: open het gesprek in Berichten, tik op het contact, scroll en download iCloud-foto\'s.',
        missingMediasRecoverySmsTitle: 'SMS- / iPhone-overdracht',
        missingMediasRecoveryTitle: 'Ontbrekende media ({count})',
        conversationPreviewEditionMetaLabel: 'Details van de editie',
        conversationPreviewBestofLearnMore: 'Hoe werkt de Best-Of-selectie?',
        conversationPreviewBestofHint: 'Illustratieve Best Of-voorvertoning: de selectie van uw beste berichten gebeurt na uw bestelling, bij het genereren van de PDF.',
        conversationPreviewBestofHintDismiss: 'Sluiten',
        conversationPreviewBestofHintLearnMore: 'Meer info',
        conversationPreviewBestofPriceNote: 'Selectie na bestelling',
        conversationPreviewTypeBestofTaglineCompare: 'Lichtere optie: uw beste momenten in 1 deel.',
        conversationPreviewMetaEbook: 'eBook inbegrepen',
        conversationPreviewMetaVolume: '{count} deel',
        conversationPreviewMetaVolumes: '{count} delen',
        conversationPreviewMetaPages: '{pages} pagina\'s',
        conversationPreviewMetaMessages: '{count} berichten',
        conversationPreviewMetaBestofPages: '~400 pagina\'s',
        conversationPreviewMetaBestofSelection: 'Slimme selectie',
        conversationPreviewMetaPdfInstant: 'PDF meteen',
        conversationPreviewMetaPdfCredit: 'Tegoed voor het boek',
        conversationPreviewPdfPriceNote: 'Afgetrokken bij upgrade naar boek',
        conversationPreviewPdfLearnMore: 'Hoe werkt het?',
        conversationPreviewPdfHelpText: 'U betaalt {ebookPrice} en ontvangt uw PDF. Bestelt u later het gedrukte boek voor {bookPrice}, dan worden deze {ebookPrice} afgetrokken: er blijft {remainingPrice} over. Het tegoed blijft op uw account.',
        conversationPreviewReassurancePdfCredit: 'Deze {price} worden afgetrokken als u naar het boek gaat',
        conversationPreviewStickyPdfCredit: '{price} tegoed als u naar het boek gaat',
        conversationPreviewEbookCreditBanner: 'U heeft {amount} tegoed op dit gesprek. Dat wordt automatisch afgetrokken als u het gedrukte boek bestelt.',
        conversationPreviewEbookCreditOrderHint: '{credit} tegoed afgetrokken · catalogusprijs {fullPrice}',
        conversationPreviewStickyEbookCredit: '{credit} tegoed toegepast',
        paymentMethodEbookCreditHint: 'E-booktegoed voor het gedrukte boek',
        cartTotalsEbookCredit: 'E-booktegoed',
        cartTotalsCredit: 'Tegoed',
        conversationOrderButtonEbook: 'Mijn PDF ontvangen',
        conversationOrderButtonEbookWithPrice: 'Mijn PDF ontvangen · {price}',
        conversationPreviewTypeBookTaglineSingle: 'Uw volledige verhaal, pagina na pagina.',
        conversationPreviewTypeBookTaglineMulti: 'Uw volledige gesprek in {count} gedrukte boeken.',
        conversationPreviewHeroHeading: 'Boekvoorbeeld',
        conversationPreviewHelpTourButton: 'Paginahulp tonen',
        conversationPreviewCardLabelCover: 'Omslag',
        conversationPreviewCardLabelParticipants: 'Deelnemers',
        conversationPreviewCardLabelDates: 'Datums',
        conversationPreviewCardLabelMessages: 'Berichten',
	conversationPreviewZoneDone: 'Al bekeken',
	conversationPreviewZoneHintCover: 'Kleur, foto, titel, voorwoord',
	conversationPreviewZoneHintParticipants: 'Namen en kleuren van de bubbels',
	conversationPreviewZoneHintDates: 'Periode die het boek beslaat',
	conversationPreviewZoneHintMessages: 'Berichten verbergen of aanpassen',
        conversationHelpPreviewCustomizeTitle: 'Namen, datums en berichten',
        conversationHelpPreviewCustomizeText: 'Tik op een kaart om namen, datums of berichten te bewerken.',
        conversationBookNavPrev: 'Vorige pagina',
        conversationBookNavNext: 'Volgende pagina',
        conversationBookBackToCover: 'Terug naar de omslag',
        conversationPreviewTypeBookPagesHint: ' · {pages} pagina\'s',
        conversationPreviewTypeBookMessagesHint: ' · {count} berichten',
        conversationOrderTotal: 'Totaal',
        conversationPreviewTypeBestofDescription: '400 pagina\'s, uw beste momenten. eBook inbegrepen.',
        conversationPreviewTypeBestofTitle: 'Best Of',
        conversationPreviewTypeBookDescription: '{count} deel · Volledig verhaal. eBook inbegrepen.',
        conversationPreviewTypeBookDescriptionWithPrice: '{count} delen · {unitBreakdown} · Volledige collectie. eBook inbegrepen.',
        conversationPreviewReassuranceShipping: 'Gratis wereldwijde levering',
        conversationPreviewExpressDeliveryLead: 'Expreslevering {where} vanaf',
        conversationPreviewExpressDeliveryDate: '{date}',
        conversationPreviewTypeBookTitle: 'Volledige collectie',
        conversationPreviewTypeHighlight: 'Aanbevolen',
        conversationPreviewTypePdfDescription: 'Bewaar uw gesprek als PDF. Dit bedrag telt mee voor het boek, als u dat later wilt.',
        conversationPreviewTypePdfTitle: 'Digitaal',
        conversationPreviewTypeSelectionTitle: 'Kies uw formaat',
    conversationProgress: 'Voortgang',
    conversationProviderButton: 'Ga naar de instellingen',
    conversationProviderType: 'Type',
    conversationRemoveButton: 'Verwijder de chat',
    conversationRemoveConfirmText: 'Door uw chat te verwijderen, worden uw mediabestanden van onze servers gewist en kunnen ze niet worden hersteld. Weet u het zeker?',
    conversationRemoveConfirmTitle: 'Chat verwijderen',
    conversationRemoveFlagConfirmMessage: 'Wilt u deze markering van de chat verwijderen?',
    conversationRemoveSuccess: 'Chat succesvol verwijderd!',
    conversationRestartProcess: 'Herstarten',
    conversationResumeButton: 'Bevestigen en afdrukken',
    conversationResumeConfirmText: 'Uw chat wordt gemarkeerd als "geverifieerd" en zal binnenkort worden gegenereerd en afgedrukt.',
    conversationValidateModificationsButton: 'Mijn wijzigingen bevestigen',
    conversationValidateModificationsConfirmTitle: 'Wijzigingen bevestigen?',
    conversationValidateModificationsConfirmBook: 'Uw boek gaat met uw wijzigingen terug in productie.',
    conversationValidateModificationsConfirmEbook: 'Uw eBook wordt opnieuw gegenereerd met uw wijzigingen en opnieuw naar uw gemaild.',
    conversationValidateModificationsConfirmMissingMedias: 'Sommige media uit uw gesprek ontbreken. Controleer ze voordat u bevestigt: uw boek gaat met de huidige wijzigingen in productie.',
    conversationValidateModificationsSuccessBook: 'Uw wijzigingen zijn opgeslagen. Uw boek gaat terug in productie.',
    conversationValidateModificationsSuccessEbook: 'Uw wijzigingen zijn opgeslagen. U opnieuw gegenereerde eBook wordt u per e-mail toegestuurd.',
    conversationValidateModificationsBackToList: 'Terug naar mijn gesprekken',
    conversationSelectThread: 'Selecteer een chat',
    conversationShareCancelButton: 'Nu niet',
    conversationShareConfirmButton: 'Onthul mijn records',
    conversationShareConfirmTitle: 'Kijk eens wat we hebben gevonden...',
    conversationShareConfirmText: 'Uw chat verbergt ongelooflijke records. We hebben ze omgezet in op maat gemaakte beelden, klaar om te delen.',
    conversationStatusConfigured: 'Wacht op generatie',
    conversationStatusDone: 'Voltooid',
    conversationStatusOngeneration: 'Wordt gegenereerd',
    conversationStatusOnproduction: 'In productie',
    conversationStatusOnvalidation: 'Wacht op druk',
    conversationStatusPending: 'In afwachting',
    conversationTypeAndroidDownloadAlt: 'Of kopieer en plak de link in uw favoriete browser',
    conversationTypeAndroidDownloadButton: 'Download de applicatie',
    conversationTypeAndroidIntroText1: 'Om uw SMS-boek vanaf een Android-telefoon te laten afdrukken, moet u uw smartphone gebruiken (Samsung, Xiaomi, Pixel, enz.).',
    conversationTypeAndroidIntroText2: 'Installeer de MonLivreSMS app op uw Android mobiel door op de volgende link te klikken (de app is niet beschikbaar in Google Play):',
    conversationTypeAndroidIntroText3: 'Kies de mede-auteur van uw herinnerings-SMS-boek, evenals de start- en einddatum van jullie verhaal.',
    conversationTypeAndroidIntroText4: 'Kies de namen van de hoofdrolspelers in jullie verhaal, schrijf uw voorwoord en personaliseer uw omslag.',
    conversationTypeAndroidIntroText5: 'Om het maken van uw boek af te ronden, maakt u een account aan en rondt u uw aankoop af via onze beveiligde betaalserver.',
    conversationTypeInstagramFileText1: 'Instagram stuurt u een e-mail zodat u het bestand kunt downloaden.',
    conversationTypeInstagramFileText2: 'Download het naar uw apparaat.',
    conversationTypeInstagramFileText3: 'Klik op de knop hieronder en selecteer het bestand in uw downloads zonder het te openen, en laat het in .zip formaat (bijvoorbeeld: *jouwnaam*_*datum*.zip). Alleen het gekozen gesprek wordt naar onze afdrukservices gestuurd.',
    conversationTypeInstagramProviderText1: 'Haal een kopie van uw Instagram-gegevens op via de algemene instellingen van uw account.',
    conversationTypeInstagramProviderText2: 'Voer het e-mailadres in dat aan uw Instagram-account is gekoppeld en kies het JSON-formaat.',
    conversationTypeInstagramProviderText3: 'Voer vervolgens uw wachtwoord in en klik op <strong>Download aanvragen</strong> om het genereren van uw back-up in Instagram te starten.',
    conversationTypeIosIntroText1: 'Sluit uw iPhone aan op uw COMPUTER en maak een ongecodeerde iTunes-back-up. (vink "Deze computer" aan, VINK "Lokale reservekopie coderen" UIT en klik op "Maak reservekopie").',
    conversationTypeIosIntroText2: 'Download de MonLivreSMS software door op de link te klikken die overeenkomt met het besturingssysteem van uw computer:',
    conversationTypeIosIntroText3: '<strong>LET OP, als de software geen back-up detecteert:</strong><br></br> - Voor MAC:<br></br>Ga naar Systeemvoorkeuren > Privacy en beveiliging > Volledige schijftoegang en voeg de MonLivreSMS-app toe door op het hangslot linksonder te klikken.<br></br> - Voor PC:<br></br>Voor uw veiligheid blokkeert Apple het lezen van uw back-up zonder uw toestemming.',
    conversationTypeMessengerFileText1: 'Facebook stuurt u een e-mail om het archief van uw chats te downloaden.',
    conversationTypeMessengerFileText2: 'Download het naar uw apparaat.',
    conversationTypeMessengerFileText3: 'Klik op de knop hieronder en selecteer het archief in uw downloads in .zip-formaat (bijvoorbeeld: facebook-*jouwnaam*.zip). Alleen de door u gekozen chat wordt verwerkt.',
    conversationTypeMessengerProviderText1: 'Haal een kopie van uw Facebook-gegevens op via de instellingen van uw account.',
    conversationTypeMessengerProviderText2: 'Klik op "Uw informatie downloaden".',
    conversationTypeMessengerProviderText3: `Stel vervolgens de volgende opties in:<br></br>
              <strong>Datumbereik</strong>: (wat u wilt)<br></br>
              <strong>Indeling</strong>: JSON<br></br>
              <strong>Mediakwaliteit</strong>: Laag (dit is voldoende voor het afdrukken en is veel sneller over te dragen)<br></br>
              <strong>Uw informatie</strong>: Selecteer alleen "Berichten" (vink de rest uit).`,
    'conversationTypeMessengerProviderText4': 'Let op: Zorg ervoor dat u het JSON-gegevensformaat selecteert (en niet HTML)!',
    'conversationTypeSnapchatProviderText1.1': 'Open de Snapchat-app op uw apparaat.',
    'conversationTypeSnapchatProviderText1.2': 'Tik linksboven op uw avatar (of Bitmoji) om naar uw profiel te gaan.',
    'conversationTypeSnapchatProviderText1.3': 'Tik rechtsboven op het tandwielpictogram om de Instellingen te openen.',
    'conversationTypeSnapchatProviderText2.1': 'Scrol naar beneden naar de sectie "Privacybeheer".',
    'conversationTypeSnapchatProviderText2.2': 'Selecteer "Mijn gegevens".',
    'conversationTypeSnapchatProviderText3.1': 'Er kan worden gevraagd om in te loggen om uw identiteit te verifiëren.',
    'conversationTypeSnapchatProviderText4.1': 'Op de pagina "Mijn gegevens" vind u een lijst met gegevens die u kunt downloaden, inclusief uw berichten.',
    'conversationTypeSnapchatProviderText4.2': 'Klik onderaan de pagina op "Aanvraag indienen".',
    'conversationTypeSnapchatProviderText5.1': 'Zodra uw aanvraag is verzonden, bereidt Snapchat het downloaden van uw gegevens voor.',
    'conversationTypeSnapchatProviderText5.2': 'Dit kan even duren, meestal een paar uur tot een dag.',
    'conversationTypeSnapchatProviderText5.3': 'U ontvangt een e-mail van Snapchat met een link om uw gegevens te downloaden wanneer het bestand klaar is.',
    'conversationTypeSnapchatProviderText6.1': 'Klik op de link in de e-mail om naar de downloadpagina te gaan.',
    'conversationTypeSnapchatProviderText6.2': 'Download het ZIP-bestand met uw gegevens.',
    'conversationTypeSnapchatProviderText7.1': 'Open het ZIP-bestand niet nadat het is gedownload.',
    'conversationTypeSnapchatProviderText7.2': 'Upload het volledige ZIP-bestand zoals het is in de daarvoor bestemde sectie van onze website.',
    'conversationTypeSnapchatProviderText7.3': 'Daarna kunt u de gewenste chat kiezen om uw boek te maken.',
    conversationTypeSnapchatProviderTitle1: '1. Toegang tot Snapchat-instellingen:',
    conversationTypeSnapchatProviderTitle2: '2. Uw Gegevens Aanvragen:',
    conversationTypeSnapchatProviderTitle3: '3. Authenticatie:',
    conversationTypeSnapchatProviderTitle4: '4. Downloaden van uw Gegevens:',
    conversationTypeSnapchatProviderTitle5: '5. Wachten op de E-mail:',
    conversationTypeSnapchatProviderTitle6: '6. Archief Downloaden:',
    conversationTypeSnapchatProviderTitle7: '7. Uploaden naar MonLivreSMS:',
    'conversationTypeTelegramProviderText1.1': 'Installeer de Telegram Desktop-app op uw pc of Mac via https://desktop.telegram.org/.',
    'conversationTypeTelegramProviderText1.2': 'Open de Telegram-app op uw computer.',
    'conversationTypeTelegramProviderText2.1': 'Open in de app de chat die u in een boek wilt veranderen door op de naam van uw contactpersoon te klikken.',
    'conversationTypeTelegramProviderText3.1': 'Klik op de drie puntjes in de rechterbovenhoek van de chat.',
    'conversationTypeTelegramProviderText3.2': 'Kies "Chatgeschiedenis exporteren".',
    'conversationTypeTelegramProviderText4.1': 'Selecteer in het instellingenvenster alle soorten bestanden die u wilt opnemen (foto\'s, video\'s, spraakberichten, enz.).',
    'conversationTypeTelegramProviderText4.2': 'Stel de groottelimiet in op het maximaal toegestane voor exporteren.',
    'conversationTypeTelegramProviderText4.3': 'Klik onderaan het venster op "Exporteren".',
    'conversationTypeTelegramProviderText5.1': 'Zoek de map met de geëxporteerde gegevens en comprimeer deze naar een ZIP-bestand (Rechtermuisklik > Kopiëren naar > Gecomprimeerde (gezipte) map).',
    'conversationTypeTelegramProviderText6.1': 'Upload het volledige ZIP-bestand op onze website.',
    conversationTypeTelegramProviderTitle1: '1. Telegram Desktop Installeren:',
    conversationTypeTelegramProviderTitle2: '2. De Chat Selecteren:',
    conversationTypeTelegramProviderTitle3: '3. De Geschiedenis Exporteren:',
    conversationTypeTelegramProviderTitle4: '4. Exportinstellingen:',
    conversationTypeTelegramProviderTitle5: '5. Comprimeren naar een ZIP-bestand:',
    conversationTypeTelegramProviderTitle6: '6. Bestand uploaden naar MonLivreSMS:',
    conversationTypeTitle: 'Een boek maken van de chat met {name}',
    conversationTypeWhatsappFileText1: 'Uw WhatsApp-chat ophalen',
    conversationTypeWhatsappFileText2: 'Klik op "Een bestand bijvoegen"',
    conversationTypeWhatsappFileText3: 'Upload uw gesprek',
    conversationTypeWhatsappFileText4: 'Als het bestand niet in het ".zip" formaat is, comprimeer het dan eerst.',
    conversationTypeWhatsappFileText5: 'Als u alleen de tekst van uw gesprek wilt (zonder foto\'s), upload dan uitsluitend het .txt-bestand',
    conversationTypeWhatsappProviderText1: 'Exporteer een kopie van uw WhatsApp-chat',
    conversationTypeWhatsappProviderText2: '<strong>Vanaf een Android:</strong><br></br>Open de WhatsApp-app<br></br>Ga naar de gewenste chat<br></br>Tik op "Meer" (de drie puntjes rechtsboven)',
    conversationTypeWhatsappProviderText3: '<strong>Vanaf iOS (iPhone):</strong><br></br>Open de WhatsApp-app<br></br>Ga naar de gewenste chat<br></br>Tik bovenaan op de naam van de contactpersoon of de groep<br></br>Scroll helemaal naar beneden en selecteer "Exporteer chat"',
    conversations: 'Chats',
    conversationsMy: 'Mijn chats',
    conversationsLuxEyebrow: 'Uw verhalen',
    conversationsLuxHint: 'Vind uw gesprekken terug en maak er een mooi boek van.',
    ordersLuxEyebrow: 'Het atelier',
    ordersLuxHint: 'Volg uw boeken, van het atelier tot bij u thuis.',
    ordersLuxDetailTitle: 'Uw boek',
    ordersLuxDetailHint: 'Volg uw boek, van het atelier tot aan uw deur.',
    ordersLuxViewFollow: 'Volg mijn boek',
    ordersLuxEmptyTitle: 'Uw eerste verhaal wacht op u.',
    ordersLuxEmptyHint: 'Maak van een gesprek een boek dat u steeds opnieuw wilt openslaan.',
    ordersLuxStepReceived: 'Ontvangen',
    ordersLuxStepAtelier: 'Atelier',
    ordersLuxStepPrint: 'Druk',
    ordersLuxStepShipped: 'Onderweg',
    ordersLuxStepHome: 'Bij u',
    ordersLuxStoryPendingpayment: 'Uw bestelling wacht op betaling om het atelier in te gaan.',
    ordersLuxStoryPending: 'We hebben uw bestelling ontvangen. Het atelier is er al mee bezig.',
    ordersLuxStoryOnpreparation: 'Uw boek krijgt vorm. Elke pagina wordt met zorg voorbereid.',
    ordersLuxStoryOnfabrication: 'Uw boek wordt gedrukt. Het verlaat binnenkort het atelier.',
    ordersLuxStoryShipped: 'Uw boek is onderweg. Het reist naar u toe.',
    ordersLuxStoryComplete: 'Uw boek is aangekomen. Het wacht alleen nog op uw handen.',
    ordersLuxStoryCanceled: 'Deze bestelling is geannuleerd. Uw herinneringen blijven veilig bij ons.',
    userProfileLuxEyebrow: 'Uw ruimte',
    userProfileLuxHint: 'Beheer uw gegevens, inlogmethodes en voorkeuren.',
    userProfileValueEmpty: 'Niet ingevuld',
    userProfileNotLinked: 'Niet gekoppeld',
    userProfileNewsletterOn: 'U ontvangt al ons nieuws en onze aanbiedingen.',
    userProfilePasswordOn: 'Ingesteld',
    addressesLuxEyebrow: 'Uw ruimte',
    addressesLuxHint: 'Vind uw lever- en factuuradressen.',
    addressesLuxEditHint: 'Dit adres kan dienen voor levering of facturatie.',
    conversationsNewApp: 'Nieuwe chats in de app',
    conversationsOldApp: 'Oude chats in de app',
    dashboardTitle: 'Dashboard',
    date: 'Datum',
    dateActivated: 'Activeringsdatum',
    dateCreated: 'Aanmaakdatum',
    dateLastCguAccept: 'Datum laatste acceptatie Algemene Voorwaarden',
    dateLastEdit: 'Datum laatste bewerking',
    dateLastLogin: 'Datum laatste login',
    dateSelect: 'Selecteer een datum',
    dateSelectPlaceholder: 'Klik hier om een datum te selecteren...',
    days: 'Dag(en)',
    daysCount: `{count} {count, plural,
        =0 {dag}
        =1 {dag}
        other {dagen}
    }`,
    delete: 'Verwijderen',
    deleteRequestError: 'Fout bij verwijderen!',
    deleteRequestSuccess: 'Succesvol verwijderd!',
    description: 'Beschrijving',
    detailsInformation: 'Details',
    domain: 'Domein',
    download: 'Downloaden',
    edit: 'Bewerken',
    editViewAdvanced: 'Geavanceerd bewerken',
    editViewSimplified: 'Eenvoudig bewerken',
    elementNoItems: 'Geen item',
    elementsCount: `{count} {count, plural,
              =0 {item}
              =1 {item}
              other {items}
          }`,
    example: 'Voorbeeld',
    examples: 'Voorbeelden',
    file: 'Bestand',
    fileDeleteError: 'Kan dit bestand niet verwijderen',
    fileDeleteSuccess: 'Bestand verwijderd!',
    fileSelected: 'Geselecteerd bestand: {file}',
    fileSwitch: 'Bestand wijzigen',
    fileUploadError: 'Kan dit bestand niet uploaden!',
    fileUploadProcessStartOnSave: 'Het uploaden van het bestand begint bij het opslaan.',
    fileUploadRestrictionTypeError: 'Bestandsformaat niet geldig! Toegestaan: {types}',
    fileUploadSuccess: 'Bestand succesvol geüpload!',
    files: 'Bestanden',
    filtersTitle: 'Filters',
    finish: 'Afronden',
    flags: 'Vlaggen',
    free: 'Gratis',
    generalInformation: 'Algemene informatie',
    help: 'Hulp',
    hours: 'Uren',
    hoursCount: `{count} {count, plural,
        =0 {uur}
        =1 {uur}
        other {uren}
    }`,
    imageDeleteError: 'Kan deze afbeelding niet verwijderen!',
    imageDeleteSuccess: 'Afbeelding verwijderd!',
    imageUploadError: 'Kan deze afbeelding niet uploaden',
    imageUploadRestrictionSize: 'De afbeelding mag maximaal {format} groot zijn',
    imageUploadRestrictionType: 'De afbeelding moet in het formaat {types} zijn',
    imageUploadRestrictionTypeError: 'Afbeeldingsformaat niet geaccepteerd! Toegestaan: {types}',
    import: 'Importeren',
    importModelDownloadButton: 'Sjabloon downloaden',
    importRequestError: 'Er is een fout opgetreden tijdens het importeren!',
    importRequestSomeFailAlert: 'Een of meer elementen konden niet worden geïmporteerd!',
    importRequestSuccess: 'Gegevens succesvol geïmporteerd!',
    importerFileButton: 'Gegevens importeren',
    importerFileHelp: 'U kunt een CSV-bestand maken met uw spreadsheetprogramma (Excel, OpenOffice, ...)',
    importerFileInfo: 'Selecteer een CSV-bestand (Waarden gescheiden door komma\'s)',
    importerNoItemsAlert: 'Geen elementen om te importeren',
    importerTitle: 'Gegevens importeren',
    information: 'Informatie',
    informationsDetails: 'Details',
    informationsGeneral: 'Algemene informatie',
    invoicePrint: 'De factuur afdrukken',
    invoicesPrint: 'De facturen afdrukken',
    isActive: 'Actief?',
    isPublic: 'Is openbaar?',
    isUnlimited: 'Onbeperkt?',
    label: 'Naam/Label',
    language: 'Taal',
    languageAR: 'Arabisch',
    languageBN: 'Bengaals',
    languageDE: 'Duits',
    languageEN: 'Engels',
    languageES: 'Spaans',
    languageFR: 'Frans',
    languageHI: 'Hindi',
    languageIT: 'Italiaans',
    languageJA: 'Japans',
    languagePT: 'Portugees',
    languageRU: 'Russisch',
    languageZH: 'Chinesisch',
    learnMoreButton: 'Meer weten',
    limitLabel: 'Limiettype',
    limitTextForm1: 'moet een',
    listTitle: 'Lijst',
    loading: 'Laden...',
    logo: 'Logo',
    minutes: 'Minuut/minuten',
    name: 'Naam',
    next: 'Volgende',
    no: 'Nee',
    of: 'van',
    options: 'Opties',
    order: 'Bestelling',
    orderAdd: 'Een bestelling toevoegen',
    orderAddTitle: 'Een bestelling aanmaken',
    orderAddressPrivacyInfo: ' Uw adres wordt niet openbaar gemaakt! Alleen de andere deelnemers aan deze bestelling kunnen dit zien.',
    orderAddressShippingValid: 'Bezorgadres bevestigen',
    orderBilling: 'Facturatie',
    orderConfirmationPaymentError: 'Er is een fout opgetreden... Neem alstublieft contact met ons op!',
    orderConfirmationPaymentWaiting: 'Een moment geduld alstublieft... We verwerken uw betaling om uw bestelling te bevestigen.',
    orderConfirmationPendingText: 'Uw bestelling wacht op betaling om te worden afgerond! Klik op de onderstaande link om uw aankoop te voltooien door de betaling te verrichten.',
    orderConfirmationPendingText2: 'LET OP: Als u met een bankkaart betaalt, kan de validatie van de betaling enkele minuten duren. Wacht even terwijl we de veiligheidscontroles uitvoeren.',
    orderConfirmationPendingTitle: 'Bestelling wacht op betaling!',
    orderConfirmationSocialText: 'Volg ons op uw favoriete sociale media om niets te missen van onze nieuwtjes, nieuwe producten en exclusieve acties...',
    orderConfirmationSocialTitle: 'Laten we contact houden!',
    orderConfirmationText: ' Uw bestelling is succesvol geregistreerd en wordt voorbereid. U ontvangt een e-mail zodra deze is verzonden.',
    orderConfirmationTitle: 'Bestelling ontvangen!',
    orderContent: 'Inhoud van de bestelling',
    orderDetails: 'Details',
    orderId: 'Identificatie',
    orderInfoCommentAlertTitle: 'Belangrijk bericht',
    orderInvoice: 'Factuur',
    orderInvoicePrintButton: 'De factuur afdrukken',
    orderItemsEmpty: 'Er bevindt zich geen enkel artikel in uw bestelling',
    orderItemViewBook: 'Bekijk mijn boek',
    orderItemsTotal: 'Totaal aantal artikelen:',
    orderMassStatusConfirmMessage: 'Status van {count} bestelling(en) bijwerken?',
    orderNoItems: 'U heeft nog geen enkele bestelling geplaatst!',
    orderNoteCustomer: 'Klantnotitie',
    orderPaymentChooseMethodLabel: 'Kies een betaalmethode',
    orderPaymentFinishTitle: 'Uw betaling afronden',
    orderPaymentValidButton: 'De betaling bevestigen',
    orderPayments: 'Betalingen',
    orderProcessInvitationText: 'Nodig uw vrienden uit om het vak in te vullen',
    orderProcessInvitationTextBefore1: 'Directos.eu is een groepsaankoopdienst voor particulieren waarmee uw producten rechtstreeks bij fabrikanten kunt kopen. U bespaart zowel op de prijs van de producten ALS op de verzendkosten!',
    orderProcessInvitationTextBefore2: 'Maak u geen zorgen! Wij hebben de oplossing:',
    orderProductAdd: 'Een product toevoegen',
    orderRefunds: 'Terugbetalingen',
    orderShipping: 'Verzending',
    orderShippingAdd: 'De verzending toevoegen',
    orderShippingFee: 'Verzendkosten',
    orderShippingRemoveConfirmMessage: 'Weet u zeker dat u deze verzending uit de bestelling wilt verwijderen?',
    orderShippingTrackingTitle: 'Volg uw bestelling',
    orderShippingTrackingButton: 'Volg mijn pakket',
    orderShippingTrackingHint: 'De tracking kan enkele uren duren voordat deze bij de vervoerder verschijnt.',
    orderShippings: 'Verzendingen',
    orderStatus: 'Status',
    orderStatusCanceled: 'Geannuleerd',
    orderStatusComplete: 'Voltooid',
    orderStatusOnpreparation: 'In voorbereiding',
    orderStatusOnprogress: 'In behandeling',
    orderStatusPending: 'In afwachting',
    orderStatusPendingpayment: 'Wachtend op betaling',
    orderStatusShipped: 'Verzonden',
    orderSubtotalDiscount: 'Korting',
    orderSubtotalExclTax: 'Subtotaal (excl. btw)',
    orderSubtotalInclTax: 'Subtotaal (incl. btw)',
    orderTax: 'Btw',
    orderThanks: 'Bedankt voor uw bestelling',
    attributionPaidLine: 'De betaling is gelukt',
    attributionSkip: 'Mijn bestelling bekijken',
    attributionSourceTitle: 'Wat gaf u zin in dit boek?',
    attributionSourceLead: 'Uw bestelling staat al. Eén antwoord vertelt ons wat u aansprak.',
    attributionSearchTitle: 'Kende u MonLivreSMS al voordat u ging zoeken?',
    attributionSearchLead: 'Een naam die u al kende, of iets nieuws.',
    attributionOccasionTitle: 'Voor welke gelegenheid is dit boek?',
    attributionOccasionLead: 'De gelegenheid waar u aan denkt.',
    attributionOtherPlaceholder: 'Een paar woorden, als u wilt',
    attributionOtherContinue: 'Verder',
    attributionSaveError: 'Dit antwoord is niet opgeslagen. Probeer het opnieuw.',
    attributionOpt_bouche_a_oreille: 'Iemand uit mijn omgeving vertelde het me',
    attributionOpt_vu_objet: 'Ik zag het boek bij iemand thuis',
    attributionOpt_receveur_devenu_client: 'Ik kreeg er een cadeau, nu ben ik aan de beurt',
    attributionOpt_recherche: 'Door te zoeken op Google',
    attributionOpt_instagram: 'Instagram',
    attributionOpt_tiktok: 'TikTok',
    attributionOpt_facebook: 'Facebook',
    attributionOpt_pinterest: 'Pinterest',
    attributionOpt_qvema: 'Qui veut être mon associé',
    attributionOpt_medias: 'Een artikel, een uitzending of een podcast',
    attributionOpt_client_existant: 'Ik had hier al eens besteld',
    attributionOpt_autre: 'Iets anders',
    attributionOpt_decouverte_pure: 'Eerder toeval',
    attributionOpt_pre_bao: 'Iemand uit mijn omgeving had het verteld',
    attributionOpt_pre_tv: 'Ik had het op tv gezien',
    attributionOpt_pre_social: 'Ik had het op sociale media gezien',
    attributionOpt_pre_inconnu: 'Ik weet het niet meer',
    attributionOpt_anniv_couple: 'De verjaardag van onze ontmoeting',
    attributionOpt_noel: 'Kerst',
    attributionOpt_saint_valentin: 'Valentijnsdag',
    attributionOpt_anniversaire: 'Een verjaardag',
    attributionOpt_deuil: 'De berichten van iemand die ik ben verloren',
    attributionOpt_naissance: 'Een geboorte',
    attributionOpt_distance: 'Iemand die vertrekt, of ver weg woont',
    attributionOpt_pour_soi: 'Voor mezelf, niet om cadeau te doen',
    attributionOpt_autre_occasion: 'Een ander moment',
    bookIntentTitle: 'Dit boek is voor...',
    bookIntentLead: 'Eén antwoord, en we beginnen.',
    bookIntentSkip: 'Overslaan',
    bookIntentOpt_anniv_couple: 'De dag dat we elkaar leerden kennen',
    bookIntentOpt_anniversaire: 'Iemands verjaardag',
    bookIntentOpt_noel: 'Kerst',
    bookIntentOpt_saint_valentin: 'Valentijnsdag',
    bookIntentOpt_souvenir: 'Iemand die er niet meer is',
    bookIntentOpt_plus_tard: 'Een latere datum',
    bookIntentOpt_autre: 'Iets anders',
    bookIntentDate_anniv_couple: 'Welke datum is het?',
    bookIntentDateLead_anniv_couple: 'De dag dat u elkaar ontmoette, of de dag die u samen viert.',
    bookIntentDate_anniversaire: 'Op welke dag is de verjaardag?',
    bookIntentDateLead_anniversaire: 'De verjaardag van de persoon voor wie u het boek maakt.',
    bookIntentDate_plus_tard: 'Rond welke datum?',
    bookIntentDateLead_plus_tard: 'De dag die u in gedachten heeft.',
    bookIntentDateDefer: 'De datum vul ik later in',
    bookIntentDateBack: 'Terug',
    bookIntentDateContinue: 'Verder',
    bookIntentSaveError: 'We konden het antwoord niet opslaan. Probeer het opnieuw.',
    inboxPromptTitle: 'Voor uw boek',
    inboxPromptSignup: 'We hebben u net een mail gestuurd, « {subject} ». Dit is het begin van uw boek, geen reclame. {provider} legt hem soms apart. Markeer hem als « {mark} ». Met dit gebaar komt het vervolg goed bij u aan, met wat u nodig hebt om het echt goed te maken.',
    inboxPromptTransfer: 'We hebben u net een mail gestuurd, « {subject} ». Dit is de link naar uw gesprek, geen reclame. {provider} legt hem soms apart. Markeer hem als « {mark} ». Met dit gebaar hebt u alles bij de hand om het boek te maken dat u wilt.',
    inboxPromptMarkGmail: 'Geen spam',
    inboxPromptMarkYahoo: 'Geen spam',
    inboxPromptButton: 'Ik bevestig in {provider}',
    inboxPromptClose: 'Sluiten',
    inboxPromptConfirm: 'We hebben u net een mail gestuurd, « {subject} ». Die opent uw account. {provider} legt hem soms apart. Markeer hem als « {mark} ». Met dit gebaar komt het vervolg bij u aan.',
    emailConfirmPageTitle: 'Bevestig uw adres',
    emailConfirmTitle: 'Kijk in uw mail',
    emailConfirmLead: 'We hebben u net een mail gestuurd om uw account te openen. De knop daarin bevestigt uw adres.',
    emailConfirmResend: 'De mail opnieuw sturen',
    emailConfirmResent: 'De mail is weer onderweg.',
    emailConfirmExpired: 'Deze link is verlopen. Vraag een nieuwe aan vanuit uw account.',
    emailConfirmInvalid: 'Deze link hoort bij geen enkel account.',
    emailConfirmWorking: 'Account openen…',
    orderTotal: 'TOTAAL',
    orderTotalTTC: 'Totaal (incl. btw)',
    orderTotalTax: 'Btw {rate}%',
    orderTotalToPay: 'Totaal te betalen bedrag: {total}€',
    orderTotals: 'Totalen',
    orderUserRegisterAlert: 'U moet uw e-mailadres opgeven zodat we contact met u kunnen opnemen als er een probleem is met uw bestelling.',
    orderView: 'De bestelling bekijken',
    orderWeight: 'Gewicht',
    orderitemAddProductTitle: 'Artikelgegevens bewerken',
    orders: 'Bestellingen',
    ordersContactTitle: 'Contact opnemen over een bestelling',
    ordersMy: 'Mijn bestellingen',
    ordersMyViewButton: 'Mijn bestellingen bekijken',
    packingInformation: 'Verpakkingsinformatie',
    parcelGroupInfo: ' Groepeer de verzending op aantal pakketten',
    parcelGroupLabel: 'Groep pakketten',
    parcelGroupWeightInfo: 'Kg per pakket',
    parcelGroupWeightLabel: 'Groepeer de verzending op gewicht',
    paymentCardInputLabel: 'Voer de gegevens van uw kaart in om uw bestelling te bevestigen.',
    paymentMethodCreditbalanceDescription1: 'Wordt automatisch van het totaal afgetrokken',
    paymentMethodCreditbalanceDescription2: 'Nog te betalen',
    paymentMethodCreditbalancePay: 'Bevestigen met mijn tegoed',
    paymentMethodCreditbalanceTitle: 'Tegoed al toegepast',
    paymentFailError: 'Uw betaling is mislukt! Probeer het alstublieft opnieuw.',
    paymentMethod: 'Betaalmethode',
    paymentMethodBancontactLabel: 'Bancontact',
    paymentMethodBankcheckLabel: 'Bankcheque',
    paymentMethodBanktransferLabel: 'Bankoverschrijving',
    paymentMethodCardLabel: 'Bankkaart',
    paymentMethodCreditcardLabel: 'Bankkaart',
    paymentMethodCreditDescription1: 'Dit bedrag wordt automatisch afgetrokken van het openstaande bedrag van uw winkelwagen.',
    paymentMethodGiropayLabel: 'Giropay',
    paymentMethodIdealLabel: 'iDEAL',
    paymentMethodPhoneLabel: 'Telefoon',
    paymentMethodCreditPay: 'Betalen met mijn credits',
    paymentMethodCreditTitle: 'U heeft al een deel van uw bestelling betaald:',
    paymentValidButton: 'Mijn betaling bevestigen',
    previous: 'Vorige',
    priceInformation: 'Prijsinformatie',
    priceRoundAlertTooltip: 'Deze prijs kan licht zijn afgerond door valutaomrekening.',
    printButton: 'Afdrukken',
    process: 'Proces',
    productAnnexes: 'Bijlagen',
    productAnnexesNewProductError: 'Sla uw nieuwe product eerst op voordat uw bijlagen toevoegt!',
    productAttributes: 'Attributen',
    productConversationTypeMissingAlert: 'Er is geen product gekoppeld aan het geselecteerde type. Neem contact met ons op om dit op te lossen!',
    productCostHT: 'Kosten (excl. btw)',
    productDescription: 'Beschrijving',
    productEdit: 'Het product bewerken',
    productImages: 'Afbeeldingen',
    productImagesNewProductError: 'Sla uw nieuwe product eerst op voordat uw afbeeldingen toevoegt!',
    productIsActive: 'Actief?',
    productName: ' Naam',
    productPictureDelete: 'De afbeelding verwijderen',
    productPriceHT: 'Prijs (excl. btw)',
    productPriceTTC: 'Prijs (incl. btw)',
    productReference: 'Referentie',
    productSlug: 'Slug',
    productSpecialPriceQuantityDiscountInfo: 'Bespaar {percent}% op uw aankoop door {quantity} exemplaren toe te voegen!',
    productTaxCalculate: 'Berekenen',
    productTaxRate: 'Btw-tarief',
    productTaxRateFormHelp: 'Voor 21% btw, vul 0.21 in',
    productUseForConversationBook: 'Beschikbaar voor papieren boeken?',
    productUseForConversationEBook: 'Beschikbaar voor eBooks (digitaal)?',
    productUseForCredit: 'Gebruiken voor de gebruikerscredits?',
    products: 'Producten',
    productsView: 'De producten bekijken',
    quantity: 'Aantal',
    refresh: 'Vernieuwen',
    refundCreateTitle: 'Een terugbetaling aanmaken',
    refundCreateConfirmMessage: 'Weet u zeker dat u deze terugbetaling wilt aanmaken?',
    remove: 'Verwijderen',
    retry: 'Opnieuw proberen',
    save: 'Opslaan',
    saveBeforeAlert: 'Sla eerst de wijzigingen op...',
    saveRequestError: 'Fout bij het opslaan!',
    saveRequestSuccess: 'Succesvol opgeslagen!',
    saving: 'Bezig met opslaan...',
    searchFor: 'Zoeken',
    seconds: 'Seconde(n)',
    select: 'Selecteren',
    selectAll: 'Alles selecteren',
    selectFile: 'Een bestand selecteren',
    selectImage: 'Selecteer een afbeelding',
    selectOptions: 'Selecteer een optie',
    selectUnAll: 'Alles deselecteren',
    seoTitle: 'Druk uw SMS en WhatsApp-chats af in een boek',
    shippingAddressEdit: 'Het bezorgadres bewerken',
    shippingAddressMissingError: 'U heeft geen bezorgadres ingevoerd.',
    shippingCalculation: 'Berekening',
    shippingCalculationInfo: 'Als de berekening vastloopt in een lus, is het beter om de inclusieve maximumlimiet te gebruiken.',
    shippingCarrier: 'Vervoerder',
    shippingChronopostPickupError: 'We konden de afhaalpunten niet laden! Controleer het land en de postcode voordat u het opnieuw probeert.',
    shippingChronopostPickupNoResult: 'We hebben geen afhaalpunt in de buurt gevonden. Zoek met een ander adres of andere postcode.',
    shippingChronopostPickupOpeningHours: 'Openingstijden',
    shippingChronopostPickupOpeningHoursView: 'Bekijk de openingstijden',
    shippingChronopostPickupViewList: 'Bekijk als lijst',
    shippingChronopostPickupViewMap: 'Bekijk op de kaart',
	shippingPickupError: 'Kan de afhaalpuntkiezer niet openen. Probeer het later opnieuw.',
	shippingPickupChange: 'Afhaalpunt wijzigen',
	shippingPickupChoose: 'Kies een afhaalpunt',
    shippingCountrySelect: 'Land van levering',
    shippingDeleteConfirmMessage: 'Weet u zeker dat u deze verzendmethode wilt verwijderen?',
    shippingDeliveryEstimationDate1: 'Geschatte leverdatum: {date}',
    shippingDeliveryEstimationDate2: 'Geschatte leverdatum: tussen {date1} en {date2}',
    shippingDeliveryEstimationText: 'Dit is slechts een schatting van de verzendkosten. U kunt in de volgende stap uw exacte afleverpunt kiezen.',
    shippingSurchargeCorsica: 'Dit tarief bevat een Corsica-toeslag van {price}.',
    shippingSurchargeOverseas: 'Dit tarief bevat een toeslag van {price} voor overzeese gebieden.',
    shippingSurchargeRemote: 'Dit tarief bevat een toeslag van {price} voor moeilijk bereikbare gebieden.',
    shippingDeliveryTime: 'Levertijd (in dagen)',
    shippingDeliveryTimeInfo: 'Levering in {days} werkdagen',
    shippingDescription: 'Beschrijving',
    shippingExcludeDepartmentInfo: 'Scheid de uit te sluiten postcodes met een komma (,). U kunt "*" gebruiken als jokerteken.',
    shippingExcludeDepartmentLabel: 'Postcodes uitsluiten',
    shippingExtraFeeCalculation: 'Berekening van de extra verzendkosten',
    shippingExtraFeeLabel: 'Label voor extra verzendkosten',
    shippingExtraFees: 'Extra kosten',
    shippingFeeCalculatorTitle: 'Bereken uw verzendkosten',
    shippingFeeFreeDelivery: 'Gratis verzending!',
    shippingFeeNotFoundError: '',
    shippingFeeWithBookResult: 'Bestel nu en ontvang uw eBook direct, en uw afgedrukte boeken in {countryName} tussen {deliveryDateFrom} en {deliveryDateTo}.',
    shippingFeeWithoutBookResult: 'Bestel nu en ontvang uw eBook direct in uw e-mail.',
    shippingFreeStep: 'Drempel voor gratis verzending',
    shippingFreeTreshold: 'Bedrag voor gratis verzending',
    shippingFreeInfo: 'Gratis verzending vanaf {value}',
    shippingIdentifier: 'Verzend-ID',
    shippingIsPriceTTC: 'Is de prijs van de verzending inclusief btw?',
    shippingLabelGenerateButton: 'Het label genereren',
    shippingLabelGenerateButton2: 'Het label opnieuw genereren',
    packingCheckTitle: 'De boeken van deze bestelling',
    packingCheckHint: 'Houd één boek tegelijk met de achterkant naar de camera. Als de teller stijgt, legt u het buiten beeld en pakt u het volgende.',
    packingCheckProgress: '{seen} / {expected}',
    packingCheckForeign: 'Dit boek hoort bij bestelling {code}. Haal het uit het pakket.',
    packingCheckReady: 'Klopt. Dit zijn de boeken van deze bestelling. U kunt het label afdrukken.',
    packingCheckOverflow: 'Er zijn te veel boeken gelezen. Begin opnieuw.',
    packingCheckRestart: 'Opnieuw beginnen',
    packingCheckCameraStart: 'Camera openen',
    packingCheckCameraDenied: 'De camera is geblokkeerd. Sta hem toe, of scan de QR-code met de scanner.',
    packingCheckLocked: 'Scan alle boeken voordat u het label afdrukt.',
    packingCheckWedgeLabel: 'Of scan de QR-code met de scanner',
    packingCheckLoading: 'De boeken van deze bestelling worden geladen.',
    prepBooksCardTitle: 'Boeken',
    prepBooksCount: '{count, plural, one {# boek} other {# boeken}}',
    prepBooksPageEyebrow: 'Voorbereiding',
    prepBooksPageTitle: 'Bestelling {code}',
    prepBooksPageHint: 'De boeken die in dit pakket gaan.',
    prepModeClient: 'Klantweergave',
    prepModePreparation: 'Voorbereidingsweergave',
    shippingLegacyChronopostPaused: 'Deze bestelling staat nog op het eerdere Chronopost. Zet de verzendmethode via Bewerken op een Sendcloud-aanbod en maak daarna het label.',
    shippingMethodCalculating: 'Verzendopties berekenen...',
    shippingMethodConditions: 'Verzendvoorwaarden',
    shippingMethodMissingAlert: 'We hebben geen beschikbare vervoerder voor uw winkelwagen gevonden. Wijzig het adres of kies een andere vervoerder.',
    shippingMethodNotAvailable: 'Er zijn geen bezorgopties beschikbaar voor uw adres...',
    shippingRatesError: 'Het berekenen van de verzendkosten is onderbroken. Probeer het zo meteen opnieuw. Gebeurt het nog een keer? Stuur ons dan een bericht, dan kijken we met u mee.',
    shippingMethodPricing: 'Tarieven',
    shippingMethodPricingSystem: 'Tariferingssysteem',
    shippingMethodSearch: 'Zoeken naar verzendopties...',
    shippingMethodSelectTitle: 'Selecteer uw verzendmethode',
    shippingGroupRelay: 'Afhaalpunt',
    shippingGroupHome: 'Thuisbezorging',
    shippingTierClassic: 'Standaardlevering',
    shippingTierExpress: 'Expresslevering',
    shippingTierClassicDesc: 'Standaard levertijd',
    shippingTierExpressDesc: 'De snelste optie',
    shippingTierPriceRelayFree: 'Gratis bij afhaalpunt',
    shippingTierPriceRelayFrom: 'Vanaf {price} bij afhaalpunt',
    shippingTierPriceHomeFrom: '{price} thuisbezorgd',
    shippingChangeTier: 'Leveringssnelheid wijzigen',
    shippingTierModeTitle: 'Kies uw leveringswijze',
    shippingStepOf: 'Stap {current} van {total}',
    shippingStepSpeedTitle: 'Wanneer wilt u uw bestelling ontvangen?',
    shippingStepModeTitle: 'Waar wilt u uw bestelling ontvangen?',
    shippingMethodTrackingInfo: 'Trackinginformatie',
    shippingMethods: 'Verzendmethoden',
    shippingOrder: 'Verzendopdracht',
    shippingProvider: 'Logistieke dienstverlener',
    shippingStep: 'Stap',
    shippingStepInfo: 'Deze stap MOET de linker parameter zijn! De bovenste parameter is de standaard postcode.',
    shippingStepLimitInfo: 'Is de linker voorwaarde het minimum/maximum?',
    shippingTaxRate: 'Btw-tarief van de verzending',
    shippingTitle: 'Levering',
    shippingTrackingNumber: 'Trackingnummer',
    shippingTrackingParcelUrl: 'URL om het pakket te volgen',
    status: 'Status',
    stepTitle: 'Stap {step}',
    submit: 'Verzenden',
    suborderitemAddProductTitle: 'Een product toevoegen',
    switchLanguage: 'Taal wijzigen',
    tableMassActions: 'Bulkacties',
    tableRefreshSuccessAlert: 'Succesvol gesynchroniseerd!',
    tableRefreshSuccessError: 'Synchronisatiefout!',
    tableSelection: `{count} {count, plural,
			  =0 {geselecteerd}
			  =1 {geselecteerd}
			  other {geselecteerd}
		  }`,
    tag: 'Tag',
    tagFillPlaceholder: 'Voer een trefwoord in...',
    tags: 'Tags',
    taskDescription: 'Beschrijving',
    taskEditTitle: 'De taak bewerken',
    taskPriority: 'Prioriteit',
    taxRate: 'Btw',
    the: 'de/het',
    time: 'Tijd',
    timezone: 'Tijdzone',
    title: 'Titel',
    toleranceLabel: 'Tolerantie',
    total: 'Totaal',
    type: 'Type',
    unit: 'Eenheid',
    user: 'Gebruiker',
    userAccountCreditsTitle: 'Mijn tegoed',
    userAccountDataProtection: 'Gegevensbescherming',
    userAccountDataProtectionText1: 'Wij nemen de bescherming van uw persoonlijke gegevens zeer serieus. Daarom beloven wij ze veilig te bewaren en bewaren we ze alleen voor de tijd die strikt noodzakelijk is om u onze dienst te kunnen verlenen.',
    userAccountDataProtectionText2: 'We vragen u alleen om de strikt noodzakelijke informatie. We zullen uw gegevens nooit delen met derden of deze voor commerciële doeleinden gebruiken zonder uw uitdrukkelijke toestemming.',
    userAccountDataProtectionText3: 'Als u uw gegevens wilt downloaden of uw recht om vergeten te worden wilt uitoefenen, neem dan contact met ons op via {email}.',
    userAccountDelete: 'Mijn account verwijderen',
    userAccountDeleteActiveSuborder: 'U kunt uw account niet verwijderen zolang u nog lopende bestellingen hebt!',
    userAccountDeleteBlockText: 'U kunt uw account momenteel niet verwijderen!',
    userAccountDeleteButton: 'Mijn account definitief verwijderen',
    userAccountDeleteConfirmMessage: 'Weet u heel zeker dat u uw account voor altijd wilt verwijderen?',
    userAccountDeleteConfirmTitle: 'Mijn account verwijderen',
    userAccountDeleteError: 'We konden uw account niet verwijderen!',
    userAccountDeleteSuccess: 'Uw account is verwijderd! We hopen u snel weer te zien!',
    userAccountDeleteText: 'Als u uw account verwijdert, verliest u de toegang tot uw hele geschiedenis en uw opgeslagen boeken. We zullen al uw persoonlijke gegevens veilig van onze servers verwijderen. Deze actie is onomkeerbaar!',
    userAccountEdit: 'Mijn gegevens wijzigen',
    userAccountEditSuccess: 'Profiel succesvol bijgewerkt',
    userAccountExistError: 'Er bestaat geen account dat aan dit e-mailadres is gekoppeld!',
    userAccountExistTitle: 'Heeft u al een account bij ons?',
    userAccountGeneral: 'Algemeen',
    userAccountHistory: 'Geschiedenis',
    userAccountInfo: 'Uw gegevens zijn beschermd en blijven strikt vertrouwelijk.',
    userAccountInfoMyTitle: 'Mijn persoonlijke gegevens',
    userAccountMy: 'Mijn account',
    userAccountPersonnalInformation: 'Mijn persoonlijke informatie',
    userAccountPreferencesInformation: 'Mijn voorkeuren',
    userAccountResetError: 'Fout bij een poging om het account te herstellen!',
    userAccountResetSuccess: 'Account succesvol hersteld!',
    userActivityOnLine: 'Online',
    userAdd: 'Een gebruiker toevoegen',
    userAddNew: 'Een nieuwe gebruiker toevoegen',
    userBridgeError: 'Aanmelden vanuit de app is mislukt. Probeer het opnieuw.',
    userBridgeInvalid: 'Deze aanmeldlink is niet meer geldig. Start het aanmelden opnieuw vanuit de app.',
    userBridgePending: 'Bezig met aanmelden…',
    userBridgeSuccess: 'U bent aangemeld! U kunt nu terug naar de app.',
    userChangePasswordSuccess: 'Wachtwoord bijgewerkt!',
    userConfirmationCode: 'Bevestigingscode per e-mail ontvangen',
    userConfirmationCodeCheckButton: 'Ik heb de code al om mijn wachtwoord te resetten',
    userConfirmationCodeError: 'Voer de bevestigingscode in die we u per e-mail hebben gestuurd!',
    userConnectionInfo: 'Log in om uw bestelling te bevestigen en uw boek op te slaan!',
    userCredits: 'Credits',
        userCreditsBalancePositive: 'U heeft {amount} tegoed: wordt automatisch toegepast bij de volgende stap.',
    userCreditsPrepaymentInviteTitle: 'Vooruitbetaling van uw boek',
    userDeleteConfirmTitle: 'Gebruiker verwijderen',
    userDeleteConfirmMessage: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
    userDeleteConfirmation: 'De gebruiker {user} is verwijderd!',
    userEdit: '{user} bewerken',
    userEdit2: 'De gebruiker bewerken',
    userEditPassword: 'Mijn wachtwoord wijzigen',
    userEmail: 'E-mailadres',
    userEmailError: 'Het e-mailadres is ongeldig!',
    userEmailFillInfo: 'Voer uw e-mail in',
    userEmailFormInfo: 'Typ uw e-mail in om door te gaan',
    userEmailFormInfo2: 'We gebruiken uw e-mail om uw account veilig aan te maken en u de tracking van uw bestelling te sturen.',
    userLoginCodeTitle: 'U heeft al een account',
    userLoginCodeIntro: 'We hebben zojuist een code van 6 cijfers naar {email} gestuurd. Vul deze hier in om verder te gaan.',
    userLoginCodeLabel: 'Code uit de e-mail',
    userLoginCodeSubmit: 'Bevestigen',
    userLoginCodeInvalid: 'Deze code klopt niet. Controleer de laatste e-mail die u heeft ontvangen.',
    userLoginCodeExpired: 'Deze code is niet meer geldig. Vraag hieronder een nieuwe aan.',
    userLoginCodeError: 'Oeps, dat ging mis. Probeer het zo meteen opnieuw.',
    userLoginCodeLinkHint: 'Dezelfde e-mail bevat ook een inloglink.',
    userLoginCodeResend: 'Nieuwe code sturen',
    userLoginCodeResendIn: 'Nieuwe code sturen over {seconds} s',
    userLoginCodeResent: 'Opnieuw verstuurd. Kijk ook even in uw spammap.',
    userLoginCodeChangeEmail: 'Een ander e-mailadres gebruiken',
    userLoginCodeCartSuccess: 'U bent ingelogd. U kunt uw bestelling nu afronden.',
    userEnvironmentTestNoTest: 'Deze gebruiker heeft geen enkele omgevingstest uitgevoerd!',
    userFillPlaceholder: 'Voer de naam van een gebruiker in...',
    userFirstName: 'Voornaam',
    userForgotPassword: 'Bent u uw wachtwoord vergeten?',
    userForgotPasswordRetryDateError: 'U kunt nog geen nieuwe code aanvragen. Controleer uw inbox (en uw spammap) om deze te vinden.',
    userFormInfo: 'Vul uw profiel aan',
    userGenderLabel: 'Geslacht',
    userIsActive: 'Actief?',
    userLastName: 'Achternaam',
    userLogin: 'Inloggen',
    userLoginAction: 'Binnenkomen',
    userLoginEmailSelected: 'Inloggen met het e-mailadres: {email}',
    userLoginError: 'Onjuiste gegevens! Probeer het opnieuw...',
    userLoginFirstButton: 'Is dit uw eerste keer hier?',
    userLoginFirstText: 'Controleer uw inbox: we hebben u een tijdelijk wachtwoord gestuurd. Gebruik dit voor uw eerste keer inloggen. U kunt het gemakkelijk wijzigen in uw profiel.',
    userLoginBenefit1: 'Uw SMS-fotoboek in enkele klikken',
    userLoginBenefit2: 'Snelle levering aan huis',
    userLoginBenefit3: '100% veilig betalen',
    userLoginIntro: 'Identificeer uzelf om toegang te krijgen tot uw boeken en uw persoonlijke ruimte.',
    userLoginWelcomeSubtitle: 'Verander uw SMS\'jes in een prachtig gedrukt fotoboek.',
    userLoginWelcomeTitle: 'Welkom!',
    userLoginNoConnexion: 'Geen verbinding',
    userLoginTitle: 'Inloggen',
    userLogout: 'Uitloggen',
    userName: 'Naam',
    userNewPassword: 'Nieuw wachtwoord',
    userNewsletterSubscribeButton: 'Inschrijven voor de nieuwsbrief',
    userNewsletterText1: 'Ontvang cadeau-ideeën, exclusieve kortingen en onze laatste nieuwtjes direct in uw mailbox.',
    userOldPassword: 'Uw huidige wachtwoord',
    userOptions: 'Gebruikersopties',
    userPassword: 'Wachtwoord',
    userPasswordConfirmation: 'Bevestig uw wachtwoord',
    userPasswordConfirmationError: 'De wachtwoorden komen niet overeen! Probeer het opnieuw.',
    userPasswordConfirmationRestriction: 'Beide wachtwoorden moeten exact hetzelfde zijn.',
    userPasswordEdit: 'Mijn wachtwoord wijzigen',
    userPasswordSet: 'Een wachtwoord instellen',
    userPasswordSetSuccess: 'Wachtwoord opgeslagen.',
    userSocialConnectionsTitle: 'Verbindingen',
    userSocialContinueApple: 'Doorgaan met Apple',
    userSocialContinueGoogle: 'Doorgaan met Google',
    userSocialDivider: 'of',
    userSocialError: 'Aanmelden is mislukt. Probeer het opnieuw.',
    userSocialErrorNoEmail: 'Uw Apple-account heeft geen e-mailadres gegeven. Gebruik een andere methode.',
    userSocialErrorUnavailable: 'Deze aanmelding is nog niet beschikbaar.',
    userSocialLinkApple: 'Apple koppelen',
    userSocialLinkGoogle: 'Google koppelen',
    userSocialLinkSuccess: 'Account gekoppeld.',
    userSocialLinked: 'Gekoppeld',
    userSocialUnlinkApple: 'Apple ontkoppelen',
    userSocialUnlinkConfirm: 'Deze aanmelding ontkoppelen van uw account?',
    userSocialUnlinkGoogle: 'Google ontkoppelen',
    userSocialUnlinkLastError: 'Voeg een wachtwoord toe voordat u uw laatste aanmelding ontkoppelt.',
    userSocialUnlinkSuccess: 'Account ontkoppeld.',
    userPasswordError: 'Voer een correct wachtwoord in!',
    userPasswordResetText: 'Voer uw nieuwe wachtwoord in. Bevestig het en klik op de knop hieronder om het op te slaan.',
    userPasswordRestriction: 'Uw wachtwoord moet voor uw veiligheid ten minste 6 tekens bevatten, waaronder 1 cijfer en 1 speciaal teken (@&!()$*€%)!',
    userPasswordRestrictionAlt: 'Uw wachtwoord moet minstens 6 tekens lang zijn!',
    userPasswordTemporaryCheckButton: 'Ik heb mijn tijdelijke wachtwoord al ontvangen',
    userPhone: 'Mobiele telefoon',
    userPhoneError: 'Het telefoonnummer is ongeldig!',
    userProfileMy: 'Mijn profiel',
    userReInitPassword: 'Mijn wachtwoord resetten',
    userRecoverFromOldAppCheckButton: 'Ik heb de e-mail ontvangen om mijn wachtwoord te herstellen',
    userRecoverFromOldAppText: 'We hebben zojuist uw account gemigreerd naar ons nieuwe platform! Controleer uw e-mail om uw wachtwoord te herstellen en uw nieuwe persoonlijke ruimte te activeren.',
    userRegister: 'Mijn account aanmaken',
    userRegisterError: 'We konden uw account niet aanmaken! Controleer uw e-mail en probeer het opnieuw...',
    userRegisterSuccess: 'Gefeliciteerd! We hebben uw account veilig aangemaakt. U heeft zojuist een e-mail ontvangen met uw tijdelijke wachtwoord!',
    userRegisterSuccessEmailNotice: 'Er is zojuist een bevestigingsmail verzonden naar {email}.',
    userRegisterSuccessEyebrow: 'Welkom',
    userRegisterSuccessPageTitle: 'Welkom!',
    userRegisterSuccessSourcesHint: 'Kies de app waar uw berichten staan.',
    userRegisterSuccessSourcesTitle: 'Waar beginnen we?',
    userRegisterSuccessStep1Desc: 'Daar vind u het overzicht van uw registratie.',
    userRegisterSuccessStep1Title: 'Controleer uw inbox',
    userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS of Android: kies uw bron.',
    userRegisterSuccessStep2Title: 'Importeer uw berichten',
    userRegisterSuccessStep3Desc: 'Omslag, kleuren, foto\'s: maak elk detail helemaal van u.',
    userRegisterSuccessStep3Title: 'Maak uw boek',
    userRegisterSuccessStepsEyebrow: 'Uw traject',
    userRegisterSuccessText: 'Uw account is klaar. In een paar stappen maakt u van uw berichten een boek om te koesteren.',
    userRegisterSuccessTitle: 'Uw verhaal begint hier',
    userRegisterSuccessTitleNamed: 'Welkom, {firstName}!',
    userResetPasswordAccountButton: 'Wachtwoord van het account resetten',
    userResetPasswordAskSuccess: 'Controleer uw inbox! We hebben u een link gestuurd om uw nieuwe wachtwoord aan te maken.',
    userResetPasswordButton: 'Mijn wachtwoord resetten',
    userResetPasswordError: 'We konden uw wachtwoord niet resetten! Probeer het later opnieuw...',
    userResetPasswordInfo: 'U ontvangt een veilige link in uw e-mail om uw wachtwoord te resetten.',
    userResetPasswordInfo2: 'Maak uw nieuwe wachtwoord aan door de onderstaande velden in te vullen:',
    userResetPasswordSuccess: 'Uw wachtwoord is succesvol bijgewerkt!',
    userRole: 'Rol',
    userRoleAdmin: 'Beheerder',
    userRoleCustomer: 'Klant',
    userSearchLabel: 'Voer een e-mail of de naam van een gebruiker in',
    userSendNewAccountEmail: 'Stuur een "Nieuw account" e-mail naar deze gebruiker',
    userSendNewAccountEmailSuccess: 'De gebruiker is op de hoogte gebracht!',
    userSwitch: 'Verander van gebruiker',
    userValidForgotPasswordError: 'We konden de herstelcode niet naar u verzenden!',
    userValidForgotPasswordSuccess: 'Controleer uw e-mail! Gebruik de bevestigingscode die we u hebben gestuurd om uw nieuwe wachtwoord aan te maken.',
    users: 'Gebruikers',
    usersList: 'Lijst met gebruikers',
    valid: 'Bevestigen',
    view: 'Bekijken',
    voucher: 'Kortingscode',
    voucherApplyButton: 'Korting toepassen',
    voucherApplyComplete: 'U kunt geen verdere kortingscodes stapelen op deze bestelling!',
    voucherApplyFormLabel: 'Promotiecode',
    voucherApplyValidError: 'Oeps! Deze kortingscode is niet geldig voor uw huidige bestelling.',
    voucherCode: 'Code',
    voucherCodePlaceholder: 'Typ hier uw promotiecode in',
    voucherDeleteConfirmMessage: 'Weet u zeker dat u deze kortingsbon wilt verwijderen?',
    voucherEdit: 'De kortingscode bewerken',
    voucherIsAuto: 'Automatisch?',
    voucherIsCumulative: 'Is het cumulatief?',
    voucherIsPublic: 'Is het openbaar?',
    voucherNotExistsError: 'Deze kortingscode bestaat niet of is verlopen!',
    voucherPriority: 'Prioriteit',
    voucherProductOffer: 'Aangeboden',
    voucherRemoveAllButton: 'Verwijder alle kortingen',
    vouchers: 'Kortingscodes',
    weight: 'Gewicht',
    yes: 'Ja',
    you: 'U',
    yourself: 'U',
    userNewsletterTitle: 'Nieuwsbrief',
    userNewsletterSubscribeText: 'We sturen u onze nieuwste producten, exclusieve promoties en onze favoriete boeken.',
    userNewsletterUnSubscribeButton: 'Mij afmelden voor de nieuwsbrief',
    'userOrdersView': 'Bekijk de bestellingen van deze gebruiker',
    'userCanCustomizeMessages': 'Kan deze berichten personaliseren?',
    'userLogAsUser': 'Inloggen als deze gebruiker',
    'shippingMethodProviderData': 'Informatie van het transportbedrijf',
    'productUseForCustomization': 'Gebruiken voor personalisatie?',
    'conversationBookFormat': 'Formaat van het boek',
    'conversationMessageSelect': 'Selecteer dit bericht',
    'conversationMessagesEditTitle': 'Het atelier: Personaliseer uw berichten',
    'conversationMessageSelectorDateFrom': 'Selecteer berichten verzonden na',
    'conversationMessageSelectorDateTo': 'Selecteer berichten verzonden voor',
    'conversationTextSearch': 'Zoek een woord in de chat',
    'conversationOnlyMedias': 'Toon alleen foto\'s/video\'s',
    'conversationMessagesSelectVisible': 'Deze pagina selecteren',
    'conversationMessagesSelectAllFiltered': 'Alles selecteren ({count, number})',
    'unselect': 'Deselecteren',
    'conversationMessagesEditHideSelected': 'Verberg de geselecteerde berichten uit het boek',
    'conversationMessagesEditShowSelected': 'Toon de geselecteerde berichten opnieuw',
    'conversationMessagesEditTooManySelected': 'U heeft te veel berichten tegelijk geselecteerd!',
    'conversationNoMessages': 'Geen enkel bericht',
    'conversationMessageEdit': 'Bewerk de tekst van het bericht',
    'conversationMessageAdd': 'Een bericht toevoegen',
    'conversationMessageInsert': 'Hier een bericht invoegen',
    'conversationMessageEditSelect': 'Selecteer dit bericht',
    'conversationMessageEditUnselect': 'Deselecteer dit bericht',
    'conversationMessageSetUnVisibleButton': 'Verberg dit bericht in het gedrukte boek',
    'conversationMessageHiddenAlert': 'Dit bericht is verborgen en zal niet in uw afgedrukte boek verschijnen.',
    'conversationMessageSetVisibleButton': 'Bericht weer tonen',
    'conversationMessagesEditEnableButton': 'Activeer de personalisatie van berichten',
    'conversationMessagesEditEnableButton2': 'Ontgrendel personalisatie voor {price}',
    'conversationMessagesEditDisableAlert': 'Om de exacte inhoud van uw berichten te kunnen wijzigen, verbergen of bewerken, moet u deze premium optie activeren (eenmalige betaling).',
    'conversationMessageDateHint': 'Pas datum en tijd aan om dit bericht op de gewenste plek in het gesprek te zetten.',
    'conversationMessageSender': 'Afzender',
    'conversationMessageSenderPlaceholder': 'Afzender kiezen',
    'conversationMessageSenderRequiredHint': 'Kies wie dit bericht verstuurt om het op te kunnen slaan.',
    'conversationMessageAnnotation': 'Annotatie',
    'conversationMessageAnnotationNoMedia': 'Een annotatie kan geen foto, video of audio bevatten.',
    'conversationMessageText': 'Tekst',
    'conversationMessageTextPlaceholder': 'Typ uw tekst',
    'conversationMessageAttachments': 'Bijlagen (Foto\'s/Video\'s)',
    'conversationMessageMediaLabel': 'Foto, video of audio',
    'conversationMessageMediaDragDrop': 'Sleep hier een foto, video of audiobestand naartoe',
    'conversationMessageMediaTapSelect': 'Tik om een foto, video of audio te kiezen',
    'conversationMessageMediaOpenFinder': 'Bestand kiezen',
    'conversationMessageMediaPickSenderFirst': 'Kies eerst een afzender om een foto, video of audio toe te voegen.',
    'conversationMessageHiddenLabel': 'Dit bericht uit het boek verbergen?',
    'conversationGenerate': 'Genereer de proefdrukken van de boeken',
    'conversationVerify': 'Forceer de verificatie',
    'conversationLaunchButton': 'Naar de drukker sturen',
    'conversationViewButton': 'Mijn chat bekijken',
    'reset': 'Resetten',
    'cms': 'CMS',
    'cmsLinkColor': 'Kleur van de knop',
    'cmsLinkNeedObfuscate': 'Obfuscatie nodig?',
    'cmsImageUseForMobile': 'Gebruikt voor de mobiele versie?',
    'contentEditPage': 'De pagina bewerken',
    'cmsRedirectionAdd': 'Voeg een omleiding toe',
    'cmsContentEdit': 'Pas de inhoud aan',
    'cmsPageIsActive': 'Actieve pagina?',
    'cmsContentTypeLabel': 'Inhoudstype',
    'cmsContentModelLabel': 'Ontwerpmodel',
    'cmsContentTitle': 'Titel van de pagina',
    'cmsContentSlug': 'Slug (URL)',
    'cmsPanelIsTemplate': 'Opgenomen in de globale sjabloon?',
    'cmsPageSeoTitle': 'SEO-titel (Google)',
    'cmsPageSeoDescription': 'SEO Meta-beschrijving',
    'cmsPageSeoKeywords': 'SEO Trefwoorden',
    'cmsPageSeoHideOnSitemap': 'Verbergen voor zoekmachines (Sitemap)',
    'cmsPageSeoUseCustomTitleSuffix': 'Gebruik een aangepast titelachtervoegsel',
    'cmsPageSeoTitleSuffix': 'Titelachtervoegsel',
    'affiliation': 'Affiliate programma',
    'affiliationInvoiceTotalAdminTitle': 'Totaal te betalen (incl. btw)',

    conversationImportLuxEyebrow: 'Uw verhaal',
    conversationImportLuxTagline: 'Een uniek cadeau van u: dat niemand anders kan geven.',
    conversationImportLuxPrivacy: 'Uw berichten blijven privé: alleen het gekozen gesprek wordt gebruikt.',
    conversationImportProgressExport: 'Exporteren',
    conversationImportProgressUpload: 'Uploaden',
    conversationImportProgressCustomize: 'Personaliseren',
    conversationImportUploadSuccess: 'Archief ontvangen: kies uw gesprek in de volgende stap',
    conversationImportUploadSuccessSingle: 'Bestand ontvangen: ga verder om uw boek te personaliseren',
    conversationImportContinueSingle: 'Doorgaan',
    conversationImportSelectionTitleSingle: 'Uw gesprek',
    conversationImportSelectionHintSingle: 'Eén gesprek gevonden in uw bestand.',
    conversationImportSelectionHintMultiple: 'Kies het gesprek voor uw boek: gebruik zoeken om de lijst te filteren.',
    conversationImportSelectionListCount: '{shown} van {total} gesprekken',
    conversationImportSelectionNoMatch: 'Geen gesprek komt overeen met uw zoekopdracht.',
    conversationImportStepPickThread: 'Gesprek kiezen',
    conversationImportStepMedia: 'Foto-opties',
    conversationImportStepTerms: 'Voorwaarden accepteren',
    conversationImportExtrasLockedHint: 'Kies hierboven een gesprek om deze opties te ontgrendelen.',
    conversationImportPickThreadBeforeTerms: 'U moet hierboven nog een gesprek kiezen voordat u verder kunt.',
    conversationImportChangeThread: 'Gesprek wijzigen',
    conversationImportSelectionConfirmedHint: 'Perfect: u kunt uw boek hieronder nu aanpassen.',

    conversationImportOptionsTitle: 'Foto\'s & herinneringen',
    conversationImportOptionsHint: 'Alles staat standaard aan: vink alleen uit wat u niet wilt opnemen.',
    conversationImportOptionsImagesLabel: 'Foto\'s & afbeeldingen',
    conversationImportOptionsImagesDesc: 'Foto\'s uit uw gesprek worden in het boek afgedrukt.',
    conversationImportOptionsMediasLabel: 'Video\'s, audio & GIFs',
    conversationImportOptionsMediasDesc: 'Toegankelijk via QR-codes in het boek (10 jaar opslag inbegrepen).',
    conversationImportOptionsTransferNote: 'Het uploaden kan enkele minuten duren afhankelijk van het aantal foto\'s: blijf op deze pagina.',
    conversationImportOptionsNoMedia: 'Uw bestand bevat geen foto\'s of media: uw boek bevat alleen de berichten.',
    conversationImportAgreementRead: 'Lees de algemene verkoopvoorwaarden',
    conversationImportCreateBook: 'Mijn boek maken',
    conversationImportSelectToContinue: 'Selecteer een gesprek om door te gaan.',
    conversationImportAcceptTermsToContinue: 'Vink het vakje met de algemene voorwaarden aan om door te gaan.',
    conversationImportTransferEyebrow: 'Bijna klaar',
    conversationImportTransferTitle: 'We bereiden uw boek voor',
    conversationImportTransferSubtitle: 'Even geduld: uw verhaal krijgt vorm.',
    conversationImportTransferStay: 'Blijf op deze pagina tot de overdracht is voltooid.',
    conversationImportStepMedias: 'Video\'s en audio uploaden',
    conversationImportTransferStatMessages: 'Berichten',
    conversationImportTransferStatPhotos: 'Foto\'s',
    conversationImportTransferStatMedias: 'Video\'s en audio',
    conversationImportTransferEyebrow: 'Bijna klaar',
    conversationImportTransferTitle: 'We bereiden uw boek voor',
    conversationImportTransferSubtitle: 'Even geduld: uw verhaal krijgt vorm.',
    conversationImportTransferStay: 'Blijf op deze pagina tot de overdracht is voltooid.',
    conversationImportResumeTitle: 'Een vorige overdracht werd onderbroken.',
    conversationImportResumeTextFile: 'Selecteer hetzelfde bestand ({name}) opnieuw om verder te gaan waar het gestopt is.',
    conversationImportResumeText: 'Selecteer hetzelfde bestand opnieuw om verder te gaan waar het gestopt is.',
    conversationImportResumeButton: 'Overdracht hervatten',
    conversationImportResumeDiscard: 'Opnieuw beginnen',
    conversationImportDuplicateTitle: 'Dit gesprek staat al op uw account',
    conversationImportDuplicateEyebrow: 'Identiek gesprek',
    conversationImportDuplicateLead: 'We hebben een identiek gesprek gevonden. U kunt het bestaande openen om een dubbele transfer te vermijden.',
    conversationImportDuplicateQuestion: 'Wat wilt u doen?',
    conversationImportDuplicateUseExisting: 'Gebruik het bestaande gesprek',
    conversationImportDuplicateImportAnyway: 'Opnieuw importeren',
    conversationImportDropHint: 'Sleep uw .zip-bestand hier naartoe, of',
    conversationImportDropFormats: 'Volledig .zip aanbevolen: niet openen (foto\'s en media inbegrepen)',
    conversationImportJsonOnlyHint: 'Alleen JSON-bestand: foto\'s en media worden niet meegenomen. Voor een geïllustreerd boek upload u het volledige .zip zonder het te openen. Als uw browser het archief al heeft uitgepakt, comprimeer de map « messages » tot .zip.',

    conversationInstagramImportIntro: 'Exporteer uw Instagram-berichten in 3 stappen:',
    conversationInstagramImportDemoTitle: 'Exporteer uw Instagram-berichten',
    conversationInstagramImportDemoExportMeta: 'Exporteren naar apparaat · JSON',
    conversationInstagramImportDemoDownloadsAvailable: 'Beschikbare downloads',
    conversationInstagramImportDemoStartExport: 'Export starten',
    conversationInstagramImportDemoCustomizeMessages: 'Alleen berichten',
    conversationInstagramImportDemoCustomize: 'Informatie aanpassen',
    conversationInstagramImportDemoConfirmTitle: 'Export bevestigen',
    conversationInstagramImportDemoSave: 'Opslaan',
    conversationInstagramImportDemoMessagesTip: 'Optioneel maar sneller: alles wissen, dan alleen Berichten.',
    conversationInstagramImportDemoDataPayments: 'Betalingen',
    conversationInstagramImportDemoDataComments: 'Reacties',
    conversationInstagramImportDemoClearAll: 'Alles wissen',
    conversationInstagramImportDemoActivitySection: 'Uw Instagram-activiteit',
    conversationInstagramImportDemoPickSpecific: 'Kies specifieke informatie om te exporteren',
    conversationInstagramImportDemoExportExternal: 'Exporteren naar externe dienst',
    conversationInstagramImportDemoExportDevice: 'Exporteren naar mijn apparaat',
    conversationInstagramImportDemoChooseDestination: 'Kies waar u naartoe exporteert',
    conversationInstagramImportDemoProfileAccount: 'Uw account · Instagram',
    conversationInstagramImportDemoProfileName: 'Uw accountnaam',
    conversationInstagramImportDemoAccountShort: 'Uw account',
    conversationInstagramImportDemoProfiles: 'Profielen',
    conversationInstagramImportDemoChooseProfile: 'Kies een profiel',
    conversationInstagramImportDemoPastActivity: 'Eerdere activiteit',
    conversationInstagramImportDemoCurrentActivity: 'Huidige activiteit',
    conversationInstagramImportDemoCreateExport: 'Export maken',
    conversationInstagramImportDemoExportIntro: 'Maak een kopie van uw informatie om naar uw apparaat te downloaden.',
    conversationInstagramImportDemoExportTitle: 'Uw informatie exporteren',
    conversationInstagramImportDemoCaptionStart: 'Tik op Export starten',
    conversationInstagramImportDemoCaptionDevice: 'Tik op Exporteren naar mijn apparaat',
    conversationInstagramImportDemoCaptionProfile: 'Kies uw Instagram-profiel',
    conversationInstagramImportDemoCaptionCreate: 'Tik op Export maken',
    conversationInstagramImportDemoCaptionMessages: 'Tip: Alles wissen, dan alleen Berichten (sneller)',
    conversationInstagramImportDemoCaptionJson: 'Kies JSON-formaat, dan Opslaan',
    conversationInstagramImportDemoCaptionDrop: 'Download de .zip wanneer klaar en plaats hem hieronder',
    conversationInstagramImportDemoPlatform: 'Instagram',
    conversationInstagramImportDemoDataMessages: 'Berichten',
    conversationInstagramImportDemoFormat: 'Formaat',
    conversationInstagramImportDemoMediaQuality: 'Mediakwaliteit',
    conversationInstagramImportDemoQualityLow: 'Laag',
    conversationInstagramImportDemoJsonNotice: 'JSON verplicht voor uw boek. HTML werkt niet.',
    conversationInstagramImportDemoReadyHint: 'Plaats de volledige .zip hieronder zonder het uit te pakken. U kiest daarna het gesprek.',
    conversationInstagramImportCta: 'Instagram-instellingen openen',
    conversationInstagramImportStep1: 'Tik op <b>Export maken</b>, kies uw <b>Instagram</b>-profiel, dan <b>Exporteren naar mijn apparaat</b>.',
    conversationInstagramImportStep2: 'Tip voor een snellere export: <b>Alles wissen</b>, vink alleen <b>Berichten</b> aan. Kies <b>JSON</b>-formaat en <b>Lage</b> mediakwaliteit.',
    conversationInstagramImportStep3: 'Tik op <b>Export starten</b>, wacht op de e-mail (10 min tot 24 u), download de <b>.zip</b> en plaats hem hieronder <b>zonder het uit te pakken</b>: u kiest het gesprek <b>daarna</b>.',
    conversationInstagramImportAlert: '<b>JSON</b>-formaat verplicht (niet HTML). Tip: alleen <b>Berichten</b> exporteren is sneller, maar niet verplicht.',
    conversationInstagramImportDetailTitle: 'Instagram-export: gedetailleerde gids',
    conversationInstagramImportDetailIntro: 'Volg elke stap met de screenshots hieronder. De knop hierboven opent direct de exportpagina.',
    conversationInstagramImportDetailSkipApp: 'Ik heb de pagina via de knop geopend: ga verder bij stap 5',
    conversationInstagramImportDetailStep1: 'Open de <b>Instagram</b>-app en ga via de drie puntjes rechtsboven naar <b>Instellingen</b>.',
    conversationInstagramImportDetailStep2: 'Selecteer <b>Accountcentrum</b>.',
    conversationInstagramImportDetailStep3: 'Tik op <b>Uw informatie en machtigingen</b>.',
    conversationInstagramImportDetailStep4: 'Kies <b>Uw informatie exporteren</b>.',
    conversationInstagramImportDetailStep5: 'Ga naar <b>Informatie downloaden of overdragen</b>. Als u de knop hierboven hebt gebruikt, bent u al op deze pagina.',
    conversationInstagramImportDetailStep6: 'Selecteer <b>Instagram</b>. Deze stap verschijnt mogelijk niet op sommige accounts.',
    conversationInstagramImportDetailStep7: 'Kies <b>Sommige van uw informatie</b>.',
    conversationInstagramImportDetailStep8: 'Scroll naar <b>Berichten</b>, vink het aan en tik op <b>Volgende</b>.',
    conversationInstagramImportDetailStep9: 'Tik op <b>Downloaden naar apparaat</b>.',
    conversationInstagramImportDetailStep10: 'Kies de gewenste periode, het formaat <b>JSON</b> en een <b>lage</b> mediakwaliteit voor een snellere download.',
    conversationInstagramImportDetailStep11: 'Uw archief is klaar binnen <b>10 minuten tot 24 uur</b>. U ontvangt een e-mail zodra het beschikbaar is: u kunt het ook vinden op de Accountcentrum-pagina.',
    conversationInstagramImportDetailStep12: 'Download het volledige <b>.zip</b>-bestand naar uw apparaat en zet het hieronder neer <b>zonder het te openen</b>. Alleen het gesprek dat u daarna kiest, wordt gebruikt voor uw boek.',

    conversationKakaotalkImportIntro: 'Het begint op uw telefoon. Gebruikt u iPhone of Android?',
    conversationKakaotalkImportPlatformIphone: 'iPhone',
    conversationKakaotalkImportPlatformAndroid: 'Android',
    conversationKakaotalkImportIphoneStep1: 'Open op uw iPhone <b>KakaoTalk</b> en het gesprek dat u in uw boek wilt.',
    conversationKakaotalkImportIphoneStep2: 'Tik rechtsboven op het <b>menu</b> (☰) en daarna onderaan het paneel op het <b>instellingen</b>-icoon.',
    conversationKakaotalkImportIphoneStep3: 'Tik op <b>Gesprek exporteren</b> en kies <b>Alleen tekstberichten versturen</b>.',
    conversationKakaotalkImportIphoneStep4: 'Sla het <b>.txt</b>-bestand op (Bestanden, e-mail, AirDrop) en zet het hieronder neer <b>zonder het te bewerken</b>.',
    conversationKakaotalkImportAndroidStep1: 'Open op uw telefoon <b>KakaoTalk</b> en het gesprek dat u in uw boek wilt.',
    conversationKakaotalkImportAndroidStep2: 'Tik rechtsboven op het <b>menu</b> (☰) en daarna onderaan het paneel op het <b>instellingen</b>-icoon.',
    conversationKakaotalkImportAndroidStep3: 'Tik op <b>Gesprek exporteren</b> en kies <b>Alleen tekst versturen</b>.',
    conversationKakaotalkImportAndroidStep4: 'Sla het <b>.txt</b>-bestand op (Bestanden, Google Drive, e-mail) en zet het hieronder neer <b>zonder het te bewerken</b>.',
    conversationKakaotalkImportAlert: 'Eén gesprek per export. De andere optie bewaart ook uw foto\'s, maar KakaoTalk koppelt ze niet aan de berichten: kies alleen tekst, foto\'s verschijnen als een enkel woord.',
    conversationKakaotalkImportDesktopNote: 'Op de computer (Windows of Mac): open het menu van het gesprek en dan <b>Chat opslaan</b>. Het <b>.txt</b>-bestand dat u krijgt werkt hier ook.',
    conversationLineImportIntro: 'Het begint op uw telefoon. Gebruikt u iPhone of Android?',
    conversationLineImportPlatformIphone: 'iPhone',
    conversationLineImportPlatformAndroid: 'Android',
    conversationLineImportIphoneStep1: 'Open op uw iPhone <b>LINE</b> en het gesprek dat u in uw boek wilt.',
    conversationLineImportIphoneStep2: 'Bovenaan de chat tik u op het <b>menu</b> (☰) → <b>Instellingen</b>.',
    conversationLineImportIphoneStep3: 'Tik op <b>Chatgeschiedenis exporteren</b> en kies hoe u het bestand verstuurt (Bestanden, e-mail, AirDrop).',
    conversationLineImportIphoneStep4: 'Sla het <b>.txt</b>-bestand op en zet het hieronder neer <b>zonder het te bewerken</b>.',
    conversationLineImportAndroidStep1: 'Open op uw telefoon <b>LINE</b> en het gesprek dat u in uw boek wilt.',
    conversationLineImportAndroidStep2: 'Bovenaan de chat tik u op het <b>menu</b> (☰) → <b>Instellingen</b>.',
    conversationLineImportAndroidStep3: 'Tik op <b>Chatgeschiedenis exporteren</b> en kies hoe u het bestand verstuurt (Bestanden, Google Drive, e-mail).',
    conversationLineImportAndroidStep4: 'Sla het <b>.txt</b>-bestand op en zet het hieronder neer <b>zonder het te bewerken</b>.',
    conversationLineImportAlert: 'Eén gesprek per export. Alleen berichten die nu zichtbaar zijn in de chat worden opgeslagen en LINE exporteert geen foto\'s of stickers als afbeeldingen.',
    conversationLineImportDesktopNote: 'Op de computer (Windows of Mac): open <b>Chats</b>, dubbelklik op het gesprek en gebruik bovenaan het <b>menu</b> → <b>Chat opslaan</b>. Deze export bestaat niet in LINE voor Chrome.',

    conversationLinkedinImportIntro: '3 stappen om uw LinkedIn-gesprekken te exporteren:',
    conversationLinkedinImportCta: 'Open de LinkedIn-exportpagina',
    conversationLinkedinImportStep1: 'Open de pagina hierboven in een <b>webbrowser</b> (computer of telefoon). Anders: <b>U</b> → <b>Instellingen en privacy</b> → <b>Gegevensprivacy</b> → <b>Een kopie van uw gegevens opvragen</b>.',
    conversationLinkedinImportStep2: 'Vraag een archief aan met uw <b>Berichten</b>: vink het bestand <b>Berichten</b> aan, of kies het volledige archief, en klik op <b>Archief aanvragen</b>.',
    conversationLinkedinImportStep3: 'Download de <b>.zip</b> uit de e-mail van LinkedIn (10 min tot 24 u) en zet hem hieronder neer <b>zonder hem te openen</b>: u kiest het gesprek <b>daarna</b>.',
    conversationLinkedinImportAlert: 'Deze export bestaat niet in de mobiele LinkedIn-app: gebruik een browser. Het archief moet het bestand <b>messages.csv</b> bevatten (LinkedIn exporteert geen foto\'s of bijlagen).',

    conversationSnapchatImportIntro: '3 stappen om uw Snapchat-gesprekken te exporteren:',
    conversationSnapchatImportCta: 'Snapchat Mijn gegevens openen',
    conversationSnapchatImportStep1: 'In de app: avatar → instellingen (tandwiel) → <b>Privacy</b> → <b>Mijn gegevens</b>. U kunt ook de link hierboven gebruiken.',
    conversationSnapchatImportStep2: 'Log in indien gevraagd, tik dan onderaan op <b>Verzoek indienen</b>: Snapchat stuurt u een e-mail wanneer het archief klaar is (enkele uren tot 1 dag).',
    conversationSnapchatImportStep3: 'Download het <b>.zip</b> uit de e-mail en zet het hieronder neer <b>zonder het te openen</b>: u kiest het gesprek <b>na</b> het uploaden.',
    conversationSnapchatImportAlert: 'Volledig <b>.zip</b>-archief verplicht: niet openen. Uw berichten worden in het boek afgedrukt (Snapchat-export bevat geen afdrukbare foto\'s).',
    conversationSnapchatPlaceholderMedia: '[Media]',
    conversationSnapchatPlaceholderNote: '[Spraakbericht]',
    conversationSnapchatPlaceholderSticker: '[Sticker]',
    conversationSnapchatPlaceholderSnap: '[Snap]',
    conversationSnapchatPlaceholderAudio: '[Audio]',
    conversationSnapchatStatusParticipantAdded: 'Er is een lid aan de groep toegevoegd',
    conversationSnapchatStatusNameChanged: 'De groepsnaam is gewijzigd',
    conversationSnapchatStatusConversationCreated: 'Gesprek aangemaakt',
    conversationSnapchatStatusGeneric: 'Snapchat-melding',
    conversationSnapchatImportPartialContent: '{withText} berichten met tekst van {total}. Snapchat exporteert de inhoud van niet-opgeslagen berichten niet.',
    conversationSnapchatImportDetailTitle: 'Snapchat-export: gedetailleerde gids',
    conversationSnapchatImportDetailIntro: 'Volg elke stap met de screenshots hieronder. U kunt ook de knop hierboven gebruiken om Mijn gegevens direct te openen en bij stap 4 te beginnen.',
    conversationSnapchatImportDetailSkipApp: 'Ik heb de pagina via de knop geopend: ga verder bij stap 4',
    conversationSnapchatImportDetailStep1: 'Open <b>Snapchat</b> en tik op uw profielfoto.',
    conversationSnapchatImportDetailStep2: 'Tik op het <b>tandwiel</b> om de instellingen te openen.',
    conversationSnapchatImportDetailStep3: 'Scroll naar <b>Accountacties</b> en tik op <b>Mijn gegevens</b>. U kunt ook de knop hierboven gebruiken.',
    conversationSnapchatImportDetailStep4: 'Vink <b>Chatgeschiedenis</b> aan, kies de formaten <b>JSON</b> en <b>HTML</b>, tik dan op <b>Volgende</b>.',
    conversationSnapchatImportDetailStep5: 'Kies de gewenste periode, bevestig uw e-mailadres en tik op <b>Verzenden</b>.',
    conversationSnapchatImportDetailStep6: 'Snapchat stuurt u een e-mail zodra de export klaar is: dit kan enkele uren tot enkele dagen duren.',
    conversationSnapchatImportDetailStep7: 'Wanneer u de e-mail ontvangt, klik op de link om uw gegevens te openen.',
    conversationSnapchatImportDetailStep8: 'Tik in Snapchat op <b>Export bekijken</b>, daarna op <b>Downloaden</b>.',
    conversationSnapchatImportDetailStep9: 'Download het volledige <b>.zip</b>-bestand naar uw apparaat en zet het hieronder neer <b>zonder het te openen</b>. Alleen het gesprek dat u daarna kiest, wordt gebruikt voor uw boek.',

    conversationTelegramImportIntro: '4 stappen om een Telegram-gesprek te exporteren:',
    conversationTelegramImportCta: 'Telegram Desktop downloaden',
    conversationTelegramImportStep1: 'Op een pc installeert u <b>Telegram Desktop</b>. Op een Mac gebruikt u niet de App Store-app « Telegram »: download <b>Telegram Desktop</b> via de link hierboven (in de App Store heet die Telegram Lite). Open daarna het gesprek dat u tot boek wilt maken.',
    conversationTelegramImportStep2: 'Klik op de <b>drie puntjes</b> rechtsboven → <b>Chatgeschiedenis exporteren</b>.',
    conversationTelegramImportStep3: 'Vink <b>foto\'s, video\'s en bestanden</b> aan, kies het formaat <b>JSON</b> (HTML werkt ook), klik op <b>Exporteren</b> en wacht tot de download klaar is.',
    conversationTelegramImportStep4: 'Comprimeer de geëxporteerde map tot <b>.zip</b> (rechtermuisknop → comprimeren), zet hem hieronder neer <b>zonder het uit te pakken</b>: u bevestigt de opties <b>na</b> het uploaden.',
    conversationTelegramImportAlert: 'Eén gesprek per keer. Neem <b>media</b> op in de export voor een geïllustreerd boek: upload het volledige <b>.zip</b> ongewijzigd.',
    conversationTelegramImportDetailTitle: 'Telegram-export: gedetailleerde gids',
    conversationTelegramImportDetailIntro: 'Volg elke stap met de screenshots hieronder. Gebruik de knop hierboven om Telegram Desktop te downloaden, of ga naar stap 2 als het al is geïnstalleerd.',
    conversationTelegramImportDetailSkipApp: 'Ik heb Telegram Desktop al: ga verder bij stap 2',
    conversationTelegramImportDetailStep1: 'Op een pc is <b>Telegram Desktop</b> de juiste app. Op een Mac downloadt u <b>Telegram Desktop</b> via de link hierboven: de App Store-app « Telegram » kan geen chat exporteren. In de App Store heet het juiste programma <b>Telegram Lite</b>.',
    conversationTelegramImportDetailStep2: 'Open het <b>gesprek</b> dat u in een boek wilt omzetten.',
    conversationTelegramImportDetailStep3: 'Klik op de <b>drie puntjes</b> rechtsboven, daarna op <b>Chatgeschiedenis exporteren</b>.',
    conversationTelegramImportDetailStep4: 'Vink <b>alle bestandstypen</b> aan (foto\'s, video\'s, spraakberichten, enz.), zet de maximale bestandsgrootte op <b>1500 MB</b> en kies het formaat <b>JSON</b>. Als er geen formaatkeuze is, werkt een HTML-export ook.',
    conversationTelegramImportDetailStep5: 'Klik rechtsonder op <b>Exporteren</b> om de export te starten.',
    conversationTelegramImportDetailStep6: 'Tik op uw telefoon op <b>Toestaan</b> indien gevraagd. Comprimeer de geëxporteerde map tot een <b>.zip</b> en zet die hieronder neer <b>zonder hem te openen</b>: u bevestigt de opties na het uploaden.',

    conversationImportDetectedPlatform: 'Deze stappen zijn voor {platform}. De andere keuzes blijven beschikbaar.',
    conversationWhatsappImportIntro: 'Het begint op uw telefoon. Gebruikt u iPhone of Android?',
    conversationWhatsappImportPlatformIphone: 'iPhone',
    conversationWhatsappImportPlatformAndroid: 'Android',
    conversationWhatsappImportIphoneStep1: 'Open het gesprek, tik bovenaan op de <b>naam</b>, daarna op <b>Chat exporteren</b>.',
    conversationWhatsappImportIphoneStep2: 'Kies <b>Media bijvoegen</b> voor foto\'s in het boek (of <b>Zonder media</b> alleen tekst).',
    conversationWhatsappImportIphoneStep3: 'Bewaar in <b>Bestanden</b> en sleep de <b>.zip</b> hieronder <b>zonder het uit te pakken</b>.',
    conversationWhatsappImportIphoneStep4: '<b>Met media</b> voor foto\'s in het boek, <b>zonder media</b> alleen berichten: sla het bestand op uw computer of telefoon op en plaats het hieronder <b>zonder het uit te pakken</b>.',
    conversationWhatsappImportAndroidStep1: 'Open de chat, tik op <b>⋮</b> → <b>Meer</b> → <b>Chat exporteren</b>.',
    conversationWhatsappImportAndroidStep2: 'Kies <b>Media meenemen</b> voor foto\'s in het boek (of <b>Zonder media</b> alleen tekst).',
    conversationWhatsappImportAndroidStep3: 'Sla op of deel het bestand en plaats de <b>.zip</b> hieronder <b>zonder het uit te pakken</b>.',
    conversationWhatsappImportAndroidStep4: 'Sla het bestand op (Bestanden, Google Drive of e-mail), zet het op uw computer of telefoon en plaats het hieronder <b>zonder het te openen</b>.',
    conversationWhatsappImportAlert: 'Eén gesprek per export. Kies bij voorkeur <b>Media bijvoegen</b> voor een geïllustreerd boek. Blijf op deze pagina tot het einde.',
    conversationWhatsappImportAlertAndroid: 'Eén chat per export. Kies bij voorkeur <b>Media meenemen</b>. Op sommige telefoons werkt alleen e-mail: kies dan <b>Zonder media</b>. Blijf op deze pagina tot het einde.',
    conversationWhatsappImportIphoneDetailTitle: 'WhatsApp-export op iPhone: gedetailleerde gids',
    conversationWhatsappImportIphoneDetailIntro: 'Volg elke stap op uw iPhone met de screenshots hieronder, zet het bestand daarna op uw computer of telefoon voordat u het hier neerzet.',
    conversationWhatsappImportIphoneDetailStep1: 'Open <b>WhatsApp</b> en het gesprek dat u in een boek wilt omzetten.',
    conversationWhatsappImportIphoneDetailStep2: 'Tik bovenaan op de <b>naam van het contact</b> of de groep.',
    conversationWhatsappImportIphoneDetailStep3: 'Scroll helemaal naar beneden tot uw <b>Chat exporteren</b> ziet.',
    conversationWhatsappImportIphoneDetailStep4: 'Tik op <b>Chat exporteren</b>.',
    conversationWhatsappImportIphoneDetailStep5: 'Kies <b>Media bijvoegen</b> voor een geïllustreerd boek, of <b>Zonder media</b> alleen voor berichten.',
    conversationWhatsappImportIphoneDetailStep6: 'Sla het bestand op uw computer of telefoon op (bijv. in Bestanden), zet het dan hieronder neer <b>zonder het te openen</b>.',
    conversationWhatsappImportAndroidDetailTitle: 'WhatsApp-export op Android: gedetailleerde gids',
    conversationWhatsappImportAndroidDetailIntro: 'Volg elke stap op uw Android met de screenshots hieronder, zet het bestand daarna op uw computer of telefoon voordat u het hier neerzet.',
    conversationWhatsappImportAndroidDetailStep1: 'Open <b>WhatsApp</b> en het gesprek dat u tot boek wilt maken.',
    conversationWhatsappImportAndroidDetailStep2: 'Tik op <b>⋮</b> (rechtsboven) → <b>Meer</b> → <b>Chat exporteren</b>.',
    conversationWhatsappImportAndroidDetailStep3: 'Kies <b>Media meenemen</b> voor foto\'s, of <b>Zonder media</b> alleen voor berichten.',
    conversationWhatsappImportAndroidDetailStep4: 'Sla het bestand op (Bestanden, Google Drive of e-mail), zet het op uw computer of telefoon en plaats het hieronder <b>zonder het te openen</b>.',
    conversationWhatsappImportDemoTitle: 'Exporteer uw WhatsApp-gesprek',
    conversationWhatsappImportDemoIndividual: 'Persoonlijke chat',
    conversationWhatsappImportDemoGroup: 'Groepschat',
    conversationWhatsappImportDemoCaptionOpen: 'Open de chat in WhatsApp',
    conversationWhatsappImportDemoCaptionTapName: 'Tik bovenaan op de naam',
    conversationWhatsappImportDemoCaptionExport: 'Scroll omlaag en tik op Chat exporteren',
    conversationWhatsappImportDemoCaptionMedia: 'Kies Media bijvoegen voor foto\'s in uw boek',
    conversationWhatsappImportDemoCaptionSave: 'Bewaar in Bestanden en sleep hieronder',
    conversationWhatsappImportDemoExportLabel: 'Chat exporteren',
    conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
    conversationWhatsappImportDemoAttachMedia: 'Media bijvoegen',
    conversationWhatsappImportDemoWithoutMedia: 'Zonder media',
    conversationWhatsappImportDemoSaveFiles: 'Bewaar in Bestanden',
    conversationWhatsappImportDemoA11y: 'Animatiegids: open de chat, tik op de naam, exporteer, kies Media bijvoegen, bewaar in Bestanden.',
    conversationWhatsappImportDemoCaptionExportGroup: 'Open het ⋯-menu en tik op Chat exporteren',
    conversationWhatsappImportDemoContactName: 'Léa',
    conversationWhatsappImportDemoContactMom: 'Mama',
    conversationWhatsappImportDemoGroupName: 'Weekend',
    conversationWhatsappImportDemoGroupWork: 'Work: design',
    conversationWhatsappImportDemoChats: 'Chats',
    conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
    conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
    conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
    conversationWhatsappImportDemoSeeAll: 'See all ›',
    conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
    conversationWhatsappImportDemoAddList: 'Add to a list',
    conversationWhatsappImportDemoClearChat: 'Chat wissen',
    conversationWhatsappImportDemoBlock: 'Block',
    conversationWhatsappImportDemoParticipants: '{count} participants',
    conversationWhatsappImportDemoAudio: 'Audio',
    conversationWhatsappImportDemoVideo: 'Video',
    conversationWhatsappImportDemoAdd: 'Add',
    conversationWhatsappImportDemoSearch: 'Search',
    conversationWhatsappImportDemoMemberYou: 'You',
    conversationWhatsappImportDemoMemberAlex: 'Alex',
    conversationWhatsappImportDemoMemberCamille: 'Camille',
    conversationWhatsappImportDemoEditGroup: 'Edit group info',
    conversationWhatsappImportDemoEditDescription: 'Edit description',
    conversationWhatsappImportAndroidDemoIncludeMedia: 'Media meenemen',
    conversationWhatsappImportAndroidDemoWithoutMedia: 'Zonder media',
    conversationWhatsappImportAndroidDemoMediaNotice: 'Media meenemen voor een geïllustreerd boek. Zonder media is lichter.',
    conversationWhatsappImportAndroidDemoClear: 'Chat wissen',
    conversationWhatsappImportAndroidDemoExport: 'Chat exporteren',
    conversationWhatsappImportAndroidDemoReport: 'Melden',
    conversationWhatsappImportAndroidDemoMore: 'Meer',
    conversationWhatsappImportAndroidDemoWallpaper: 'Achtergrond',
    conversationWhatsappImportAndroidDemoMute: 'Meldingen dempen',
    conversationWhatsappImportAndroidDemoOnline: 'online',
    conversationWhatsappImportAndroidDemoCaptionSave: 'Sla op of deel het bestand en plaats het hieronder',
    conversationWhatsappImportAndroidDemoCaptionMedia: 'Kies Media meenemen voor foto\'s in uw boek',
    conversationWhatsappImportAndroidDemoCaptionExport: 'Tik op Meer, dan Chat exporteren',
    conversationWhatsappImportAndroidDemoCaptionMenu: 'Tik rechtsboven op het menu',
    conversationWhatsappImportAndroidDemoCaptionOpen: 'Open de chat in WhatsApp',
    conversationWhatsappImportAndroidDemoTitle: 'Exporteer uw WhatsApp-chat op Android',
    conversationWhatsappImportAndroidDemoShareHint: 'Plaats daarna de .zip hieronder zonder het uit te pakken.',
    conversationWhatsappImportAndroidDemoFiles: 'Bestanden',
    conversationWhatsappImportAndroidDemoShareVia: 'Versturen naar…',

    conversationMessengerImportIntro: 'Begin met <b>Na 2023</b>: versleutelde chats, op Messenger.com. Ga naar <b>Voor 2023</b> als de uwe daar ontbreekt.',
    conversationMessengerImportContext: 'Een gesprek dat vóór 2023 begon, kan doorgaan nadat de versleuteling is ingeschakeld. Messenger splitst het dan in twee archieven. Importeer beide en voeg ze samen vanuit uw lijst met gesprekken.',
    conversationMessengerImportPlatformClassic: 'Voor 2023',
    conversationMessengerImportPlatformEncrypted: 'Na 2023',
    conversationMessengerImportClassicCta: 'Meta openen om te exporteren',
    conversationMessengerClassicImportDemoReadyHint: 'Plaats de volledige .zip hieronder zonder het uit te pakken. U kiest daarna het gesprek.',
    conversationMessengerClassicImportDemoExportMeta: 'Exporteren naar apparaat · JSON',
    conversationMessengerClassicImportDemoDownloadsAvailable: 'Beschikbare downloads',
    conversationMessengerClassicImportDemoStartExport: 'Export starten',
    conversationMessengerClassicImportDemoQualityLow: 'Laag',
    conversationMessengerClassicImportDemoMediaQuality: 'Mediakwaliteit',
    conversationMessengerClassicImportDemoCustomizeMessages: 'Alleen berichten',
    conversationMessengerClassicImportDemoCustomize: 'Informatie aanpassen',
    conversationMessengerClassicImportDemoConfirmTitle: 'Export bevestigen',
    conversationMessengerClassicImportDemoJsonNotice: 'JSON verplicht voor uw boek. HTML werkt niet.',
    conversationMessengerClassicImportDemoFormat: 'Formaat',
    conversationMessengerClassicImportDemoSave: 'Opslaan',
    conversationMessengerClassicImportDemoMessagesTip: 'Optioneel maar sneller: alles wissen, dan alleen Berichten.',
    conversationMessengerClassicImportDemoDataMessages: 'Berichten',
    conversationMessengerClassicImportDemoDataPayments: 'Betalingen',
    conversationMessengerClassicImportDemoDataComments: 'Reacties',
    conversationMessengerClassicImportDemoClearAll: 'Alles wissen',
    conversationMessengerClassicImportDemoPickSpecific: 'Kies specifieke informatie om te exporteren',
    conversationMessengerClassicImportDemoExportExternal: 'Exporteren naar externe dienst',
    conversationMessengerClassicImportDemoExportDevice: 'Exporteren naar mijn apparaat',
    conversationMessengerClassicImportDemoChooseDestination: 'Kies waar u naartoe exporteert',
    conversationMessengerClassicImportDemoAccountShort: 'Uw account',
    conversationMessengerClassicImportDemoProfileName: 'Uw accountnaam',
    conversationMessengerClassicImportDemoProfiles: 'Profielen',
    conversationMessengerClassicImportDemoChooseProfile: 'Kies een profiel',
    conversationMessengerClassicImportDemoPastActivity: 'Eerdere activiteit',
    conversationMessengerClassicImportDemoCurrentActivity: 'Huidige activiteit',
    conversationMessengerClassicImportDemoCreateExport: 'Export maken',
    conversationMessengerClassicImportDemoExportIntro: 'Maak een kopie van uw informatie om naar uw apparaat te downloaden.',
    conversationMessengerClassicImportDemoExportTitle: 'Uw informatie exporteren',
    conversationMessengerClassicImportDemoCaptionDrop: 'Download de .zip wanneer klaar en plaats hem hieronder',
    conversationMessengerClassicImportDemoCaptionStart: 'Tik op Export starten',
    conversationMessengerClassicImportDemoCaptionJson: 'Kies JSON-formaat, dan Opslaan',
    conversationMessengerClassicImportDemoCaptionMessages: 'Tip: Alles wissen, dan alleen Berichten (sneller)',
    conversationMessengerClassicImportDemoCaptionDevice: 'Tik op Exporteren naar mijn apparaat',
    conversationMessengerClassicImportDemoCaptionCreate: 'Tik op Export maken',
    conversationMessengerClassicImportDemoActivitySection: 'Uw Facebook-activiteit',
    conversationMessengerClassicImportDemoProfileAccount: 'Uw account · Facebook',
    conversationMessengerClassicImportDemoPlatform: 'Facebook',
    conversationMessengerClassicImportDemoCaptionProfile: 'Kies uw Facebook-profiel',
    conversationMessengerClassicImportDemoTitle: 'Messenger-gesprekken van voor 2023 exporteren',
    conversationMessengerEncryptedImportDemoTitle: 'Messenger-gesprekken van na 2023 exporteren',
    conversationImportDemoBadgeMeta: 'Voorbeeld: doe dit op Meta, met de knop hierboven',
    conversationMessengerEncryptedImportDemoBadge: 'Voorbeeld: doe dit op Messenger.com, met de knop hierboven',
    conversationMessengerEncryptedImportDemoCaptionLogin: 'Open Messenger.com op een computer en meld u aan',
    conversationMessengerEncryptedImportDemoCaptionSettings: 'Klik op het tandwiel linksonder',
    conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Open Privacy en veiligheid',
    conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Kies End-to-end versleutelde chats',
    conversationMessengerEncryptedImportDemoCaptionStorage: 'Open Berichtenopslag',
    conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Klik op Gegevens van de berichtenopslag downloaden',
    conversationMessengerEncryptedImportDemoCaptionRange: 'Laat Media aangevinkt en kies de periode All time',
    conversationMessengerEncryptedImportDemoCaptionDrop: 'Klik op Bestand downloaden en zet de .zip hieronder neer',
    conversationMessengerEncryptedImportDemoLandingTitle: 'Een plek voor interessante gesprekken',
    conversationMessengerEncryptedImportDemoLandingText: 'Met Messenger blijf u in contact met de mensen om wie u geeft.',
    conversationMessengerEncryptedImportDemoContinueAs: 'Doorgaan als Uw naam',
    conversationMessengerEncryptedImportDemoSwitchAccount: 'Ander account kiezen',
    conversationMessengerEncryptedImportDemoChats: 'Chats',
    conversationMessengerEncryptedImportDemoSearch: 'Zoeken in Messenger',
    conversationMessengerEncryptedImportDemoContactName: 'Uw contact',
    conversationMessengerEncryptedImportDemoContactStatus: 'Nu actief',
    conversationMessengerEncryptedImportDemoLockBadge: 'End-to-end versleuteld',
    conversationMessengerEncryptedImportDemoMenuPreferences: 'Voorkeuren',
    conversationMessengerEncryptedImportDemoMenuProfileName: 'Profielnaam wijzigen',
    conversationMessengerEncryptedImportDemoMenuRestricted: 'Beperkte accounts',
    conversationMessengerEncryptedImportDemoMenuAccessibility: 'Toegankelijkheid',
    conversationMessengerEncryptedImportDemoMenuHelp: 'Help',
    conversationMessengerEncryptedImportDemoPrivacyTitle: 'Privacy en veiligheid',
    conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Leesbevestigingen',
    conversationMessengerEncryptedImportDemoPrivacyReported: 'Gerapporteerde chats',
    conversationMessengerEncryptedImportDemoPrivacyKeys: 'Sleutels in de chat controleren',
    conversationMessengerEncryptedImportDemoEncryptedTitle: 'End-to-end versleutelde chats',
    conversationMessengerEncryptedImportDemoEncryptedHint: 'Beheer de instellingen van uw end-to-end versleutelde chats',
    conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Veiligheidsmeldingen',
    conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Voorbeelden',
    conversationMessengerEncryptedImportDemoStorageTitle: 'Berichtenopslag',
    conversationMessengerEncryptedImportDemoStorageHint: 'Beheer hoe u uw chatgeschiedenis opslaat en opent',
    conversationMessengerEncryptedImportDemoStorageIntro: 'Uw end-to-end versleutelde berichten worden veilig opgeslagen in uw back-up.',
    conversationMessengerEncryptedImportDemoStoragePin: 'Pincode opnieuw instellen',
    conversationMessengerEncryptedImportDemoStorageMethods: 'Beveiligingsmethoden beheren',
    conversationMessengerEncryptedImportDemoStorageRemember: 'Deze browser onthouden',
    conversationMessengerEncryptedImportDemoStorageDownload: 'Gegevens van de berichtenopslag downloaden',
    conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Download al uw end-to-end versleutelde berichten en bijlagen.',
    conversationMessengerEncryptedImportDemoStorageAutoImport: 'Automatische imports uitschakelen',
    conversationMessengerEncryptedImportDemoDownloadTitle: 'Uw gegevens downloaden',
    conversationMessengerEncryptedImportDemoDownloadIntro: 'U kunt op elk moment een kopie van al uw end-to-end versleutelde berichten en bijlagen downloaden.',
    conversationMessengerEncryptedImportDemoMediaTip: 'Laat Media aangevinkt, anders bevat uw boek geen foto’s.',
    conversationMessengerEncryptedImportDemoFileNotice: 'Het voorbereiden van het bestand kan enkele minuten duren.',
    conversationMessengerEncryptedImportDemoDownloadFile: 'Bestand downloaden',
    conversationMessengerEncryptedImportDemoReadyHint: 'Zet de volledige .zip hieronder neer zonder hem te openen. Daarna kies u het gesprek.',
    conversationMessengerImportEncryptedCta: 'Messenger.com openen om te exporteren',
    conversationMessengerImportClassicStep1: 'Tik op <b>Export maken</b>, kies uw <b>Facebook</b>-profiel, dan <b>Exporteren naar mijn apparaat</b>.',
    conversationMessengerImportClassicStep2: 'Tip voor een snellere export: <b>Alles wissen</b>, vink alleen <b>Berichten</b> aan. Kies <b>JSON</b>-formaat en <b>Lage</b> mediakwaliteit.',
    conversationMessengerImportClassicStep3: 'Tik op <b>Export starten</b>, wacht op de e-mail (10 min tot 24 u), download de <b>.zip</b> en plaats hem hieronder <b>zonder het uit te pakken</b>: u kiest het gesprek <b>daarna</b>.',
    conversationMessengerImportClassicAlert: 'Gesprek ontbreekt? Schakel over naar <b>Na 2023</b>. <b>JSON</b>-formaat verplicht (niet HTML). Tip: alleen <b>Berichten</b> exporteren is sneller, maar niet verplicht.',
    conversationMessengerImportEncryptedStep1: 'Open <b>Messenger.com</b> op een computer, meld u aan en klik linksonder op het <b>tandwiel</b>.',
    conversationMessengerImportEncryptedStep2: 'Ga naar <b>Privacy en veiligheid</b>, dan <b>End-to-end versleutelde chats</b>, dan <b>Berichtenopslag</b>.',
    conversationMessengerImportEncryptedStep3: 'Klik op <b>Gegevens van de berichtenopslag downloaden</b>. Laat <b>Media</b> aangevinkt en kies de periode <b>All time</b>.',
    conversationMessengerImportEncryptedStep4: 'Klik op <b>Bestand downloaden</b> en zet de <b>.zip</b> hieronder neer <b>zonder hem te openen</b>: u kiest het gesprek <b>na</b> het uploaden.',
    conversationMessengerImportEncryptedAlert: 'Laat <b>Media</b> aangevinkt, anders bevat uw boek geen foto’s. Gesprek ontbreekt? Ga naar <b>Voor 2023</b>.',
    conversationMessengerImportClassicDetailTitle: 'Export voor 2023: gedetailleerde gids',
    conversationMessengerImportClassicDetailIntro: 'Volg elke stap met de screenshots hieronder. De knop hierboven opent direct de exportpagina.',
    conversationMessengerImportClassicDetailSkipApp: 'Ik heb de pagina via de knop geopend: ga verder bij stap 5',
    conversationMessengerImportClassicDetailStep1: 'Open de <b>Messenger</b>-app en ga via de drie puntjes naar <b>Instellingen</b>.',
    conversationMessengerImportClassicDetailStep2: 'Tik op het <b>tandwiel</b>.',
    conversationMessengerImportClassicDetailStep3: 'Selecteer <b>Accountcentrum</b>.',
    conversationMessengerImportClassicDetailStep4: 'Tik op <b>Uw informatie en machtigingen</b>.',
    conversationMessengerImportClassicDetailStep5: 'Kies <b>Uw informatie downloaden</b>.',
    conversationMessengerImportClassicDetailStep6: 'Ga naar <b>Informatie downloaden of overdragen</b>. Als u de knop hierboven hebt gebruikt, bent u al op deze pagina.',
    conversationMessengerImportClassicDetailStep7: 'Selecteer <b>Facebook</b>. Deze stap verschijnt mogelijk niet op sommige accounts.',
    conversationMessengerImportClassicDetailStep8: 'Kies <b>Sommige van uw informatie</b>.',
    conversationMessengerImportClassicDetailStep9: 'Vink alleen <b>Berichten</b> aan, tik dan op <b>Volgende</b>.',
    conversationMessengerImportClassicDetailStep10: 'Tik op <b>Downloaden naar apparaat</b>.',
    conversationMessengerImportClassicDetailStep11: 'Kies de gewenste periode, het formaat <b>JSON</b> en een <b>lage</b> kwaliteit. Uw archief is klaar binnen <b>10 minuten tot 24 uur</b>: u ontvangt een e-mail.',
    conversationMessengerImportClassicDetailStep12: 'Download het volledige <b>.zip</b>-bestand naar uw apparaat en zet het hieronder neer <b>zonder het te openen</b>. Alleen het gesprek dat u daarna kiest, wordt gebruikt voor uw boek.',
    conversationMessengerImportEncryptedDetailTitle: 'Export na 2023: gedetailleerde gids',
    conversationMessengerImportEncryptedDetailIntro: 'Volg elke stap met de screenshots hieronder. U kunt ook de knop hierboven gebruiken om Messenger.com te openen en bij stap 2 te beginnen.',
    conversationMessengerImportEncryptedDetailSkipApp: 'Ik ben al op Messenger.com: ga verder bij stap 2',
    conversationMessengerImportEncryptedDetailStep1: 'Open op een computer <b>Messenger.com</b> en klik linksonder op uw profielfoto.',
    conversationMessengerImportEncryptedDetailStep2: 'Klik op <b>Privacy en veiligheid</b>.',
    conversationMessengerImportEncryptedDetailStep3: 'Klik op <b>End-to-end versleutelde chats</b>.',
    conversationMessengerImportEncryptedDetailStep4: 'Klik op <b>Beveiligde opslag</b>.',
    conversationMessengerImportEncryptedDetailStep5: 'Klik op <b>Gegevens uit beveiligde opslag downloaden</b>.',
    conversationMessengerImportEncryptedDetailStep6: 'Klik op <b>Bestand downloaden</b>.',
    conversationMessengerImportEncryptedDetailStep7: 'Voer uw Facebook-wachtwoord in en klik op <b>Bevestigen</b>.',
    conversationMessengerImportEncryptedDetailStep8: 'Klik op <b>Downloaden</b>. Het voorbereiden van het bestand kan enkele minuten duren.',
    conversationMessengerImportEncryptedDetailStep9: 'Download het volledige <b>.zip</b>-bestand naar uw computer en zet het hieronder neer <b>zonder het te openen</b>. Alleen het gesprek dat u daarna kiest, wordt gebruikt voor uw boek.',
    conversationMessengerImportMissingTip: 'Chat niet in de lijst? Ga terug en probeer de export <b>Na 2023</b>.',
    conversationMessengerImportEmptyTitle: 'Geen gesprek gevonden in dit archief',

    conversationSmsImportTagline: 'Geen bestand hier uploaden: alles gebeurt via onze software of app.',
    conversationSmsImportIntro: 'Geen bestandsupload op deze pagina. Alles gebeurt via onze software (iPhone) of onze app (Android). Kies uw setup:',
    conversationSmsImportContext: 'Onze Android-app staat <b>niet in Google Play</b>: SMS-toegang is daar beperkt. Om de app te openen vragen Android en Play Protect om een bevestiging.',
    conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
    conversationSmsImportPlatformIphonePc: 'iPhone + PC',
    conversationSmsImportPlatformAndroid: 'Android',
    conversationSmsImportMacCta: 'Mac-software downloaden',
    conversationSmsImportPcCta: 'PC-software downloaden',
    conversationSmsImportAndroidCta: 'Android-app downloaden',
    conversationSmsImportMacStep1: 'Download de Mac-software.',
    conversationSmsImportMacStep2: 'Installeer hem en <b>laat uw begeleiden</b>: de software toont u de volgende stappen.',
    conversationSmsImportMacStep3: 'Kies het <b>gesprek</b> voor uw account en blijf op het scherm tot de overdracht klaar is.',
    conversationSmsImportMacStep4: 'Installeer de software hieronder, geef <b>volledige schijftoegang</b> in Systeeminstellingen → Privacy, kies dan het gesprek voor uw account.',
    conversationSmsImportMacHelp: 'Als de software geen back-up vindt: Systeeminstellingen → Privacy en beveiliging → <b>Volledige schijftoegang</b> → voeg MonLivreSMS toe (ontgrendel het hangslot linksonder).',
    conversationSmsImportMacAlert: 'Geen upload hier: de overdracht start vanuit de software, die u op het scherm begeleidt.',
    conversationSmsImportPcStep1: 'Download de PC-software.',
    conversationSmsImportPcHelp: 'Controleer in iTunes dat <b>Lokale back-up coderen</b> uit staat voordat u op <b>Back-up nu</b> klikt. Visuele hulp hierboven.',
    conversationSmsImportHelpToggle: 'Meer gedetailleerde hulp nodig?',
    conversationSmsImportPcStep2: 'Installeer hem en <b>laat uw begeleiden</b>: de software toont u de volgende stappen.',
    conversationSmsImportPcStep3: 'Kies het <b>gesprek</b> voor uw account en blijf op het scherm tot de overdracht klaar is.',
    conversationSmsImportPcStep4: 'Installeer de software hieronder, start hem (sta toe bij Windows-waarschuwing), kies dan het gesprek voor uw account.',
    conversationSmsImportPcAlert: 'Geen upload hier: de overdracht start vanuit de software, die u op het scherm begeleidt.',
    conversationSmsImportAndroidStep1: 'Download op uw Android onze <b>app buiten de store</b> hieronder: SMS-toegang is niet toegestaan in Google Play.',
    conversationSmsImportAndroidStep2: 'Open het gedownloade bestand. Als Android de installatie niet toestaat, tik op <b>Instellingen</b>, zet <b>Toestaan vanaf deze bron</b> aan en ga terug.',
    conversationSmsImportAndroidStep3: 'Als <b>Play Protect</b> verschijnt, tik op <b>Meer details</b> en daarna op <b>Toch installeren</b>. Tik daarna op <b>Installeren</b> en op <b>Openen</b>.',
    conversationSmsImportAndroidStep4: 'Sta in de app toegang tot <b>sms</b> en <b>contacten</b> toe.',
    conversationSmsImportAndroidStep5: 'Kies het <b>gesprek</b> en bevestig. Blijf op het scherm tot de overdracht klaar is: de berichten gaan rechtstreeks naar uw account.',
    conversationSmsImportAndroidAlert: 'Geen bestand hier neerzetten. Blijf op het overdrachtsscherm in de app zodat alle foto\'s worden meegenomen.',
    conversationSmsImportFooter: 'Overdracht klaar? Personaliseer uw boek op deze site: de app stuurt u automatisch door.',
	conversationSmsImportAndroidDetailIntro: 'Volg elke stap op uw Android-telefoon. De app staat <b>niet in Google Play</b>. Android en daarna Play Protect vragen om een bevestiging voordat de app opent: dat hoort erbij.',
	conversationSmsImportAndroidDetailSkipApp: 'Ik heb de app al gedownload: ga verder bij stap 2',
	conversationSmsImportAndroidDetailStep1: 'Download onze SMS-export-app buiten Google Play (knop hieronder): SMS-toegang is niet toegestaan in de Play Store.',
	conversationSmsImportAndroidDetailStep2: 'Tik na het downloaden op <b>Openen</b>.',
	conversationSmsImportAndroidDetailStep3: 'Tik op <b>Instellingen</b> om installatie toe te staan.',
	conversationSmsImportAndroidDetailStep4: 'Zet <b>Toestaan vanaf deze bron</b> aan en ga terug naar het installatiescherm.',
	conversationSmsImportAndroidDetailStep5: 'Als <b>Play Protect</b> verschijnt, tik op <b>Meer details</b> en daarna op <b>Toch installeren</b>. Installeer de app, open hem en sta toegang tot sms en contacten toe.',
	conversationSmsImportAndroidDetailStep6: 'Selecteer het gewenste <b>gesprek</b>.',
	conversationSmsImportAndroidDetailStep7: 'Bevestig en valideer: blijf op het overdrachtsscherm tot het einde zodat alle foto\'s worden meegenomen. U wordt automatisch doorgestuurd om uw boek te personaliseren.',
	conversationSmsImportAndroidDetailTitle: 'SMS-export Android: gedetailleerde gids',
	conversationSmsImportMacDetailIntro: 'Download de software en laat u op het scherm begeleiden. De screenshots hieronder helpen vooral bij de installatie.',
	conversationSmsImportMacDetailSkipSoftware: 'Ik heb de software al gedownload: ga verder bij stap 8',
	conversationSmsImportMacDetailStep1: 'Sluit uw iPhone met een USB-kabel aan op uw Mac.',
	conversationSmsImportMacDetailStep10: 'Open <b>Systeeminstellingen</b> → <b>Privacy en beveiliging</b>.',
	conversationSmsImportMacDetailStep11: 'Scroll naar beneden en klik op <b>Toch openen</b>.',
	conversationSmsImportMacDetailStep12: 'Klik in de beveiligingsprompt op <b>Sta toe</b>.',
	conversationSmsImportMacDetailStep13: 'Klik op <b>Openen</b>.',
	conversationSmsImportMacDetailStep14: 'Klik op <b>Doorgaan</b>.',
	conversationSmsImportMacDetailStep15: 'Klik opnieuw op <b>Doorgaan</b>.',
	conversationSmsImportMacDetailStep16: 'Klik op <b>Installeren</b>.',
	conversationSmsImportMacDetailStep17: 'Klik in de beveiligingsprompt opnieuw op <b>Sta toe</b>.',
	conversationSmsImportMacDetailStep18: 'Klik op <b>Sluiten</b> om de assistent te verlaten.',
	conversationSmsImportMacDetailStep19: 'Open <b>Finder</b> → <b>Programma\'s</b> en start <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'Voor foto\'s in het boek: open <b>Berichten</b>, selecteer het gesprek en tik op de <b>contactnaam</b>.',
	conversationSmsImportMacDetailStep20: 'Klik op het <b>Apple-menu</b> linksboven → <b>Systeeminstellingen</b>.',
	conversationSmsImportMacDetailStep21: 'Open <b>Privacy en beveiliging</b> → <b>Volledige schijftoegang</b>.',
	conversationSmsImportMacDetailStep22: 'Sleep het MonLivreSMS-pictogram naar de lijst (lang indrukken) en vink <b>Volledige schijftoegang</b> aan.',
	conversationSmsImportMacDetailStep23: 'Klik op <b>Openen</b> om te bevestigen.',
	conversationSmsImportMacDetailStep24: 'Klik opnieuw op <b>Openen</b> als een tweede bevestiging verschijnt.',
	conversationSmsImportMacDetailStep25: 'Kies het <b>gesprek</b> om te exporteren: teksten en foto\'s worden naar uw account gestuurd. Blijf op het overdrachtsscherm tot het einde, met stabiele internetverbinding.',
	conversationSmsImportMacDetailStep3: 'Scroll helemaal naar beneden op het contactkaartje.',
	conversationSmsImportMacDetailStep4: 'Tik op <b>Downloaden</b> om alle iCloud-foto\'s naar de iPhone te importeren.',
	conversationSmsImportMacDetailStep5: 'Open <b>Finder</b>, selecteer uw iPhone in de zijbalk, vink <b>Codeer lokale back-up</b> uit en schakel <b>Back-up alle gegevens op deze Mac</b> in.',
	conversationSmsImportMacDetailStep6: 'Klik op <b>Back-up nu</b> en wacht tot de back-up klaar is.',
	conversationSmsImportMacDetailStep7: 'Download de MonLivreSMS-software voor Mac (knop hieronder op deze pagina).',
	conversationSmsImportMacDetailStep8: 'Dubbelklik op de gedownloade map <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep9: 'Klik op <b>OK</b> om de installatie te starten.',
	conversationSmsImportMacDetailTitle: 'SMS-export iPhone + Mac: gedetailleerde gids',
	conversationSmsImportPcDetailIntro: 'Download de software en laat u op het scherm begeleiden. De screenshots hieronder helpen vooral bij de installatie.',
	conversationSmsImportPcDetailSkipSoftware: 'Ik heb de software al gedownload: ga verder bij stap 3',
	conversationSmsImportPcDetailStep1: 'Sluit uw iPhone met een USB-kabel aan op uw PC.',
	conversationSmsImportPcDetailStep2: 'Download de MonLivreSMS-software voor PC (knop hieronder op deze pagina).',
	conversationSmsImportPcDetailStep3: 'Installeer <link>iTunes</link> als u dat nog niet heeft.',
	conversationSmsImportPcDetailStep4: 'Start iTunes.',
	conversationSmsImportPcDetailStep5: 'Meld u aan met uw <b>Apple-ID</b> en bevestig op de iPhone indien gevraagd.',
	conversationSmsImportPcDetailStep6: 'Zodra de iPhone wordt herkend, klik op <b>Doorgaan</b>.',
	conversationSmsImportPcDetailStep7: 'Onder <b>Overzicht</b> vink <b>Codeer lokale back-up</b> uit en klik op <b>Back-up nu</b> (op deze computer, niet iCloud).',
	conversationSmsImportPcDetailStep8: 'Als de back-up klaar is, open de map MonLivreSMS. Bij een Windows-waarschuwing klik op <b>Meer info</b> en dan <b>Toch uitvoeren</b>. Kies daarna het gesprek voor uw account.',
	conversationSmsImportPcDetailTitle: 'SMS-export iPhone + PC: gedetailleerde gids',
    /* --- sync 2026-06-29 --- */
    autocompleteSearch: 'Typ om te zoeken…',
    cmsAdminListHint: "Pagina's, panelen en vertalingen bewerken. Vlaggen tonen de vertaalstatus per taal.",
    cmsContentDuplicateSuccess: 'CMS-inhoud gedupliceerd!',
    cmsPageAdd: 'Pagina toevoegen',
    code: 'Code',
    configAdminHint: 'App-instellingen, affiliaties, achtergrondprocessen en ruwe configuratiesleutels.',
    console: 'Console',
    conversationAdminListHint: 'Blader, filter en beheer alle klantgesprekken. Gebruik statustabs per funnelstap.',
    conversationBackToList: 'Terug naar mijn gesprekken',
    conversationCreationDate: 'Aanmaakdatum',
    conversationCustomImportUpload: 'Gegenereerd bestand importeren',
    conversationDownloadBackPreview: 'Terug naar boekvoorbeeld',
    conversationDownloadEyebrow: 'Uw boek is klaar',
    conversationDownloadHint: 'Download uw PDF en bewaar een digitale kopie van uw gesprek.',
    conversationDownloadLoading: 'Bestanden worden voorbereid…',
    conversationFlags: 'Vlaggen',
    conversationHighlightShareImageButton: 'Afbeelding versturen',
    conversationHighlightsEmpty: 'Voor cijfers heeft dit gesprek nog een paar berichten meer nodig.',
    conversationHighlightsLoading: 'Uw cijfers worden verzameld.',
    conversationImages: 'Afbeeldingen',
    conversationMedias: 'Media',
    conversationMergeSelect: 'Dit gesprek selecteren',
    conversationMergeUnselect: 'Selectie opheffen',
    conversationOrders: 'Bestellingen',
    conversationPreviewCoverEditButton: 'Omslag bewerken',
    conversationPreviewCoverOpenLabel: 'Boek openen',
    conversationPreviewCustomizeClose: 'Personalisatie sluiten',
    conversationPreviewCustomizeDone: 'Personalisatie afronden',
    conversationPreviewEditionBelowHint: 'Kies uw editie hieronder',
    conversationPreviewEditionScrollLabel: 'Naar editiesectie',
    conversationPrinterMode: 'Printermodus',
    copiedToClipboard: 'Gekopieerd!',
    country: 'Land',
    dateStatus: 'Statusdatum',
    dateValidation: 'Validatiedatum',
    dates: 'Datums',
    identifier: 'Identificatie',
    loadMore: 'Meer laden…',
    orderAdminListHint: 'Bestellingen per status volgen en verwerken. Filter op land, product of validatiedatum.',
    orderConfirmationGuestTitle: 'Blijf op de hoogte',
    orderConfirmationHomeCta: 'Terug naar home',
    orderConfirmationNextStepsTitle: 'Wat gebeurt er nu?',
    orderConfirmationOrderNumber: 'Bestelling nr. {code}',
    orderConfirmationPaymentWaitingHint: 'Dit duurt meestal maar een paar seconden.',
    orderConfirmationStepEmail: 'Bevestiging per e-mail',
    orderConfirmationStepEmailDesc: 'Een samenvatting is verstuurd naar {email}',
    orderConfirmationStepEmailDescNoEmail: 'U ontvangt een samenvatting per e-mail',
    orderConfirmationStepPreparation: 'Uw boek wordt voorbereid',
    orderConfirmationStepPreparationDesc: 'We drukken en binden uw boek met zorg',
    orderConfirmationStepShipping: 'Verzending',
    orderConfirmationStepShippingDesc: 'U ontvangt een e-mail zodra uw pakket verzonden is',
    orderConfirmationSummaryTitle: 'Uw bestelling',
    orderConfirmationViewOrderCta: 'Mijn bestelling volgen',
    orderFlags: 'Vlaggen',
    orderMassExportInvoiceDetails: 'Factuurdetails exporteren',
    orderMassSendEmail: 'E-mail versturen',
    orderMassUpdateStatus: 'Status bijwerken',
    orderNote: 'Notitie',
    orderNoteAdmin: 'Interne notitie (admin)',
    orderNoteAdminAdd: 'Notitie toevoegen',
    orderNoteAdminEmpty: 'Geen interne notities voor deze bestelling.',
    orderNoteAdminPlaceholder: 'Interne notitie alleen zichtbaar voor het team (verzending, support…)',
    orderPaymentMethod: 'Betaalmethode',
    orderPublicAccess: 'Openbare toegang',
    orderSendStatusNotificationEmail: 'Notificatie-e-mail versturen',
    orderViewShort: 'Bestelling',
    ordersEditSuccess: 'Bestellingen bijgewerkt!',
    product: 'Product',
    productAdd: 'Product toevoegen',
    productAdminListHint: 'Catalogus, prijzen en beschikbaarheid in de shop beheren.',
    seoOrderViewTitle: 'Bestelling nr. {code}',
    shippingAdd: 'Methode toevoegen',
    shippingAdminListHint: 'Vervoerders, landen en tariefregels voor leveringen configureren.',
    shippingMethod: 'Verzendmethode',
    tableDownloadNoElementError: 'Niets om te downloaden!',
    tablePageSize: 'Per pagina',
    taskAddTitle: 'Taak toevoegen',
    taskAssignSelf: 'Aan mezelf toewijzen',
    taskCountdownDate: 'Herinneringsdatum',
    userAccountNote: 'Gebruikersaccountnotitie',
    userAdminListHint: 'Zoek accounts, bekijk activiteit en open een profiel of bestellingen van een gebruiker.',
    vatExempt: 'BTW-VRIJ',
    voucherAdd: 'Voucher toevoegen',
    voucherAdminListHint: 'Promocodes, voorwaarden en gebruikslimieten aanmaken en beheren.',

	offerErrorRequired: 'Vul de verplichte velden in.',
	offerErrorEmail: 'Controleer uw e-mailadres.',
	offerErrorGiftEmail: 'Controleer het e-mailadres van degene die het cadeau krijgt.',
	offerErrorGiftSameEmail: 'Het e-mailadres van degene die het cadeau krijgt, moet anders zijn dan het uwe.',
	offerErrorGeneric: 'Oeps, dat ging mis. Probeer het zo meteen opnieuw.',
	offerStepWhoEyebrow: 'Daar gaan we',
	offerStepWhoTitle: 'Wie gaat het boek maken?',
	offerStepWhoHint: 'U stelt het zelf samen, voor uzelf of om cadeau te doen. Een cadeaubon is voor als de ander het maakt.',
	offerWhoSelf: 'Ik ga het maken',
	offerWhoSelfHint: 'Voor mezelf, of om te geven zodra het gedrukt is',
	offerWhoGift: 'Ik geef een cadeaubon',
	offerWhoGiftHint: 'De persoon krijgt een link en maakt zelf het boek',
	offerStepOccasionEyebrow: 'De gelegenheid',
	offerStepOccasionHint: 'Het moment waaraan u denkt.',
	offerStepGiftEyebrow: 'Uw cadeau',
	offerStepGiftTitle: 'Aan wie geeft u het cadeau?',
	offerStepGiftHint: 'Wij sturen het cadeau per e-mail, met een link om het boek te maken. Niets printen, niets inpakken.',
	offerGiftName: 'Voornaam van de ontvanger',
	offerGiftEmail: 'E-mailadres van de ontvanger',
	offerGiftEmailHelp: 'Het cadeau komt direct na de betaling in deze mailbox aan.',
	offerGiftFromName: 'Uw voornaam',
	offerGiftFromNameHelp: 'Zo weet de ontvanger van wie het cadeau komt.',
	offerGiftMessage: 'Een persoonlijk berichtje (optioneel)',
	offerGiftMessagePlaceholder: 'Zodat deze berichten altijd dicht bij je blijven.',
	offerContinue: 'Doorgaan',
	offerStepMessengerEyebrow: 'Uw berichten',
	offerStepMessengerTitleGift: 'Waar staan de berichten voor het boek van {name}?',
	offerStepMessengerTitle: 'Waar staan uw mooiste berichten?',
	offerStepMessengerHint: 'Kies er één. U kunt dit later nog wijzigen.',
	offerStepMessengerHintGift: 'Uw gesprek met {name}, of dat van {name} met een dierbare. Twijfelt u over de app? {name} kan ook een andere kiezen.',
	offerStepEmailEyebrow: 'Bijna klaar',
	offerStepEmailTitle: 'Uw account',
	offerStepEmailHintGift: 'Google, Apple of uw e-mail. We sturen een bevestiging, daarna betaalt u de cadeaubon.',
	offerStepEmailHint: 'Google, Apple of uw e-mail. We sturen een bevestiging, daarna importeert u het gesprek.',
	offerStepEmailHintPay: 'Google, Apple of uw e-mail. We sturen een bevestiging, daarna betaalt u het boek.',
	offerEmailLabel: 'E-mailadres',
	offerEmailPlaceholder: 'naam@voorbeeld.nl',
	offerEmailSubmit: 'Verder naar betalen',
	offerEmailSubmitAccount: 'Account aanmaken',
	offerEmailPrivacy: 'Alleen uw boek. Kijk ook even in uw spammap.',
	offerStepSentEyebrow: 'Fijn u weer te zien',
	offerStepSentTitle: 'U heeft al een account',
	offerStepSentCodeHint: 'We hebben zojuist een code van 6 cijfers naar {email} gestuurd. Vul deze hier in: uw bestelling staat klaar om te betalen. Kijk ook even in uw spammap.',
	offerStepSentCodeHintAccount: 'We hebben zojuist een code van 6 cijfers naar {email} gestuurd. Vul deze hier in om uw account te openen en het boek te beginnen. Kijk ook even in uw spammap.',
	offerStepPayEyebrow: 'Laatste stap',
	offerStepPayTitleGift: 'Het boek voor {name}',
	offerStepPayTitle: 'Uw gedrukte boek',
	offerLoggedAs: 'Ingelogd als {email}',
	offerSwitchAccount: 'Bent u dit niet?',
	offerTrustReviews: 'Meer dan {count} reviews op Trustpilot',
	offerTrustGuarantee: 'Niet goed, geld terug',
	offerTrustShipping: 'Gratis verzending',
	offerPageTitle: 'Uw berichtenboek',
	offerBack: 'Terug',
	offerItemName: 'Gedrukt boek om zelf samen te stellen',
	offerPayBenefitBook: 'Uw gedrukte boek, opgemaakt met uw berichten en foto\'s',
	offerPayBenefitBookGift: 'Een echt gedrukt boek, met berichten en foto\'s naar keuze',
	offerPayBenefitMedia: 'Ook spraakberichten en video\'s, om opnieuw te beleven via gedrukte QR-codes',
	offerPayBenefitCustom: 'Omslag, foto, titel, kleuren, voorwoord: alles is te personaliseren',
	offerPayBenefitPdf: 'De pdf krijgt u gratis bij het boek',
	offerPayBenefitShipping: 'Gratis verzending',
	offerPayTotal: 'Totaal',
	offerPayNextGift: 'Direct na de betaling ontvangt {name} uw cadeau per e-mail.',
	offerPayNextSelf: 'Meteen na de betaling importeert u het gesprek. Een paar minuten.',
	offerPayDreamSelf: 'De berichten die u steeds opnieuw leest op uw telefoon, binnenkort in uw handen. Voor altijd.',
	offerPayDreamGift: 'Op de dag dat {name} het opent, komen al deze berichten tot leven.',
	offerPayButton: '{price} betalen',
	offerPaySecure: 'Veilig betalen. Geen abonnement.',
	offerConfirmStepsTitle: 'Zo werkt het',
	offerConfirmGiftStep1: '{name} opent de e-mail en klikt op de link',
	offerConfirmGiftStep2: '{name} importeert het gesprek in een paar minuten',
	offerConfirmGiftStep3: 'Wij drukken het boek en bezorgen het',
	offerConfirmGiftTitle: 'Verstuurd naar {name}!',
	offerConfirmGiftLead: '{name} heeft uw cadeau zojuist ontvangen op {email}, met een link om het boek te maken. Het is al betaald, inclusief verzending.',
	offerConfirmViewOrder: 'Mijn bestelling bekijken',
	offerConfirmGiftNote: 'Niet ontvangen? Vraag de ontvanger om in de spammap te kijken, of stuur ons een bericht.',
	offerConfirmStep1: 'Exporteer uw gesprek uit {messenger}',
	offerConfirmStep1Generic: 'Exporteer uw gesprek uit uw berichtenapp',
	offerConfirmStep2: 'Importeer het hier: wij verzorgen de volledige opmaak',
	offerConfirmStep3: 'Keur uw boek goed: wij drukken het en sturen het naar u op',
	offerConfirmTitle: 'Gelukt, uw boek is betaald!',
	offerConfirmLead: 'Nog één ding: uw {messenger}-gesprek importeren. Wij begeleiden u stap voor stap, het duurt maar een paar minuten.',
	offerConfirmLeadGeneric: 'Nog één ding: uw gesprek importeren. Wij begeleiden u stap voor stap, het duurt maar een paar minuten.',
	offerConfirmCta: 'Mijn {messenger}-gesprek importeren',
	offerConfirmCtaGeneric: 'Mijn gesprek importeren',
	offerConfirmChangeMessenger: 'Mijn berichten staan in een andere app',
	offerConfirmEmailNote: 'Uw betaalbewijs en inloglink zijn naar {email} gestuurd.',
	userMagicTitle: 'Inloggen',
	userMagicWorking: 'U wordt ingelogd…',
	userMagicExpired: 'Deze link is verlopen. Vraag met één klik een nieuwe aan.',
	userMagicInvalid: 'Deze link is niet meer geldig. Vraag met één klik een nieuwe aan.',
	userMagicSent: 'Als er een account met dit adres bestaat, is er een nieuwe link onderweg. Kijk ook even in uw spammap.',
	userMagicEmailLabel: 'Uw e-mailadres',
	userMagicSend: 'Nieuwe link ontvangen',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Inbegrepen',
	conversationPreviewCollectionPrepaidNote: '{count} delen · {paid} al betaald',
	conversationPreviewBookCreditBannerBestof: 'Uw boek is al betaald: de Best Of is inbegrepen. Liever de volledige collectie? Dan betaalt u alleen het verschil.',
	conversationPreviewBookCreditBanner: 'Uw boek is al betaald, inclusief standaardverzending. Maak het helemaal van u en rond daarna uw bestelling af.',
	conversationOrderButtonBookCreditRemaining: 'Mijn boek afronden · nog {price}',
	conversationOrderButtonBookCreditIncluded: 'Mijn boek afronden · Inbegrepen',
	conversationPreviewBookCreditOrderHint: '{credit} al betaald · catalogusprijs {fullPrice}',
	conversationOrderButtonBookCredit: 'Mijn boek afronden',
	conversationPreviewStickyBookCredit: 'Boek al betaald',
	paymentMethodBookCreditHint: 'Uw boek is al betaald',
	cartTotalsBookCredit: 'Boek al betaald',
	paymentMethodBookcredit: 'Vooraf betaald boek',
  },
};
